const viVN = {
    "translation": {
        "admin_console": {
            "title": "Bảng quản trị",
            "admin_user": "Quản trị",
            "system_app": "Hệ thống",
            "menu": {
                "profile": "Hồ sơ",
                "language": "Ngôn ngữ",
                "appearance": {
                    "label": "Giao diện",
                    "light": "Chế độ sáng",
                    "dark": "Chế độ tối",
                    "system": "Đồng bộ theo hệ thống"
                },
                "sign_out": "Đăng xuất"
            },
            "general": {
                "placeholder": "Giá trị mẫu",
                "submit": "Gửi",
                "skip": "Bỏ qua",
                "next": "Tiếp",
                "back": "Quay lại",
                "retry": "Thử lại",
                "done": "Xong",
                "search": "Tìm kiếm",
                "search_placeholder": "Tìm kiếm",
                "clear_result": "Xoá kết quả",
                "today": "Hôm nay",
                "clear": "Xoá",
                "save": "Lưu",
                "save_changes": "Lưu thay đổi",
                "saved": "Đã lưu",
                "discard": "Bỏ thay đổi",
                "download": "Tải xuống",
                "loading": "Đang tải...",
                "redirecting": "Đang chuyển hướng...",
                "add": "Thêm",
                "added": "Đã thêm",
                "cancel": "Huỷ",
                "confirm": "Xác nhận",
                "check_out": "Xem thử",
                "create": "Tạo",
                "set_up": "Thiết lập",
                "customize": "Tuỳ chỉnh",
                "enable": "Bật",
                "reminder": "Nhắc nhở",
                "edit": "Sửa",
                "delete": "Xoá",
                "deleted": "Đã xoá",
                "activate": "Kích hoạt",
                "deactivate": "Ngừng kích hoạt",
                "more_options": "THÊM TUỲ CHỌN",
                "close": "Đóng",
                "copy": "Sao chép",
                "copying": "Đang sao chép",
                "copied": "Đã sao chép",
                "required": "Bắt buộc",
                "add_another": "Thêm cái khác",
                "create_another": "Tạo cái khác",
                "deletion_confirmation": "Bạn có chắc muốn xoá {{title}} này không?",
                "settings_nav": "Cài đặt",
                "unsaved_changes_warning": "Bạn có thay đổi chưa lưu. Bạn có chắc muốn rời trang này không?",
                "leave_page": "Rời trang",
                "stay_on_page": "Ở lại trang",
                "type_to_search": "Gõ để tìm",
                "got_it": "Đã hiểu",
                "continue": "Tiếp tục",
                "page_info": "{{min, number}}-{{max, number}} trên {{total, number}}",
                "learn_more": "Tìm hiểu thêm",
                "tab_error": "{{count, number}} lỗi",
                "tab_error_other": "{{count, number}} lỗi",
                "skip_for_now": "Tạm bỏ qua",
                "remove": "Xoá",
                "visit": "Truy cập",
                "join": "Tham gia",
                "try_now": "Thử ngay",
                "multiple_form_field": "(Nhiều)",
                "demo": "Demo",
                "unnamed": "Chưa đặt tên",
                "view": "Xem",
                "open": "Mở",
                "hide": "Ẩn",
                "unknown_error": "Lỗi không xác định, vui lòng thử lại sau.",
                "select": "Chọn",
                "contact_us_action": "Liên hệ chúng tôi",
                "description": "Mô tả",
                "name": "Tên",
                "add_field": "Thêm {{field}}",
                "create_field": "Tạo {{field}}",
                "edit_field": "Sửa {{field}}",
                "delete_field": "Xoá {{field}}",
                "coming_soon": "Sắp có",
                "or": "Hoặc",
                "reset": "Đặt lại",
                "generate": "Tạo mới",
                "manage": "Quản lý",
                "live_preview": "Xem trực tiếp"
            },
            "errors": {
                "something_went_wrong": "Rất tiếc! Đã có lỗi xảy ra.",
                "page_not_found": "Không tìm thấy trang",
                "unknown_server_error": "Đã xảy ra lỗi máy chủ không xác định",
                "empty": "Không có dữ liệu",
                "missing_total_number": "Không tìm thấy Total-Number trong header phản hồi",
                "invalid_uri_format": "Định dạng URI không hợp lệ",
                "invalid_origin_format": "Định dạng origin URI không hợp lệ",
                "invalid_json_format": "Định dạng JSON không hợp lệ",
                "invalid_parameters_format": "Định dạng tham số không hợp lệ",
                "invalid_regex": "Biểu thức chính quy không hợp lệ",
                "invalid_error_message_format": "Định dạng thông báo lỗi không hợp lệ.",
                "required_field_missing": "Vui lòng nhập {{field}}",
                "required_field_missing_plural": "Bạn phải nhập ít nhất một {{field}}",
                "more_details": "Chi tiết hơn",
                "username_pattern_error": "Tên đăng nhập chỉ được chứa chữ cái, chữ số hoặc dấu gạch dưới và không được bắt đầu bằng chữ số.",
                "email_pattern_error": "Địa chỉ email không hợp lệ.",
                "phone_pattern_error": "Số điện thoại không hợp lệ.",
                "insecure_contexts": "Ngữ cảnh không an toàn (không phải HTTPS) không được hỗ trợ.",
                "unexpected_error": "Đã xảy ra lỗi không mong muốn.",
                "not_found": "404 không tìm thấy",
                "create_internal_role_violation": "Bạn đang tạo một vai trò nội bộ mới, điều bị Logto cấm. Hãy thử tên khác không bắt đầu bằng \"#internal:\".",
                "should_be_an_integer": "Phải là số nguyên.",
                "number_should_be_between_inclusive": "Số phải nằm trong khoảng {{min}} đến {{max}} (bao gồm cả hai đầu)."
            },
            "tab_sections": {
                "overview": "Tổng quan",
                "authentication": "Xác thực",
                "authorization": "Phân quyền",
                "users": "Người dùng",
                "developer": "Nhà phát triển",
                "tenant": "Tenant"
            },
            "tabs": {
                "get_started": "Bắt đầu",
                "dashboard": "Bảng điều khiển",
                "applications": "Ứng dụng",
                "api_resources": "Tài nguyên API",
                "sign_in_experience": "Đăng nhập & tài khoản",
                "connectors": "Trình kết nối",
                "enterprise_sso": "SSO doanh nghiệp",
                "security": "Bảo mật",
                "webhooks": "Webhook",
                "organizations": "Tổ chức",
                "users": "Quản lý người dùng",
                "audit_logs": "Nhật ký kiểm toán",
                "roles": "Vai trò",
                "docs": "Tài liệu",
                "tenant_settings": "Cài đặt",
                "mfa": "Xác thực đa yếu tố",
                "customize_jwt": "JWT tuỳ chỉnh",
                "signing_keys": "Khoá ký",
                "organization_template": "Mẫu tổ chức"
            },
            "applications": {
                "page_title": "Ứng dụng",
                "title": "Ứng dụng",
                "subtitle": "Tạo và quản lý ứng dụng để xác thực OIDC.",
                "subtitle_with_app_type": "Thiết lập xác thực Logto cho ứng dụng {{name}} của bạn",
                "create_device_flow_description": "Tạo ứng dụng native dùng OAuth 2.0 Device Authorization Grant cho thiết bị nhập liệu hạn chế hoặc ứng dụng không giao diện.",
                "create": "Tạo ứng dụng",
                "create_third_party": "Tạo ứng dụng bên thứ ba",
                "create_thrid_party_modal_title": "Tạo ứng dụng bên thứ ba ({{type}})",
                "application_name": "Tên ứng dụng",
                "application_name_placeholder": "Ứng dụng của tôi",
                "application_description": "Mô tả ứng dụng",
                "application_description_placeholder": "Nhập mô tả ứng dụng của bạn",
                "select_application_type": "Chọn loại ứng dụng",
                "no_application_type_selected": "Bạn chưa chọn loại ứng dụng nào",
                "application_created": "Tạo ứng dụng thành công.",
                "tab": {
                    "my_applications": "Ứng dụng của tôi",
                    "third_party_applications": "Ứng dụng bên thứ ba"
                },
                "app_id": "App ID",
                "type": {
                    "native": {
                        "title": "Ứng dụng Native",
                        "subtitle": "Ứng dụng chạy trong môi trường native",
                        "description": "Ví dụ: app iOS, app Android, app desktop, TV, CLI"
                    },
                    "spa": {
                        "title": "Ứng dụng một trang (SPA)",
                        "subtitle": "Ứng dụng chạy trong trình duyệt và cập nhật dữ liệu tại chỗ",
                        "description": "Ví dụ: app React DOM, app Vue"
                    },
                    "traditional": {
                        "title": "Web truyền thống",
                        "subtitle": "Ứng dụng dựng và cập nhật trang hoàn toàn bởi máy chủ web",
                        "description": "Ví dụ: Next.js, PHP"
                    },
                    "machine_to_machine": {
                        "title": "Máy-với-Máy (M2M)",
                        "subtitle": "Ứng dụng (thường là dịch vụ) giao tiếp trực tiếp với tài nguyên",
                        "description": "Ví dụ: dịch vụ backend"
                    },
                    "protected": {
                        "title": "Ứng dụng được bảo vệ",
                        "subtitle": "Ứng dụng được Logto bảo vệ",
                        "description": "N/A"
                    },
                    "saml": {
                        "title": "Ứng dụng SAML",
                        "subtitle": "Ứng dụng dùng làm trình kết nối SAML IdP",
                        "description": "Ví dụ: SAML"
                    },
                    "third_party": {
                        "title": "Ứng dụng bên thứ ba",
                        "subtitle": "Ứng dụng dùng làm trình kết nối IdP bên thứ ba",
                        "description": "Ví dụ: OIDC"
                    }
                },
                "authorization_flow": {
                    "title": "Luồng cấp quyền",
                    "tooltip": "Chọn luồng cấp quyền cho ứng dụng. Sau khi đặt sẽ không đổi được.",
                    "authorization_code": {
                        "title": "Authorization code",
                        "description": "Loại grant mặc định và phổ biến nhất. Người dùng được chuyển tới trang đăng nhập để cấp quyền trực tiếp."
                    },
                    "device_flow": {
                        "title": "Device flow",
                        "description": "Cho thiết bị nhập liệu hạn chế hoặc app không giao diện (ví dụ TV, CLI). Người dùng hoàn tất đăng nhập trên thiết bị khác bằng cách nhập mã thiết bị hoặc quét mã QR."
                    }
                },
                "placeholder_title": "Chọn loại ứng dụng để tiếp tục",
                "placeholder_description": "Logto dùng thực thể ứng dụng cho OIDC để hỗ trợ các việc như nhận diện ứng dụng, quản lý đăng nhập và tạo nhật ký kiểm toán.",
                "third_party_application_placeholder_description": "Dùng Logto làm nhà cung cấp danh tính để cấp quyền OAuth cho dịch vụ bên thứ ba. Kèm màn hình đồng thuận người dùng dựng sẵn để truy cập tài nguyên. <a>Tìm hiểu thêm</a>",
                "guide": {
                    "third_party": {
                        "title": "Tích hợp ứng dụng bên thứ ba",
                        "description": "Dùng Logto làm nhà cung cấp danh tính để cấp quyền OAuth cho dịch vụ bên thứ ba. Kèm màn hình đồng thuận người dùng dựng sẵn để truy cập tài nguyên an toàn. <a>Tìm hiểu thêm</a>"
                    }
                }
            },
            "application_details": {
                "page_title": "Chi tiết ứng dụng",
                "back_to_applications": "Quay lại danh sách ứng dụng",
                "check_guide": "Xem hướng dẫn",
                "settings": "Cài đặt",
                "settings_description": "“Ứng dụng” là một phần mềm hoặc dịch vụ đã đăng ký, có thể truy cập thông tin người dùng hoặc hành động thay cho người dùng. Ứng dụng giúp Logto nhận biết ai đang yêu cầu điều gì, đồng thời xử lý việc đăng nhập và cấp quyền. Hãy điền các trường bắt buộc để xác thực.",
                "integration": "Tích hợp",
                "integration_description": "Triển khai với các secure worker của Logto, chạy trên mạng biên của Cloudflare để đạt hiệu năng hàng đầu và không có độ trễ khởi động (0ms cold start) trên toàn cầu.",
                "service_configuration": "Cấu hình dịch vụ",
                "service_configuration_description": "Hoàn tất các cấu hình cần thiết trong dịch vụ của bạn.",
                "session": "Phiên",
                "endpoints_and_credentials": "Endpoint & Thông tin xác thực",
                "endpoints_and_credentials_description": "Dùng các endpoint và thông tin xác thực sau để thiết lập kết nối OIDC trong ứng dụng của bạn.",
                "refresh_token_settings": "Refresh token",
                "refresh_token_settings_description": "Quản lý các quy tắc refresh token cho ứng dụng này.",
                "machine_logs": "Nhật ký máy",
                "application_name": "Tên ứng dụng",
                "application_name_placeholder": "Ứng dụng của tôi",
                "description": "Mô tả",
                "description_placeholder": "Nhập mô tả ứng dụng của bạn",
                "config_endpoint": "Endpoint cấu hình OpenID provider",
                "issuer_endpoint": "Endpoint issuer",
                "jwks_uri": "JWKS URI",
                "authorization_endpoint": "Endpoint cấp quyền",
                "authorization_endpoint_tip": "Endpoint thực hiện xác thực và cấp quyền. Được dùng cho <a>Xác thực</a> OpenID Connect.",
                "show_endpoint_details": "Hiện chi tiết endpoint",
                "hide_endpoint_details": "Ẩn chi tiết endpoint",
                "logto_endpoint": "Endpoint Logto",
                "application_id": "App ID",
                "application_id_tip": "Định danh ứng dụng duy nhất, thường do Logto tạo ra. Nó cũng tương ứng với “<a>client_id</a>” trong OpenID Connect.",
                "application_secret": "App secret",
                "application_secret_other": "App secret",
                "redirect_uri": "Redirect URI",
                "redirect_uris": "Redirect URI",
                "redirect_uri_placeholder": "https://your.website.com/app",
                "redirect_uri_placeholder_native": "io.logto://callback",
                "redirect_uri_tip": "URI để chuyển hướng sau khi người dùng đăng nhập (dù thành công hay không). Xem <a>AuthRequest</a> của OpenID Connect để biết thêm.",
                "mixed_redirect_uri_warning": "Loại ứng dụng của bạn không tương thích với ít nhất một trong các redirect URI. Điều này không tuân theo thông lệ tốt nhất và chúng tôi khuyến nghị nên giữ các redirect URI nhất quán.",
                "wildcard_redirect_uri_warning": "Redirect URI dạng wildcard không phải chuẩn OIDC và có thể làm tăng bề mặt tấn công. Hãy dùng thận trọng và ưu tiên các redirect URI chính xác bất cứ khi nào có thể.",
                "post_sign_out_redirect_uri": "Redirect URI sau khi đăng xuất",
                "post_sign_out_redirect_uris": "Redirect URI sau khi đăng xuất",
                "post_sign_out_redirect_uri_placeholder": "https://your.website.com/home",
                "post_sign_out_redirect_uri_tip": "URI để chuyển hướng sau khi người dùng đăng xuất (không bắt buộc). Với một số loại ứng dụng, nó có thể không có tác dụng thực tế.",
                "cors_allowed_origins": "Origin được phép trong CORS",
                "cors_allowed_origins_placeholder": "https://your.website.com",
                "cors_allowed_origins_tip": "Mặc định, tất cả origin của các Redirect URI đều được cho phép. Thông thường không cần thao tác gì với trường này. Xem <a>tài liệu MDN</a> để biết chi tiết.",
                "token_endpoint": "Endpoint token",
                "user_info_endpoint": "Endpoint userinfo",
                "enable_admin_access": "Bật quyền truy cập quản trị",
                "enable_admin_access_label": "Bật hoặc tắt quyền truy cập Management API. Sau khi bật, bạn có thể dùng access token để gọi Management API thay mặt cho ứng dụng này.",
                "always_issue_refresh_token": "Luôn cấp refresh token",
                "always_issue_refresh_token_label": "Khi bật, Logto sẽ luôn cấp refresh token, bất kể yêu cầu xác thực có kèm `prompt=consent` hay không. Tuy nhiên, không nên dùng cách này trừ khi thực sự cần, vì nó không tương thích với OpenID Connect và có thể gây ra sự cố.",
                "refresh_token_ttl": "Thời gian sống của refresh token (TTL) tính theo ngày",
                "refresh_token_ttl_tip": "Khoảng thời gian một refresh token có thể được dùng để yêu cầu access token mới trước khi hết hạn và trở nên vô hiệu. Mỗi yêu cầu token sẽ gia hạn TTL của refresh token về giá trị này.",
                "rotate_refresh_token": "Xoay vòng refresh token",
                "rotate_refresh_token_label": "Khi bật, Logto sẽ cấp refresh token mới cho các yêu cầu token khi đã qua 70% thời gian sống (TTL) ban đầu hoặc khi thoả một số điều kiện nhất định. <a>Tìm hiểu thêm</a>",
                "rotate_refresh_token_label_for_public_clients": "Khi bật, Logto sẽ cấp refresh token mới cho mỗi yêu cầu token. <a>Tìm hiểu thêm</a>",
                "backchannel_logout": "Backchannel Logout",
                "backchannel_logout_description": "Cấu hình endpoint backchannel logout của OpenID Connect và liệu ứng dụng này có yêu cầu phiên hay không.",
                "backchannel_logout_uri": "URI backchannel logout",
                "backchannel_logout_uri_session_required": "Có yêu cầu phiên không?",
                "backchannel_logout_uri_session_required_description": "Khi bật, RP yêu cầu logout token phải chứa claim `sid` (session ID) để nhận diện phiên RP với OP khi dùng `backchannel_logout_uri`.",
                "token_exchange": "Token exchange",
                "token_exchange_description": "Quản lý cài đặt token exchange cho ứng dụng này.",
                "allow_token_exchange": "Cho phép token exchange",
                "allow_token_exchange_description": "Cho phép ứng dụng này khởi tạo yêu cầu token exchange. Điều này là bắt buộc cho <impersonationLink>mạo danh người dùng</impersonationLink> và <patLink>token truy cập cá nhân</patLink>.",
                "allow_token_exchange_public_client_warning": "Không khuyến nghị bật token exchange cho public client (ứng dụng một trang / ứng dụng native). Public client không thể lưu trữ thông tin xác thực an toàn, điều này có thể khiến ứng dụng của bạn gặp rủi ro mạo danh token.",
                "device_flow_tag": "Luồng thiết bị",
                "device_flow_notification": "Ứng dụng này bật OAuth 2.0 Device Authorization Flow cho các thiết bị hạn chế nhập liệu hoặc ứng dụng headless (ví dụ: TV, CLI). Người dùng hoàn tất đăng nhập trên một thiết bị khác bằng cách nhập mã thiết bị hoặc quét mã QR. <a>Tìm hiểu thêm</a>",
                "device_flow_try_demo": "Thử bản demo",
                "delete_description": "Hành động này không thể hoàn tác. Ứng dụng sẽ bị xoá vĩnh viễn. Vui lòng nhập tên ứng dụng <span>{{name}}</span> để xác nhận.",
                "enter_your_application_name": "Nhập tên ứng dụng của bạn",
                "application_deleted": "Ứng dụng {{name}} đã được xoá thành công",
                "redirect_uri_required": "Bạn phải nhập ít nhất một redirect URI",
                "app_domain_description_1": "Bạn có thể thoải mái dùng tên miền của mình với {{domain}} do Logto cung cấp, luôn có hiệu lực vĩnh viễn.",
                "app_domain_description_2": "Bạn có thể thoải mái sử dụng tên miền <domain>{{domain}}</domain> luôn có hiệu lực vĩnh viễn.",
                "custom_rules": "Quy tắc xác thực tuỳ chỉnh",
                "custom_rules_placeholder": "^/(admin|privacy)/.+$",
                "custom_rules_description": "Đặt quy tắc bằng biểu thức chính quy cho các route yêu cầu xác thực. Mặc định: bảo vệ toàn bộ trang nếu để trống.",
                "authentication_routes": "Route xác thực",
                "custom_rules_tip": "Dưới đây là hai tình huống ví dụ:<ol><li>Chỉ bảo vệ route '/admin' và '/privacy' bằng xác thực: ^/(admin|privacy)/.*</li><li>Loại trừ ảnh JPG khỏi xác thực: ^(?!.*\\.jpg$).*$</li></ol>",
                "authentication_routes_description": "Chuyển hướng nút xác thực của bạn bằng các route đã chỉ định. Lưu ý: Các route này không thể thay thế.",
                "protect_origin_server": "Bảo vệ origin server của bạn",
                "protect_origin_server_description": "Hãy đảm bảo bảo vệ origin server khỏi truy cập trực tiếp. Tham khảo hướng dẫn để biết <a>chỉ dẫn chi tiết hơn</a>.",
                "third_party_settings_description": "Tích hợp các ứng dụng bên thứ ba với Logto làm Nhà cung cấp danh tính (IdP) của bạn thông qua OIDC / OAuth 2.0, kèm màn hình đồng ý để người dùng cấp quyền.",
                "session_duration": "Thời lượng phiên (ngày)",
                "try_it": "Thử ngay",
                "no_organization_placeholder": "Không tìm thấy tổ chức nào. <a>Đến trang tổ chức</a>",
                "field_custom_data": "Dữ liệu tuỳ chỉnh",
                "field_custom_data_tip": "Thông tin ứng dụng tuỳ chỉnh bổ sung không có trong các thuộc tính ứng dụng định sẵn, chẳng hạn như cài đặt và cấu hình đặc thù theo nghiệp vụ.",
                "custom_data_invalid": "Dữ liệu tuỳ chỉnh phải là một đối tượng JSON hợp lệ",
                "access_control": {
                    "name": "Quy tắc",
                    "title": "Kiểm soát truy cập",
                    "description": "Tuỳ chỉnh các quy tắc kiểm soát truy cập ở cấp ứng dụng.",
                    "enable": "Bật kiểm soát truy cập cấp ứng dụng",
                    "enable_description": "Bật kiểm soát truy cập chi tiết để giới hạn người dùng nào có thể truy cập ứng dụng này. Nếu tắt, mọi người dùng đã đăng ký trong hệ thống đều có thể truy cập.",
                    "enable_without_rules_notice": "Hãy thêm ít nhất một quy tắc truy cập trước khi bật kiểm soát truy cập.",
                    "load_error": "Không tải được các quy tắc kiểm soát truy cập.",
                    "custom_allow_rules": "Quy tắc cho phép tuỳ chỉnh",
                    "custom_allow_rules_description": "Tạo quy tắc để người dùng có một số thuộc tính nhất định được truy cập tự động. Cần ít nhất một quy tắc khi đã bật.",
                    "rules": "Quy tắc truy cập",
                    "add_rules": "Thêm quy tắc",
                    "rules_description": "Người dùng có thể truy cập ứng dụng này khi khớp với bất kỳ quy tắc nào đã cấu hình.",
                    "empty_rules_description": "Chưa có quy tắc nào được cấu hình.",
                    "delete_rule_confirmation": "Bạn có chắc muốn xoá quy tắc này không?",
                    "rule_table_rules": "Quy tắc",
                    "rule_table_description": "Mô tả",
                    "rule_table_users": "Người dùng",
                    "rule_table_members": "Thành viên",
                    "rule_table_user_id": "User ID",
                    "rule_count": "{{count}} quy tắc",
                    "rule_count_other": "{{count}} quy tắc",
                    "rule_users": "Người dùng",
                    "rule_users_description": "Một số người dùng cụ thể có thể truy cập ứng dụng này.",
                    "rule_roles": "Vai trò",
                    "rule_user_roles": "Vai trò người dùng",
                    "rule_user_roles_description": "Người dùng được gán các vai trò người dùng đã chọn có thể truy cập ứng dụng này.",
                    "rule_organizations": "Tổ chức",
                    "rule_organizations_description": "Tất cả thành viên hiện tại và tương lai của các tổ chức đã chọn có thể truy cập ứng dụng này.",
                    "rule_organization_roles": "Vai trò tổ chức",
                    "rule_organization_roles_description": "Thành viên có các vai trò tổ chức đã chọn trong các tổ chức đã chọn có thể truy cập ứng dụng này."
                },
                "branding": {
                    "name": "Thương hiệu",
                    "description": "Tuỳ chỉnh logo và màu thương hiệu của ứng dụng cho trải nghiệm ở cấp ứng dụng.",
                    "description_third_party": "Tuỳ chỉnh tên hiển thị và logo của ứng dụng trên màn hình đồng ý.",
                    "app_logo": "Logo ứng dụng",
                    "app_level_sie": "Trải nghiệm đăng nhập cấp ứng dụng",
                    "app_level_sie_switch": "Bật trải nghiệm đăng nhập cấp ứng dụng và thiết lập thương hiệu riêng cho ứng dụng. Nếu tắt, trải nghiệm đăng nhập chung sẽ được sử dụng.",
                    "more_info": "Thông tin thêm",
                    "more_info_description": "Cung cấp cho người dùng thêm thông tin về ứng dụng của bạn trên màn hình đồng ý.",
                    "display_name": "Tên hiển thị",
                    "application_logo": "Logo ứng dụng",
                    "application_logo_dark": "Logo ứng dụng (nền tối)",
                    "brand_color": "Màu thương hiệu",
                    "brand_color_dark": "Màu thương hiệu (nền tối)",
                    "terms_of_use_url": "URL điều khoản sử dụng ứng dụng",
                    "privacy_policy_url": "URL chính sách quyền riêng tư ứng dụng"
                },
                "permissions": {
                    "name": "Quyền",
                    "description": "Chọn các quyền mà ứng dụng bên thứ ba cần để người dùng cấp phép truy cập các loại dữ liệu cụ thể.",
                    "user_permissions": "Dữ liệu cá nhân người dùng",
                    "organization_permissions": "Truy cập tổ chức",
                    "table_name": "Cấp quyền",
                    "field_name": "Quyền",
                    "field_description": "Hiển thị trên màn hình đồng ý",
                    "delete_text": "Xoá quyền",
                    "permission_delete_confirm": "Hành động này sẽ thu hồi các quyền đã cấp cho ứng dụng bên thứ ba, khiến ứng dụng không thể yêu cầu người dùng cấp phép truy cập các loại dữ liệu cụ thể. Bạn có chắc muốn tiếp tục không?",
                    "permissions_assignment_description": "Chọn các quyền mà ứng dụng bên thứ ba yêu cầu để người dùng cấp phép truy cập các loại dữ liệu cụ thể.",
                    "user_profile": "Dữ liệu người dùng",
                    "api_permissions": "Quyền API",
                    "organization": "Quyền tổ chức",
                    "user_permissions_assignment_form_title": "Thêm quyền hồ sơ người dùng",
                    "organization_permissions_assignment_form_title": "Thêm quyền tổ chức",
                    "api_resource_permissions_assignment_form_title": "Thêm quyền tài nguyên API",
                    "user_data_permission_description_tips": "Bạn có thể chỉnh sửa mô tả của các quyền dữ liệu cá nhân người dùng qua “Trải nghiệm đăng nhập > Nội dung > Quản lý ngôn ngữ”",
                    "permission_description_tips": "Khi Logto được dùng làm Nhà cung cấp danh tính (IdP) để xác thực trong các ứng dụng bên thứ ba, và người dùng được yêu cầu cấp phép, mô tả này sẽ xuất hiện trên màn hình đồng ý.",
                    "user_title": "Người dùng",
                    "user_description": "Chọn các quyền mà ứng dụng bên thứ ba yêu cầu để truy cập dữ liệu người dùng cụ thể.",
                    "grant_user_level_permissions": "Cấp quyền đối với dữ liệu người dùng",
                    "organization_title": "Tổ chức",
                    "organization_description": "Chọn các quyền mà ứng dụng bên thứ ba yêu cầu để truy cập dữ liệu tổ chức cụ thể.",
                    "grant_organization_level_permissions": "Cấp quyền đối với dữ liệu tổ chức",
                    "oidc_title": "OIDC",
                    "oidc_description": "Các quyền OIDC cốt lõi được cấu hình tự động cho ứng dụng của bạn. Các scope này thiết yếu cho việc xác thực và không hiển thị trên màn hình đồng ý của người dùng.",
                    "default_oidc_permissions": "Quyền OIDC mặc định",
                    "permission_column": "Quyền",
                    "guide_column": "Hướng dẫn",
                    "openid_permission": "openid",
                    "openid_permission_guide": "Không bắt buộc đối với truy cập tài nguyên OAuth.\nBắt buộc đối với xác thực OIDC. Cấp quyền truy cập ID token và cho phép truy cập 'userinfo_endpoint'.",
                    "offline_access_permission": "offline_access",
                    "offline_access_permission_guide": "Không bắt buộc. Lấy refresh token cho truy cập lâu dài hoặc tác vụ nền."
                },
                "roles": {
                    "assign_button": "Gán vai trò",
                    "delete_description": "Hành động này sẽ gỡ vai trò này khỏi ứng dụng Máy-với-Máy. Bản thân vai trò vẫn tồn tại, nhưng sẽ không còn liên kết với ứng dụng Máy-với-Máy này.",
                    "deleted": "{{name}} đã được gỡ khỏi người dùng này thành công.",
                    "assign_title": "Gán vai trò cho {{name}}",
                    "assign_subtitle": "Ứng dụng Máy-với-Máy phải có vai trò loại Máy-với-Máy để truy cập các tài nguyên API liên quan.",
                    "assign_role_field": "Gán vai trò",
                    "role_search_placeholder": "Tìm theo tên vai trò",
                    "added_text": "Đã thêm {{value, number}}",
                    "assigned_app_count": "{{value, number}} ứng dụng",
                    "confirm_assign": "Gán vai trò",
                    "role_assigned": "Đã gán vai trò thành công",
                    "search": "Tìm theo tên vai trò, mô tả hoặc ID",
                    "empty": "Không có vai trò nào"
                },
                "secrets": {
                    "value": "Giá trị",
                    "empty": "Ứng dụng chưa có secret nào.",
                    "created_at": "Tạo lúc",
                    "expires_at": "Hết hạn lúc",
                    "never": "Không bao giờ",
                    "create_new_secret": "Tạo secret mới",
                    "delete_confirmation": "Hành động này không thể hoàn tác. Bạn có chắc muốn xoá secret này không?",
                    "deleted": "Secret đã được xoá thành công.",
                    "activated": "Secret đã được kích hoạt thành công.",
                    "deactivated": "Secret đã được ngừng kích hoạt thành công.",
                    "legacy_secret": "Secret cũ",
                    "expired": "Đã hết hạn",
                    "expired_tooltip": "Secret này đã hết hạn vào {{date}}.",
                    "create_modal": {
                        "title": "Tạo secret ứng dụng",
                        "expiration": "Hết hạn",
                        "expiration_description": "Secret sẽ hết hạn vào {{date}}.",
                        "expiration_description_never": "Secret sẽ không bao giờ hết hạn. Chúng tôi khuyến nghị đặt ngày hết hạn để tăng cường bảo mật.",
                        "days": "{{count}} ngày",
                        "days_other": "{{count}} ngày",
                        "years": "{{count}} năm",
                        "years_other": "{{count}} năm",
                        "created": "Secret {{name}} đã được tạo thành công."
                    },
                    "edit_modal": {
                        "title": "Sửa secret ứng dụng",
                        "edited": "Secret {{name}} đã được chỉnh sửa thành công."
                    }
                },
                "saml_idp_config": {
                    "title": "Metadata SAML IdP",
                    "description": "Dùng metadata và chứng chỉ sau để cấu hình SAML IdP trong ứng dụng của bạn.",
                    "metadata_url_label": "URL metadata IdP",
                    "single_sign_on_service_url_label": "URL dịch vụ đăng nhập một lần (SSO)",
                    "idp_entity_id_label": "IdP entity ID"
                },
                "saml_idp_certificates": {
                    "title": "Chứng chỉ ký SAML",
                    "expires_at": "Hết hạn lúc",
                    "finger_print": "Vân tay (fingerprint)",
                    "status": "Trạng thái",
                    "active": "Đang hoạt động",
                    "inactive": "Không hoạt động"
                },
                "saml_idp_name_id_format": {
                    "title": "Định dạng Name ID",
                    "description": "Chọn định dạng Name ID của SAML IdP.",
                    "persistent": "Cố định (Persistent)",
                    "persistent_description": "Dùng ID người dùng Logto làm Name ID",
                    "transient": "Tạm thời (Transient)",
                    "transient_description": "Dùng ID người dùng dùng một lần làm Name ID",
                    "unspecified": "Không chỉ định",
                    "unspecified_description": "Dùng ID người dùng Logto làm Name ID",
                    "email_address": "Địa chỉ email",
                    "email_address_description": "Dùng địa chỉ email làm Name ID"
                },
                "saml_encryption_config": {
                    "encrypt_assertion": "Mã hoá SAML assertion",
                    "encrypt_assertion_description": "Khi bật tuỳ chọn này, SAML assertion sẽ được mã hoá.",
                    "encrypt_then_sign": "Mã hoá rồi ký",
                    "encrypt_then_sign_description": "Khi bật tuỳ chọn này, SAML assertion sẽ được mã hoá rồi mới ký; nếu không, SAML assertion sẽ được ký rồi mới mã hoá.",
                    "certificate": "Chứng chỉ",
                    "certificate_tooltip": "Sao chép và dán chứng chỉ x509 mà bạn nhận từ nhà cung cấp dịch vụ để mã hoá SAML assertion.",
                    "certificate_placeholder": "-----BEGIN CERTIFICATE-----\nMIICYDCCAcmgAwIBA...\n-----END CERTIFICATE-----\n",
                    "certificate_missing_error": "Chứng chỉ là bắt buộc.",
                    "certificate_invalid_format_error": "Phát hiện định dạng chứng chỉ không hợp lệ. Vui lòng kiểm tra định dạng chứng chỉ và thử lại."
                },
                "saml_app_attribute_mapping": {
                    "name": "Ánh xạ thuộc tính",
                    "title": "Ánh xạ thuộc tính cơ bản",
                    "description": "Thêm ánh xạ thuộc tính để đồng bộ hồ sơ người dùng từ Logto sang ứng dụng của bạn.",
                    "col_logto_claims": "Giá trị của Logto",
                    "col_sp_claims": "Tên giá trị của ứng dụng của bạn",
                    "add_button": "Thêm cái khác"
                },
                "concurrent_device_limit": {
                    "title": "Giới hạn thiết bị đồng thời",
                    "enable": "Bật giới hạn thiết bị đồng thời",
                    "enable_description": "Khi bật, Logto áp dụng số grant đang hoạt động tối đa cho mỗi người dùng đối với ứng dụng này.",
                    "field": "Giới hạn thiết bị đồng thời cho mỗi ứng dụng",
                    "field_description": "Giới hạn số thiết bị mà một người dùng có thể đăng nhập cùng lúc. Logto áp dụng điều này bằng cách giới hạn số grant đang hoạt động và tự động thu hồi grant cũ nhất khi vượt quá giới hạn.",
                    "field_placeholder": "Để trống nếu không giới hạn",
                    "should_be_greater_than_zero": "Phải lớn hơn 0."
                }
            },
            "api_resources": {
                "page_title": "Tài nguyên API",
                "title": "Tài nguyên API",
                "subtitle": "Định nghĩa các API mà ứng dụng được cấp quyền của bạn có thể dùng.",
                "create": "Tạo tài nguyên API",
                "api_name": "Tên API",
                "api_name_placeholder": "Nhập tên API của bạn",
                "api_identifier": "Định danh API",
                "api_identifier_placeholder": "https://your-api-identifier",
                "api_identifier_tip": "Định danh duy nhất của tài nguyên API. Phải là URI tuyệt đối và không có phần fragment (#). Tương đương <a>tham số resource</a> trong OAuth 2.0.",
                "default_api": "API mặc định",
                "default_api_label": "Mỗi tenant chỉ đặt được không hoặc một API mặc định.\nKhi đã chỉ định API mặc định, có thể bỏ tham số resource trong yêu cầu xác thực. Các lần trao đổi token sau sẽ mặc định dùng API đó làm audience, dẫn tới việc cấp JWT. <a>Tìm hiểu thêm</a>",
                "api_resource_created": "Tài nguyên API {{name}} đã được tạo thành công",
                "invalid_resource_indicator_format": "Định danh API phải là một URI tuyệt đối hợp lệ."
            },
            "api_resource_details": {
                "page_title": "Chi tiết tài nguyên API",
                "back_to_api_resources": "Quay lại Tài nguyên API",
                "general_tab": "Chung",
                "permissions_tab": "Quyền",
                "settings": "Cài đặt",
                "settings_description": "Tài nguyên API, hay còn gọi là Resource Indicators, chỉ định dịch vụ hoặc tài nguyên đích cần được yêu cầu, thường ở dạng URI đại diện cho danh tính của tài nguyên.",
                "management_api_settings_description": "Logto Management API là bộ API toàn diện giúp quản trị viên quản lý nhiều tác vụ liên quan đến danh tính, thực thi các chính sách bảo mật, và tuân thủ các quy định và tiêu chuẩn.",
                "management_api_notice": "API này đại diện cho thực thể Logto và không thể chỉnh sửa hoặc xoá. Hãy tạo ứng dụng Máy-với-Máy để gọi Logto Management API. <a>Tìm hiểu thêm</a>",
                "token_expiration_time_in_seconds": "Thời gian hết hạn token (tính bằng giây)",
                "token_expiration_time_in_seconds_placeholder": "Nhập thời gian hết hạn token của bạn",
                "delete_description": "Hành động này không thể hoàn tác. Nó sẽ xoá vĩnh viễn tài nguyên API. Vui lòng nhập tên tài nguyên API <span>{{name}}</span> để xác nhận.",
                "enter_your_api_resource_name": "Nhập tên tài nguyên API của bạn",
                "api_resource_deleted": "Tài nguyên API {{name}} đã được xoá thành công",
                "permission": {
                    "create_button": "Tạo quyền",
                    "create_title": "Tạo quyền",
                    "create_subtitle": "Định nghĩa các quyền (scope) mà API này cần.",
                    "confirm_create": "Tạo quyền",
                    "edit_title": "Sửa quyền API",
                    "edit_subtitle": "Định nghĩa các quyền (scope) mà API {{resourceName}} cần.",
                    "name": "Tên quyền",
                    "name_placeholder": "read:resource",
                    "forbidden_space_in_name": "Tên quyền không được chứa khoảng trắng.",
                    "description": "Mô tả",
                    "description_placeholder": "Có thể đọc các tài nguyên",
                    "permission_created": "Quyền {{name}} đã được tạo thành công",
                    "delete_description": "Nếu quyền này bị xoá, người dùng đang có quyền này sẽ mất quyền truy cập được cấp bởi nó.",
                    "deleted": "Quyền \"{{name}}\" đã được xoá thành công."
                }
            },
            "connectors": {
                "page_title": "Trình kết nối",
                "title": "Trình kết nối",
                "subtitle": "Thiết lập trình kết nối để bật đăng nhập không mật khẩu và đăng nhập mạng xã hội",
                "create": "Thêm trình kết nối mạng xã hội",
                "config_sie_notice": "Bạn đã thiết lập trình kết nối. Hãy cấu hình nó trong <a>{{link}}</a>.",
                "config_sie_link_text": "trải nghiệm đăng nhập",
                "tab_email_sms": "Trình kết nối Email và SMS",
                "tab_social": "Trình kết nối mạng xã hội",
                "connector_name": "Tên trình kết nối",
                "demo_tip": "Số tin nhắn tối đa cho trình kết nối demo này giới hạn ở 100 và không nên dùng cho môi trường production.",
                "social_demo_tip": "Trình kết nối demo chỉ dành cho mục đích minh hoạ và không nên dùng cho môi trường production.",
                "connector_type": "Loại",
                "placeholder_title": "Trình kết nối mạng xã hội",
                "placeholder_description": "Logto cung cấp nhiều trình kết nối đăng nhập mạng xã hội phổ biến, đồng thời bạn có thể tự tạo bằng các giao thức chuẩn.",
                "save_and_done": "Lưu và hoàn tất",
                "type": {
                    "email": "Trình kết nối Email",
                    "sms": "Trình kết nối SMS",
                    "social": "Trình kết nối mạng xã hội"
                },
                "setup_title": {
                    "email": "Thiết lập trình kết nối Email",
                    "sms": "Thiết lập trình kết nối SMS",
                    "social": "Thêm trình kết nối mạng xã hội"
                },
                "guide": {
                    "subtitle": "Hướng dẫn từng bước để cấu hình trình kết nối của bạn",
                    "general_setting": "Cài đặt chung",
                    "parameter_configuration": "Cấu hình tham số",
                    "test_connection": "Kiểm tra kết nối",
                    "name": "Tên cho nút đăng nhập mạng xã hội",
                    "name_placeholder": "Nhập tên cho nút đăng nhập mạng xã hội",
                    "name_tip": "Tên nút trình kết nối sẽ hiển thị là \"Tiếp tục với {{name}}.\" Lưu ý độ dài của tên kẻo bị quá dài.",
                    "connector_logo": "Logo trình kết nối",
                    "connector_logo_tip": "Logo sẽ hiển thị trên nút đăng nhập của trình kết nối.",
                    "target": "Tên nhà cung cấp danh tính",
                    "target_placeholder": "Nhập tên nhà cung cấp danh tính của trình kết nối",
                    "target_tip": "Giá trị \"tên IdP\" có thể là một chuỗi định danh duy nhất để phân biệt các danh tính mạng xã hội của bạn.",
                    "target_tip_standard": "Giá trị \"tên IdP\" có thể là một chuỗi định danh duy nhất để phân biệt các danh tính mạng xã hội. Không thể đổi sau khi trình kết nối được tạo.",
                    "target_tooltip": "\"Tên IdP\" trong trình kết nối mạng xã hội Logto chỉ \"nguồn\" của các danh tính mạng xã hội. Theo thiết kế của Logto, chúng tôi không chấp nhận trùng \"tên IdP\" của cùng một nền tảng để tránh xung đột. Hãy hết sức cẩn thận trước khi thêm trình kết nối vì bạn KHÔNG THỂ đổi giá trị này sau khi tạo. <a>Tìm hiểu thêm</a>",
                    "target_conflict": "Tên IdP vừa nhập trùng với trình kết nối <span>name</span> hiện có. Dùng cùng tên IdP có thể gây hành vi đăng nhập bất ngờ khi người dùng truy cập cùng một tài khoản qua hai trình kết nối khác nhau.",
                    "target_conflict_line2": "Nếu bạn muốn thay trình kết nối hiện tại bằng cùng nhà cung cấp danh tính và cho phép người dùng cũ đăng nhập mà không cần đăng ký lại, hãy xoá trình kết nối <span>name</span> và tạo mới với cùng \"tên IdP\".",
                    "target_conflict_line3": "Nếu bạn muốn kết nối tới một nhà cung cấp danh tính khác, hãy sửa \"tên IdP\" và tiếp tục.",
                    "config": "Nhập JSON cấu hình của bạn",
                    "sync_profile": "Đồng bộ thông tin hồ sơ",
                    "sync_profile_only_at_sign_up": "Chỉ đồng bộ khi đăng ký",
                    "sync_profile_each_sign_in": "Luôn đồng bộ mỗi lần đăng nhập",
                    "sync_profile_tip": "Đồng bộ hồ sơ cơ bản từ nhà cung cấp mạng xã hội, như tên và ảnh đại diện của người dùng.",
                    "enable_token_storage": {
                        "title": "Lưu token để truy cập API lâu dài",
                        "description": "Lưu access token và refresh token trong Secret Vault. Cho phép gọi API tự động mà không cần người dùng đồng ý lại. Ví dụ: để AI Agent thêm sự kiện vào Google Calendar với cấp quyền lâu dài. <a>Tìm hiểu cách gọi API bên thứ ba</a>"
                    },
                    "callback_uri": "Redirect URI (Callback URI)",
                    "callback_uri_description": "Redirect URI là nơi người dùng được chuyển tới sau khi cấp quyền mạng xã hội. Thêm URI này vào cấu hình IdP của bạn.",
                    "callback_uri_custom_domain_description": "Nếu bạn dùng nhiều <a>tên miền tuỳ chỉnh</a> trong Logto, hãy thêm tất cả callback URI tương ứng vào IdP để đăng nhập mạng xã hội hoạt động trên mọi tên miền.\n\nTên miền Logto mặc định (*.logto.app) luôn hợp lệ — chỉ thêm nếu bạn cũng muốn hỗ trợ đăng nhập dưới tên miền đó.",
                    "acs_url": "URL Assertion Consumer Service"
                },
                "platform": {
                    "universal": "Đa nền tảng",
                    "web": "Web",
                    "native": "Native"
                },
                "add_multi_platform": " hỗ trợ nhiều nền tảng, chọn một nền tảng để tiếp tục",
                "drawer_title": "Hướng dẫn trình kết nối",
                "drawer_subtitle": "Làm theo hướng dẫn để tích hợp trình kết nối của bạn",
                "unknown": "Trình kết nối không xác định",
                "standard_connectors": "Trình kết nối chuẩn",
                "create_form": {
                    "third_party_connectors": "Tích hợp nhà cung cấp bên thứ ba để đăng nhập mạng xã hội nhanh, liên kết tài khoản mạng xã hội và truy cập API. <a>Tìm hiểu thêm</a>",
                    "email_connector_upsell": {
                        "title": "Dịch vụ email tích hợp sẵn của Logto",
                        "description": "Gửi email không cần cấu hình. Gửi mã xác minh và magic link ngay lập tức."
                    },
                    "standard_connectors": "Hoặc bạn có thể tuỳ chỉnh trình kết nối mạng xã hội bằng giao thức chuẩn."
                }
            },
            "connector_details": {
                "page_title": "Chi tiết trình kết nối",
                "back_to_connectors": "Quay lại danh sách trình kết nối",
                "check_readme": "Xem README",
                "settings": "Cài đặt chung",
                "settings_description": "Tích hợp nhà cung cấp bên thứ ba để đăng nhập mạng xã hội nhanh và liên kết tài khoản mạng xã hội",
                "setting_description_with_token_storage_supported": "Tích hợp nhà cung cấp bên thứ ba để đăng nhập mạng xã hội nhanh, liên kết tài khoản mạng xã hội và truy cập API.",
                "email_connector_settings_description": "Tích hợp với nhà cung cấp gửi email của bạn để bật đăng ký và đăng nhập bằng email không cần mật khẩu cho người dùng cuối.",
                "parameter_configuration": "Cấu hình tham số",
                "test_connection": "Kiểm tra",
                "save_error_empty_config": "Vui lòng nhập cấu hình",
                "send": "Gửi",
                "send_error_invalid_format": "Dữ liệu nhập không hợp lệ",
                "edit_config_label": "Nhập JSON của bạn tại đây",
                "test_email_sender": "Kiểm tra trình kết nối Email của bạn",
                "test_sms_sender": "Kiểm tra trình kết nối SMS của bạn",
                "test_email_placeholder": "vana@example.com",
                "test_sms_placeholder": "+84 90 555 5555",
                "test_message_sent": "Đã gửi tin nhắn kiểm tra",
                "test_sender_description": "Logto dùng mẫu \"Generic\" để kiểm tra. Bạn sẽ nhận được tin nhắn nếu trình kết nối được cấu hình đúng.",
                "options_change_email": "Đổi trình kết nối Email",
                "options_change_sms": "Đổi trình kết nối SMS",
                "connector_deleted": "Đã xoá trình kết nối thành công",
                "type_email": "Trình kết nối Email",
                "type_sms": "Trình kết nối SMS",
                "type_social": "Trình kết nối mạng xã hội",
                "in_used_social_deletion_description": "Trình kết nối này đang được dùng trong trải nghiệm đăng nhập của bạn. Khi xoá, phần đăng nhập <name/> sẽ bị xoá trong cài đặt trải nghiệm đăng nhập. Bạn sẽ cần cấu hình lại nếu quyết định thêm lại.",
                "in_used_passwordless_deletion_description": "{{name}} này đang được dùng trong trải nghiệm đăng nhập của bạn. Khi xoá, trải nghiệm đăng nhập sẽ không hoạt động đúng cho đến khi bạn xử lý xung đột. Bạn sẽ cần cấu hình lại nếu quyết định thêm lại.",
                "deletion_description": "Bạn đang gỡ trình kết nối này. Hành động không thể hoàn tác, và bạn sẽ cần cấu hình lại nếu quyết định thêm lại.",
                "logto_email": {
                    "total_email_sent": "Tổng email đã gửi: {{value, number}}",
                    "total_email_sent_tip": "Logto sử dụng SendGrid để cung cấp email tích hợp an toàn và ổn định. Hoàn toàn miễn phí. <a>Tìm hiểu thêm</a>",
                    "email_template_title": "Mẫu email",
                    "template_description": "Email tích hợp dùng các mẫu mặc định để gửi email xác minh liền mạch. Không cần cấu hình, và bạn có thể tuỳ chỉnh thông tin thương hiệu cơ bản.",
                    "template_description_link_text": "Xem mẫu",
                    "description_action_text": "Xem mẫu",
                    "from_email_field": "Email gửi từ",
                    "sender_name_field": "Tên người gửi",
                    "sender_name_tip": "Tuỳ chỉnh tên người gửi cho email. Nếu để trống, \"Verification\" sẽ được dùng làm tên mặc định.",
                    "sender_name_placeholder": "Tên người gửi của bạn",
                    "company_information_field": "Thông tin công ty",
                    "company_information_description": "Hiển thị tên công ty, địa chỉ hoặc mã bưu chính ở cuối email để tăng độ tin cậy.",
                    "company_information_placeholder": "Thông tin cơ bản về công ty của bạn",
                    "email_logo_field": "Logo email",
                    "email_logo_tip": "Hiển thị logo thương hiệu ở đầu email. Dùng cùng một ảnh cho cả chế độ sáng và chế độ tối.",
                    "urls_not_allowed": "Không cho phép URL",
                    "test_notes": "Logto dùng mẫu “Generic” để kiểm tra."
                },
                "google_one_tap": {
                    "title": "Google One Tap",
                    "description": "Google One Tap là cách an toàn và dễ dàng để người dùng đăng nhập vào website của bạn.",
                    "enable_google_one_tap": "Bật Google One Tap",
                    "enable_google_one_tap_description": "Bật Google One Tap trong trải nghiệm đăng nhập: Cho phép người dùng nhanh chóng đăng ký hoặc đăng nhập bằng tài khoản Google nếu họ đã đăng nhập sẵn trên thiết bị.",
                    "configure_google_one_tap": "Cấu hình Google One Tap",
                    "auto_select": "Tự động chọn thông tin đăng nhập nếu có thể",
                    "close_on_tap_outside": "Huỷ lời nhắc nếu người dùng nhấp/chạm ra ngoài",
                    "itp_support": "Bật <a>trải nghiệm One Tap nâng cấp trên trình duyệt ITP</a>"
                },
                "sign_in_experience": {
                    "in_use": "Đã bật cho đăng nhập ",
                    "not_in_use": "Đã tắt cho đăng nhập "
                }
            },
            "enterprise_sso": {
                "page_title": "SSO doanh nghiệp",
                "title": "SSO doanh nghiệp",
                "subtitle": "Kết nối nhà cung cấp danh tính doanh nghiệp và bật Đăng nhập một lần (SSO).",
                "create": "Thêm trình kết nối doanh nghiệp",
                "col_connector_name": "Tên trình kết nối",
                "col_type": "Loại",
                "col_email_domain": "Miền email",
                "placeholder_title": "Trình kết nối doanh nghiệp",
                "placeholder_description": "Logto cung cấp sẵn nhiều nhà cung cấp danh tính doanh nghiệp để kết nối, đồng thời bạn có thể tự tạo trình kết nối bằng giao thức SAML và OIDC.",
                "create_modal": {
                    "title": "Thêm trình kết nối doanh nghiệp",
                    "text_divider": "Hoặc bạn có thể tuỳ chỉnh trình kết nối bằng một giao thức chuẩn.",
                    "connector_name_field_title": "Tên trình kết nối",
                    "connector_name_field_placeholder": "Ví dụ: {tên công ty} - {tên nhà cung cấp danh tính}",
                    "create_button_text": "Tạo trình kết nối"
                },
                "guide": {
                    "subtitle": "Hướng dẫn từng bước để kết nối nhà cung cấp danh tính doanh nghiệp.",
                    "finish_button_text": "Tiếp tục"
                },
                "basic_info": {
                    "title": "Cấu hình dịch vụ của bạn trong IdP",
                    "description": "Tạo một tích hợp ứng dụng mới bằng SAML 2.0 trong nhà cung cấp danh tính {{name}} của bạn. Sau đó dán các giá trị sau vào đó.",
                    "saml": {
                        "acs_url_field_name": "URL Assertion Consumer Service (Reply URL)",
                        "audience_uri_field_name": "Audience URI (SP Entity ID)",
                        "entity_id_field_name": "Service Provider (SP) Entity ID",
                        "entity_id_field_tooltip": "SP Entity ID có thể ở bất kỳ định dạng chuỗi nào, thường dùng dạng URI hoặc URL làm định danh, nhưng không bắt buộc.",
                        "acs_url_field_placeholder": "https://your-domain.com/api/saml/callback",
                        "entity_id_field_placeholder": "urn:your-domain.com:sp:saml:{serviceProviderId}"
                    },
                    "oidc": {
                        "redirect_uri_field_name": "Redirect URI (Callback URL)",
                        "redirect_uri_field_description": "Redirect URI là nơi người dùng được chuyển hướng đến sau khi xác thực SSO. Thêm URI này vào cấu hình IdP của bạn.",
                        "redirect_uri_field_custom_domain_description": "Nếu bạn dùng nhiều <a>miền tuỳ chỉnh</a> trong Logto, hãy đảm bảo thêm tất cả callback URI tương ứng vào IdP để SSO hoạt động trên mọi miền.\n\nMiền Logto mặc định (*.logto.app) luôn hợp lệ — chỉ thêm nó nếu bạn cũng muốn hỗ trợ SSO dưới miền đó."
                    }
                },
                "attribute_mapping": {
                    "title": "Ánh xạ thuộc tính",
                    "description": "`id` và `email` là bắt buộc để đồng bộ hồ sơ người dùng từ IdP. Nhập tên và giá trị claim sau vào IdP của bạn.",
                    "col_sp_claims": "Giá trị của service provider (Logto)",
                    "col_idp_claims": "Tên claim của nhà cung cấp danh tính",
                    "idp_claim_tooltip": "Tên claim của nhà cung cấp danh tính"
                },
                "metadata": {
                    "title": "Cấu hình metadata của IdP",
                    "description": "Cấu hình metadata từ nhà cung cấp danh tính",
                    "dropdown_trigger_text": "Dùng phương thức cấu hình khác",
                    "dropdown_title": "chọn phương thức cấu hình của bạn",
                    "metadata_format_url": "Nhập URL metadata",
                    "metadata_format_xml": "Tải lên tệp XML metadata",
                    "metadata_format_manual": "Nhập chi tiết metadata thủ công",
                    "saml": {
                        "metadata_url_field_name": "URL metadata",
                        "metadata_url_description": "Tự động lấy dữ liệu từ URL metadata và giữ chứng chỉ luôn được cập nhật.",
                        "metadata_xml_field_name": "Tệp XML metadata của IdP",
                        "metadata_xml_uploader_text": "Tải lên tệp XML metadata",
                        "sign_in_endpoint_field_name": "Sign on URL",
                        "idp_entity_id_field_name": "IdP entity ID (Issuer)",
                        "certificate_field_name": "Chứng chỉ ký",
                        "certificate_placeholder": "Sao chép và dán chứng chỉ x509",
                        "certificate_required": "Chứng chỉ ký là bắt buộc."
                    },
                    "oidc": {
                        "client_id_field_name": "Client ID",
                        "client_secret_field_name": "Client secret",
                        "issuer_field_name": "Issuer",
                        "scope_field_name": "Scope",
                        "scope_field_placeholder": "Nhập các scope (cách nhau bằng dấu cách)"
                    }
                }
            },
            "enterprise_sso_details": {
                "back_to_sso_connectors": "Quay lại SSO doanh nghiệp",
                "page_title": "Chi tiết trình kết nối SSO doanh nghiệp",
                "readme_drawer_title": "SSO doanh nghiệp",
                "readme_drawer_subtitle": "Thiết lập trình kết nối SSO doanh nghiệp để bật SSO cho người dùng cuối",
                "tab_experience": "Trải nghiệm SSO",
                "tab_connection": "Kết nối",
                "tab_idp_initiated_auth": "SSO khởi tạo từ IdP",
                "general_settings_title": "Chung",
                "general_settings_description": "Cấu hình trải nghiệm người dùng cuối và liên kết miền email doanh nghiệp cho luồng SSO khởi tạo từ SP.",
                "custom_branding_title": "Hiển thị",
                "custom_branding_description": "Tuỳ chỉnh tên và logo hiển thị trong luồng Đăng nhập một lần của người dùng cuối. Khi để trống, giá trị mặc định sẽ được dùng.",
                "email_domain_field_name": "Miền email doanh nghiệp",
                "email_domain_field_description": "Người dùng có các miền email này có thể dùng SSO để xác thực. Vui lòng xác minh quyền sở hữu miền trước khi thêm.",
                "email_domain_field_placeholder": "Nhập một hoặc nhiều miền email (ví dụ: yourcompany.com)",
                "sync_profile_field_name": "Đồng bộ thông tin hồ sơ từ nhà cung cấp danh tính",
                "sync_profile_option": {
                    "register_only": "Chỉ đồng bộ ở lần đăng nhập đầu tiên",
                    "each_sign_in": "Luôn đồng bộ ở mỗi lần đăng nhập"
                },
                "connector_name_field_name": "Tên trình kết nối",
                "display_name_field_name": "Tên hiển thị",
                "connector_logo_field_name": "Logo hiển thị",
                "connector_logo_field_description": "Mỗi ảnh phải dưới 500KB, chỉ chấp nhận SVG, PNG, JPG, JPEG.",
                "branding_logo_context": "Tải lên logo",
                "branding_logo_error": "Lỗi tải lên logo: {{error}}",
                "branding_light_logo_context": "Tải lên logo chế độ sáng",
                "branding_light_logo_error": "Lỗi tải lên logo chế độ sáng: {{error}}",
                "branding_logo_field_name": "Logo",
                "branding_logo_field_placeholder": "https://your.domain/logo.png",
                "branding_dark_logo_context": "Tải lên logo chế độ tối",
                "branding_dark_logo_error": "Lỗi tải lên logo chế độ tối: {{error}}",
                "branding_dark_logo_field_name": "Logo (chế độ tối)",
                "branding_dark_logo_field_placeholder": "https://your.domain/dark-mode-logo.png",
                "check_connection_guide": "Hướng dẫn kết nối",
                "enterprise_sso_deleted": "Đã xoá thành công trình kết nối SSO doanh nghiệp",
                "delete_confirm_modal_title": "Xoá trình kết nối SSO doanh nghiệp",
                "delete_confirm_modal_content": "Bạn có chắc muốn xoá trình kết nối doanh nghiệp này? Người dùng từ các nhà cung cấp danh tính sẽ không dùng được Đăng nhập một lần.",
                "upload_idp_metadata_title_saml": "Tải lên metadata",
                "upload_idp_metadata_description_saml": "Cấu hình metadata đã sao chép từ nhà cung cấp danh tính.",
                "upload_idp_metadata_title_oidc": "Tải lên thông tin xác thực",
                "upload_idp_metadata_description_oidc": "Cấu hình thông tin xác thực và thông tin token OIDC đã sao chép từ nhà cung cấp danh tính.",
                "upload_idp_metadata_button_text": "Tải lên tệp XML metadata",
                "upload_signing_certificate_button_text": "Tải lên tệp chứng chỉ ký",
                "configure_domain_field_info_text": "Thêm miền email để dẫn người dùng doanh nghiệp đến nhà cung cấp danh tính của họ cho Đăng nhập một lần.",
                "email_domain_field_required": "Miền email là bắt buộc để bật SSO doanh nghiệp.",
                "upload_saml_idp_metadata_info_text_url": "Dán URL metadata từ nhà cung cấp danh tính để kết nối.",
                "upload_saml_idp_metadata_info_text_xml": "Dán metadata từ nhà cung cấp danh tính để kết nối.",
                "upload_saml_idp_metadata_info_text_manual": "Điền metadata từ nhà cung cấp danh tính để kết nối.",
                "upload_oidc_idp_info_text": "Điền thông tin từ nhà cung cấp danh tính để kết nối.",
                "service_provider_property_title": "Cấu hình trong IdP",
                "service_provider_property_description": "Thiết lập một tích hợp ứng dụng bằng {{protocol}} trong nhà cung cấp danh tính của bạn. Nhập các chi tiết do Logto cung cấp.",
                "attribute_mapping_title": "Ánh xạ thuộc tính",
                "attribute_mapping_description": "Đồng bộ hồ sơ người dùng từ nhà cung cấp danh tính bằng cách cấu hình ánh xạ thuộc tính người dùng ở phía nhà cung cấp danh tính hoặc phía Logto.",
                "saml_preview": {
                    "sign_on_url": "Sign on URL",
                    "entity_id": "Issuer",
                    "x509_certificate": "Chứng chỉ ký",
                    "certificate_content": "Hết hạn {{date}}"
                },
                "oidc_preview": {
                    "authorization_endpoint": "Authorization endpoint",
                    "token_endpoint": "Token endpoint",
                    "userinfo_endpoint": "Endpoint thông tin người dùng",
                    "jwks_uri": "Endpoint JSON Web Key Set",
                    "issuer": "Issuer"
                },
                "idp_initiated_auth_config": {
                    "card_title": "SSO khởi tạo từ IdP",
                    "card_description": "Người dùng thường bắt đầu quá trình xác thực từ ứng dụng của bạn bằng luồng SSO khởi tạo từ SP. KHÔNG bật tính năng này trừ khi thật sự cần thiết.",
                    "enable_idp_initiated_sso": "Bật SSO khởi tạo từ IdP",
                    "enable_idp_initiated_sso_description": "Cho phép người dùng doanh nghiệp bắt đầu quá trình xác thực trực tiếp từ cổng của nhà cung cấp danh tính. Vui lòng hiểu rõ các rủi ro bảo mật tiềm ẩn trước khi bật tính năng này.",
                    "default_application": "Ứng dụng mặc định",
                    "default_application_tooltip": "Ứng dụng đích mà người dùng sẽ được chuyển hướng đến sau khi xác thực.",
                    "empty_applications_error": "Không tìm thấy ứng dụng nào. Vui lòng thêm một ứng dụng trong mục <a>Ứng dụng</a>.",
                    "empty_applications_placeholder": "Không có ứng dụng",
                    "authentication_type": "Loại xác thực",
                    "auto_authentication_disabled_title": "Chuyển hướng đến client cho SSO khởi tạo từ SP",
                    "auto_authentication_disabled_description": "Khuyến nghị. Chuyển hướng người dùng đến ứng dụng phía client để bắt đầu một luồng xác thực OIDC khởi tạo từ SP an toàn. Cách này sẽ ngăn chặn tấn công CSRF.",
                    "auto_authentication_enabled_title": "Đăng nhập trực tiếp bằng SSO khởi tạo từ IdP",
                    "auto_authentication_enabled_description": "Sau khi đăng nhập thành công, người dùng sẽ được chuyển hướng đến Redirect URI đã chỉ định kèm mã cấp quyền (không có xác thực state và PKCE).",
                    "auto_authentication_disabled_app": "Cho web app truyền thống, ứng dụng một trang (SPA)",
                    "auto_authentication_enabled_app": "Cho web app truyền thống",
                    "idp_initiated_auth_callback_uri": "Client callback URI",
                    "idp_initiated_auth_callback_uri_tooltip": "Client callback URI để bắt đầu một luồng xác thực SSO khởi tạo từ SP. Một ssoConnectorId sẽ được thêm vào URI dưới dạng tham số truy vấn. (ví dụ: https://your.domain/sso/callback?connectorId={{ssoConnectorId}})",
                    "redirect_uri": "Redirect URI sau đăng nhập",
                    "redirect_uri_tooltip": "Redirect URI để chuyển hướng người dùng sau khi đăng nhập thành công. Logto sẽ dùng URI này làm OIDC redirect URI trong yêu cầu cấp quyền. Hãy dùng một URI riêng cho luồng xác thực SSO khởi tạo từ IdP để bảo mật tốt hơn.",
                    "empty_redirect_uris_error": "Chưa có redirect URI nào được đăng ký cho ứng dụng. Vui lòng thêm một cái trước.",
                    "redirect_uri_placeholder": "Chọn một redirect URI sau đăng nhập",
                    "auth_params": "Tham số xác thực bổ sung",
                    "auth_params_tooltip": "Các tham số bổ sung được truyền trong yêu cầu cấp quyền. Mặc định chỉ yêu cầu các scope (openid profile), bạn có thể chỉ định thêm scope hoặc một giá trị state riêng ở đây. (ví dụ: { \"scope\": \"organizations email\", \"state\": \"secret_state\" })."
                },
                "trust_unverified_email": "Tin tưởng email chưa xác minh",
                "trust_unverified_email_label": "Luôn tin tưởng các địa chỉ email chưa xác minh do nhà cung cấp danh tính trả về",
                "trust_unverified_email_tip": "Trình kết nối Entra ID (OIDC) không trả về claim `email_verified`, nghĩa là các địa chỉ email từ Azure không được đảm bảo đã xác minh. Mặc định, Logto sẽ không đồng bộ các địa chỉ email chưa xác minh vào hồ sơ người dùng. Chỉ bật tuỳ chọn này nếu bạn tin tưởng tất cả địa chỉ email từ thư mục Entra ID.",
                "trust_unverified_email_tip_oidc": "Trình kết nối OIDC có thể không trả về claim `email_verified`, nghĩa là các địa chỉ email từ nhà cung cấp danh tính không được đảm bảo đã xác minh. Mặc định, Logto sẽ không đồng bộ các địa chỉ email chưa xác minh vào hồ sơ người dùng. Chỉ bật tuỳ chọn này nếu bạn tin tưởng tất cả địa chỉ email từ nhà cung cấp danh tính.",
                "offline_access": {
                    "label": "Làm mới access token",
                    "description": "Bật quyền truy cập `offline` của Google để yêu cầu một refresh token, cho phép ứng dụng của bạn làm mới access token mà không cần người dùng cấp quyền lại."
                }
            },
            "security": {
                "page_title": "Bảo mật",
                "title": "Bảo mật",
                "subtitle": "Cấu hình lớp bảo vệ nâng cao chống lại các cuộc tấn công tinh vi.",
                "tabs": {
                    "captcha": "CAPTCHA",
                    "password_policy": "Chính sách mật khẩu",
                    "blocklist": "Danh sách chặn",
                    "general": "Chung"
                },
                "bot_protection": {
                    "title": "Chống bot",
                    "description": "Bật CAPTCHA cho đăng ký, đăng nhập và khôi phục mật khẩu để chặn các mối đe dọa tự động.",
                    "captcha": {
                        "title": "CAPTCHA",
                        "placeholder": "Chọn một nhà cung cấp CAPTCHA và thiết lập tích hợp.",
                        "add": "Thêm CAPTCHA"
                    },
                    "settings": "Cài đặt",
                    "enable_captcha": "Bật CAPTCHA",
                    "enable_captcha_description": "Bật xác minh CAPTCHA cho các luồng đăng ký, đăng nhập và khôi phục mật khẩu.",
                    "custom_ui_captcha_notice": "Bạn đang dùng giao diện tự tạo (Bring your UI). Cần cấu hình thêm để bật CAPTCHA trong giao diện tùy chỉnh của bạn. <a>Xem hướng dẫn thiết lập</a>."
                },
                "create_captcha": {
                    "setup_captcha": "Thiết lập CAPTCHA"
                },
                "captcha_providers": {
                    "recaptcha_enterprise": {
                        "name": "reCAPTCHA Enterprise",
                        "description": "Giải pháp CAPTCHA cấp doanh nghiệp của Google, cung cấp khả năng phát hiện mối đe dọa nâng cao và phân tích bảo mật chi tiết để bảo vệ website của bạn khỏi các hành vi gian lận."
                    },
                    "turnstile": {
                        "name": "Cloudflare Turnstile",
                        "description": "Giải pháp CAPTCHA thông minh của Cloudflare, cung cấp khả năng chống bot không gây phiền hà đồng thời đảm bảo trải nghiệm người dùng liền mạch mà không cần câu đố hình ảnh."
                    }
                },
                "captcha_details": {
                    "back_to_security": "Quay lại Bảo mật",
                    "page_title": "Chi tiết CAPTCHA",
                    "check_readme": "Xem README",
                    "options_change_captcha": "Đổi nhà cung cấp CAPTCHA",
                    "connection": "Kết nối",
                    "description": "Cấu hình các kết nối captcha của bạn.",
                    "site_key": "Site key",
                    "secret_key": "Secret key",
                    "project_id": "Project ID",
                    "domain": "Tên miền (tùy chọn)",
                    "domain_placeholder": "www.google.com (mặc định) hoặc recaptcha.net",
                    "recaptcha_key_id": "reCAPTCHA key ID",
                    "recaptcha_api_key": "API key của project",
                    "deletion_description": "Bạn có chắc muốn xoá nhà cung cấp CAPTCHA này không?",
                    "captcha_deleted": "Đã xoá nhà cung cấp CAPTCHA thành công",
                    "setup_captcha": "Thiết lập CAPTCHA",
                    "mode": "Chế độ xác minh",
                    "mode_invisible": "Ẩn",
                    "mode_checkbox": "Ô đánh dấu",
                    "mode_notice": "Chế độ xác minh được xác định trong cài đặt reCAPTCHA key của bạn tại Google Cloud Console. Đổi chế độ tại đây yêu cầu một loại key phù hợp."
                },
                "password_policy": {
                    "password_requirements": "Yêu cầu mật khẩu",
                    "password_requirements_description": "Nâng cao yêu cầu mật khẩu để phòng chống tấn công dò mật khẩu (credential stuffing) và mật khẩu yếu. ",
                    "minimum_length": "Độ dài tối thiểu",
                    "minimum_length_description": "NIST khuyến nghị dùng <a>ít nhất 8 ký tự</a> cho các sản phẩm web.",
                    "minimum_length_error": "Độ dài tối thiểu phải nằm trong khoảng {{min}} đến {{max}} (bao gồm cả hai đầu).",
                    "minimum_required_char_types": "Số loại ký tự tối thiểu bắt buộc",
                    "minimum_required_char_types_description": "Các loại ký tự: chữ hoa (A-Z), chữ thường (a-z), số (0-9), và ký hiệu đặc biệt ({{symbols}}).",
                    "password_rejection": "Từ chối mật khẩu",
                    "compromised_passwords": "Từ chối mật khẩu đã bị lộ",
                    "breached_passwords": "Mật khẩu đã bị rò rỉ",
                    "breached_passwords_description": "Từ chối các mật khẩu từng xuất hiện trong các cơ sở dữ liệu rò rỉ.",
                    "restricted_phrases": "Hạn chế các cụm từ kém an toàn",
                    "restricted_phrases_tooltip": "Mật khẩu của bạn nên tránh các cụm từ này trừ khi bạn kết hợp thêm 3 ký tự trở lên.",
                    "repetitive_or_sequential_characters": "Ký tự lặp lại hoặc liên tiếp",
                    "repetitive_or_sequential_characters_description": "Ví dụ: \"AAAA\", \"1234\", và \"abcd\".",
                    "user_information": "Thông tin người dùng",
                    "user_information_description": "Ví dụ: địa chỉ email, số điện thoại, tên đăng nhập, v.v.",
                    "custom_words": "Từ tùy chỉnh",
                    "custom_words_description": "Cá nhân hoá các từ theo ngữ cảnh cụ thể, không phân biệt hoa thường, mỗi từ một dòng.",
                    "custom_words_placeholder": "Tên dịch vụ, tên công ty của bạn, v.v.",
                    "password_expiration": "Hết hạn mật khẩu",
                    "password_expiration_description": "Yêu cầu người dùng đặt lại mật khẩu sau một số ngày nhất định. Người dùng đăng nhập qua SSO hoặc passkey không bị ảnh hưởng.",
                    "enable_password_expiration": "Bật hết hạn mật khẩu",
                    "enable_password_expiration_description": "Yêu cầu người dùng định kỳ đặt lại mật khẩu. Người dùng hiện có mà chưa ghi nhận ngày đổi mật khẩu sẽ được tính từ ngày chính sách này được bật.",
                    "enable_password_expiration_tip": "Hết hạn mật khẩu chỉ có thể bật sau khi bạn cấu hình ít nhất một phương thức quên mật khẩu với trình kết nối hợp lệ trong trải nghiệm đăng nhập.",
                    "expiration_period": "Thời hạn hiệu lực mật khẩu (ngày)",
                    "expiration_period_description": "Số ngày mật khẩu còn hiệu lực trước khi hết hạn.",
                    "expiration_period_error": "Thời hạn hiệu lực mật khẩu phải nằm trong khoảng {{min}} đến {{max}} ngày.",
                    "password_expiration_recovery_reminder": "Một số người dùng có thể không có địa chỉ email hoặc số điện thoại để nhận mã khôi phục mật khẩu, nên họ sẽ không thể đặt lại mật khẩu đã hết hạn. Hãy yêu cầu email hoặc số điện thoại khi đăng ký để đảm bảo mọi người dùng đều có thể khôi phục mật khẩu."
                },
                "verification_code_policy": {
                    "card_title": "Mã xác minh",
                    "card_description": "Cấu hình thời gian hết hạn và số lần thử lại tối đa cho mã xác minh dùng trong luồng đăng nhập, đăng ký và đặt lại mật khẩu.",
                    "enable": {
                        "title": "Tùy chỉnh cài đặt mã xác minh",
                        "description": "Cho phép tùy chỉnh thời gian hết hạn và số lần thử lại tối đa của mã xác minh."
                    },
                    "expiration_duration": {
                        "title": "Thời gian hết hạn (giây)",
                        "description": "Thời gian tính bằng giây mà mã xác minh còn hiệu lực sau khi được gửi.",
                        "error_message": "Thời gian hết hạn phải nằm trong khoảng 60 đến 3600 giây."
                    },
                    "max_retry_attempts": {
                        "title": "Số lần thử lại tối đa",
                        "description": "Số lần xác minh thất bại tối đa được phép trước khi mã bị vô hiệu.",
                        "error_message": "Số lần thử lại tối đa phải nằm trong khoảng 1 đến 100."
                    }
                },
                "sentinel_policy": {
                    "card_title": "Khoá định danh",
                    "card_description": "Việc khoá áp dụng cho mọi người dùng với cài đặt mặc định, nhưng bạn có thể tùy chỉnh để kiểm soát nhiều hơn.\n\nTạm thời khoá một định danh sau nhiều lần xác thực thất bại (vd: nhập sai mật khẩu hoặc mã xác minh liên tiếp) để ngăn tấn công dò mật khẩu (brute force).",
                    "enable_sentinel_policy": {
                        "title": "Tùy chỉnh trải nghiệm khoá",
                        "description": "Cho phép tùy chỉnh số lần đăng nhập thất bại tối đa trước khi khoá, thời gian khoá, và mở khoá thủ công tức thì."
                    },
                    "max_attempts": {
                        "title": "Số lần thất bại tối đa",
                        "description": "Tạm thời khoá một định danh khi đạt số lần đăng nhập thất bại tối đa trong một giờ.",
                        "error_message": "Số lần thất bại tối đa phải lớn hơn 0."
                    },
                    "lockout_duration": {
                        "title": "Thời gian khoá (phút)",
                        "description": "Chặn đăng nhập trong một khoảng thời gian sau khi vượt quá giới hạn số lần thất bại tối đa.",
                        "error_message": "Thời gian khoá phải ít nhất 1 phút."
                    },
                    "manual_unlock": {
                        "title": "Mở khoá thủ công",
                        "description": "Mở khoá người dùng ngay lập tức bằng cách xác nhận danh tính và nhập định danh của họ.",
                        "unblock_by_identifiers": "Bỏ chặn theo định danh",
                        "modal_description_1": "Một định danh đã bị tạm khoá do nhiều lần đăng nhập/đăng ký thất bại. Để bảo vệ an toàn, quyền truy cập sẽ tự động khôi phục sau khi hết thời gian khoá.",
                        "modal_description_2": " Chỉ mở khoá thủ công nếu bạn đã xác nhận danh tính người dùng và chắc chắn không có nỗ lực truy cập trái phép.",
                        "placeholder": "Nhập định danh (địa chỉ email / số điện thoại / tên đăng nhập)",
                        "confirm_button_text": "Mở khoá ngay",
                        "success_toast": "Đã mở khoá thành công",
                        "duplicate_identifier_error": "Định danh đã được thêm",
                        "empty_identifier_error": "Vui lòng nhập ít nhất một định danh"
                    }
                },
                "blocklist": {
                    "card_title": "Danh sách chặn email",
                    "card_description": "Kiểm soát tập người dùng của bạn bằng cách chặn các địa chỉ email rủi ro cao hoặc không mong muốn.",
                    "disposable_email": {
                        "title": "Chặn địa chỉ email dùng một lần",
                        "description": "Bật để từ chối mọi lượt đăng ký dùng địa chỉ email dùng một lần hoặc email tạm, giúp ngăn spam và nâng cao chất lượng người dùng."
                    },
                    "email_subaddressing": {
                        "title": "Chặn email subaddressing",
                        "description": "Bật để từ chối mọi lượt đăng ký dùng email subaddress với dấu cộng (+) và các ký tự bổ sung (vd: user+alias@foo.com)."
                    },
                    "custom_email_address": {
                        "title": "Chặn địa chỉ email tùy chỉnh",
                        "description": "Thêm các tên miền email hoặc địa chỉ email cụ thể không được đăng ký hoặc liên kết qua giao diện.",
                        "placeholder": "Nhập địa chỉ email hoặc tên miền bị chặn (vd: bar@example.com, @example.com)",
                        "duplicate_error": "Địa chỉ email hoặc tên miền đã được thêm",
                        "invalid_format_error": "Phải là địa chỉ email hợp lệ (bar@example.com) hoặc tên miền (@example.com)"
                    }
                }
            },
            "get_started": {
                "page_title": "Bắt đầu",
                "title": "Vài điều giúp bạn thành công",
                "subtitle": "Một số việc bạn có thể làm để nhanh chóng khai thác giá trị của Logto",
                "develop": {
                    "title": "Phát triển: Dành 5 phút để tích hợp ứng dụng của bạn",
                    "title_cloud": "Phát triển: Tích hợp ứng dụng an toàn chỉ trong vài phút",
                    "subtitle_cloud": "Hoặc dành 5 phút để tích hợp ứng dụng với các SDK và hướng dẫn dựng sẵn của chúng tôi.",
                    "try_mcp": "Thử tích hợp bằng một câu lệnh với MCP"
                },
                "customize": {
                    "title": "Tuỳ chỉnh: Mang đến trải nghiệm đăng nhập tuyệt vời",
                    "preview": {
                        "title": "Xem trực tiếp trải nghiệm đăng nhập bạn vừa tuỳ chỉnh",
                        "subtitle": "Thử trải nghiệm đăng nhập Logto ngay để xem cách nó hoạt động"
                    },
                    "connector": {
                        "title": "Thêm trình kết nối để hỗ trợ nhiều phương thức đăng nhập mạng xã hội hơn",
                        "subtitle": "Thử đăng nhập không mật khẩu và mang lại trải nghiệm an toàn, mượt mà cho khách hàng của bạn"
                    },
                    "continue_customizing": "Tiếp tục tuỳ chỉnh",
                    "try_now": "Thử ngay",
                    "add_more": "Thêm nữa"
                },
                "secure": {
                    "title": "Bảo mật: Bảo vệ tài nguyên của bạn"
                },
                "manage": {
                    "title": "Quản lý: Xác định kiểm soát truy cập cho sản phẩm và người dùng của bạn",
                    "rbac": {
                        "title": "Thêm kiểm soát truy cập theo vai trò để bảo vệ tài nguyên của bạn",
                        "subtitle": "Kiểm soát tài nguyên thông qua phân quyền theo vai trò có khả năng mở rộng cho nhiều tình huống sử dụng khác nhau."
                    },
                    "create_roles": "Tạo vai trò"
                },
                "convert_to_production": {
                    "card_title": "Sẵn sàng vận hành? Đừng quên khởi chạy thiết lập môi trường production của bạn!",
                    "title": "Đừng để dự án của bạn kẹt mãi ở chế độ dev",
                    "subtitle": "Bạn đang dùng tenant dev để kiểm thử miễn phí. Để vận hành, hãy tạo hoặc chuyển đổi sang tenant production. Cần điều gì tuỳ chỉnh? <a>Liên hệ chúng tôi</a>",
                    "convert_button": "Chuyển sang tenant production"
                },
                "oss_cloud": {
                    "try": {
                        "title": "Bỏ qua việc vận hành — dùng thử Logto Cloud miễn phí",
                        "badge": "Khuyến nghị",
                        "description": "Nhận một Logto được quản lý trọn gói mà không cần bảo trì — cùng với tích hợp nhanh bằng MCP, hỗ trợ đa tenant, cộng tác nhóm và tất cả tính năng cao cấp. Miễn phí để bắt đầu, không cần thẻ tín dụng.",
                        "action": "Khám phá Logto Cloud"
                    },
                    "private_cloud": {
                        "title": "Cần tuân thủ quy định hoặc triển khai tuỳ chỉnh?",
                        "card_title": "Private cloud",
                        "description": "Nhận một phiên bản Logto riêng với cách ly dữ liệu hoàn toàn, tên miền tuỳ chỉnh và cam kết SLA. Hoàn hảo cho doanh nghiệp có yêu cầu nghiêm ngặt về nơi lưu trữ dữ liệu hoặc tuân thủ quy định. Chúng tôi lo phần hạ tầng để bạn tập trung vào sản phẩm của mình."
                    },
                    "sidebar": {
                        "title": "Tập trung xây dựng, không phải vận hành hạ tầng.",
                        "description": "Hãy để Logto Cloud lo phần hạ tầng xác thực cho bạn.",
                        "action": "Dùng thử Logto Cloud"
                    }
                },
                "view_all": "Xem tất cả →"
            },
            "users": {
                "page_title": "Quản lý người dùng",
                "title": "Quản lý người dùng",
                "subtitle": "Quản lý danh tính người dùng gồm tạo người dùng, sửa thông tin, xem nhật ký, đặt lại mật khẩu và xoá người dùng.",
                "create": "Thêm người dùng",
                "create_subtitle": "Cung cấp ít nhất một trong các trường sau để tiếp tục.",
                "error_missing_identifier": "Bạn phải cung cấp ít nhất một định danh để tạo người dùng.",
                "user_name": "Người dùng",
                "application_name": "Từ ứng dụng",
                "latest_sign_in": "Đăng nhập gần nhất",
                "create_form_username": "Tên đăng nhập",
                "create_form_password": "Mật khẩu",
                "create_form_name": "Họ và tên",
                "placeholder_name": "Nguyễn Văn A",
                "placeholder_email": "vana@example.com",
                "placeholder_username": "nguoidung123",
                "placeholder_phone": "+84 90 555 5555",
                "unnamed": "Chưa đặt tên",
                "search": "Tìm theo tên, email, số điện thoại hoặc tên đăng nhập",
                "check_user_detail": "Xem chi tiết người dùng",
                "placeholder_title": "Quản lý người dùng",
                "placeholder_description": "Mỗi người dùng có một hồ sơ chứa toàn bộ thông tin. Gồm dữ liệu cơ bản, danh tính mạng xã hội và dữ liệu tuỳ chỉnh.",
                "dev_tenant_data_retention_notice": "Trong tenant phát triển, tài khoản người dùng cũ hơn 90 ngày sẽ tự động bị xoá. <a>Tìm hiểu thêm</a>"
            },
            "user_details": {
                "page_title": "Chi tiết người dùng",
                "back_to_users": "Quay lại quản lý người dùng",
                "created_title": "Người dùng này đã được tạo thành công",
                "created_guide": "Dưới đây là thông tin để hỗ trợ người dùng trong quá trình đăng nhập.",
                "created_email": "Địa chỉ email:",
                "created_phone": "Số điện thoại:",
                "created_username": "Tên đăng nhập:",
                "created_password": "Mật khẩu:",
                "menu_delete": "Xoá",
                "delete_description": "Hành động này không thể hoàn tác. Nó sẽ xoá vĩnh viễn người dùng.",
                "deleted": "Người dùng đã được xoá thành công",
                "reset_password": {
                    "reset_title": "Bạn có chắc muốn đặt lại mật khẩu?",
                    "generate_title": "Bạn có chắc muốn tạo mật khẩu mới?",
                    "content": "Hành động này không thể hoàn tác. Nó sẽ cập nhật thông tin đăng nhập của người dùng.",
                    "reset_complete": "Mật khẩu đã được đặt lại",
                    "generate_complete": "Mật khẩu đã được tạo",
                    "new_password": "Mật khẩu mới:",
                    "password": "Mật khẩu:"
                },
                "expire_password": {
                    "button": "Hết hạn",
                    "title": "Bạn có chắc muốn cho mật khẩu này hết hạn?",
                    "content": "Người dùng sẽ phải đặt lại mật khẩu trong lần đăng nhập tiếp theo. Hành động này không thể hoàn tác.",
                    "success": "Mật khẩu của người dùng đã được đánh dấu là hết hạn.",
                    "not_enabled_tooltip": "Chính sách hết hạn mật khẩu chưa được bật."
                },
                "tab_settings": "Cài đặt",
                "tab_roles": "Vai trò",
                "tab_logs": "Nhật ký người dùng",
                "tab_organizations": "Tổ chức",
                "authentication": "Xác thực",
                "authentication_description": "Mỗi người dùng có một hồ sơ chứa toàn bộ thông tin người dùng, gồm dữ liệu cơ bản, danh tính mạng xã hội và dữ liệu tuỳ chỉnh.",
                "user_profile": "Dữ liệu người dùng",
                "field_email": "Địa chỉ email",
                "field_phone": "Số điện thoại",
                "field_username": "Tên đăng nhập",
                "field_password": "Mật khẩu",
                "field_name": "Tên",
                "field_avatar": "URL ảnh đại diện",
                "field_avatar_placeholder": "https://your.cdn.domain/avatar.png",
                "field_custom_data": "Dữ liệu tuỳ chỉnh",
                "field_custom_data_tip": "Thông tin bổ sung của người dùng không nằm trong các thuộc tính người dùng định sẵn, chẳng hạn màu sắc và ngôn ngữ ưa thích của người dùng.",
                "field_profile": "Hồ sơ",
                "field_profile_tip": "Các claim chuẩn OpenID Connect bổ sung không có trong thuộc tính của người dùng. Lưu ý rằng mọi thuộc tính không xác định sẽ bị loại bỏ. Vui lòng tham khảo <a>tài liệu thuộc tính hồ sơ</a> để biết thêm thông tin.",
                "field_connectors": "Kết nối mạng xã hội",
                "field_sso_connectors": "Kết nối doanh nghiệp",
                "custom_data_invalid": "Dữ liệu tuỳ chỉnh phải là một đối tượng JSON hợp lệ",
                "profile_invalid": "Hồ sơ phải là một đối tượng JSON hợp lệ",
                "password_already_set": "Đã đặt mật khẩu",
                "no_password_set": "Chưa đặt mật khẩu",
                "connectors": {
                    "connectors": "Trình kết nối",
                    "user_id": "ID người dùng",
                    "remove": "Xoá",
                    "connected": "Người dùng này được kết nối với nhiều trình kết nối mạng xã hội.",
                    "not_connected": "Người dùng chưa được kết nối với trình kết nối mạng xã hội nào",
                    "deletion_confirmation": "Bạn đang xoá danh tính <name/> hiện có. Bạn có chắc muốn tiếp tục?"
                },
                "sso_connectors": {
                    "connectors": "Trình kết nối",
                    "enterprise_id": "ID doanh nghiệp",
                    "connected": "Người dùng này được kết nối với nhiều nhà cung cấp danh tính doanh nghiệp để Đăng nhập một lần (SSO).",
                    "not_connected": "Người dùng chưa được kết nối với nhà cung cấp danh tính doanh nghiệp nào để Đăng nhập một lần (SSO)."
                },
                "mfa": {
                    "field_name": "Xác thực đa yếu tố",
                    "field_description": "Người dùng này đã bật các yếu tố xác minh 2 bước.",
                    "name_column": "Đa yếu tố",
                    "field_description_empty": "Người dùng này chưa bật các yếu tố xác minh 2 bước.",
                    "deletion_confirmation": "Bạn đang xoá <name/> hiện có dùng cho xác minh 2 bước. Bạn có chắc muốn tiếp tục?"
                },
                "passkey": {
                    "field_name": "Passkey",
                    "field_description_empty": "Người dùng này chưa bật đăng nhập bằng passkey.",
                    "deletion_confirmation": "Bạn đang xoá <name/> hiện có dùng cho đăng nhập bằng passkey. Bạn có chắc muốn tiếp tục?"
                },
                "suspended": "Đã tạm ngưng",
                "suspend_user": "Tạm ngưng người dùng",
                "suspend_user_reminder": "Bạn có chắc muốn tạm ngưng người dùng này? Người dùng sẽ không thể đăng nhập vào ứng dụng của bạn và không thể lấy access token mới sau khi token hiện tại hết hạn. Ngoài ra, mọi yêu cầu API do người dùng này thực hiện sẽ thất bại.",
                "suspend_action": "Tạm ngưng",
                "user_suspended": "Người dùng đã bị tạm ngưng.",
                "reactivate_user": "Kích hoạt lại người dùng",
                "reactivate_user_reminder": "Bạn có chắc muốn kích hoạt lại người dùng này? Việc này sẽ cho phép mọi lượt đăng nhập của người dùng này.",
                "reactivate_action": "Kích hoạt lại",
                "user_reactivated": "Người dùng đã được kích hoạt lại.",
                "roles": {
                    "name_column": "Vai trò người dùng",
                    "description_column": "Mô tả",
                    "assign_button": "Gán vai trò",
                    "delete_description": "Hành động này sẽ gỡ vai trò này khỏi người dùng. Vai trò vẫn tồn tại, nhưng sẽ không còn liên kết với người dùng này.",
                    "deleted": "{{name}} đã được gỡ khỏi người dùng này thành công.",
                    "assign_title": "Gán vai trò cho {{name}}",
                    "assign_subtitle": "Tìm vai trò người dùng phù hợp bằng cách tìm theo tên, mô tả hoặc ID vai trò.",
                    "assign_role_field": "Gán vai trò",
                    "role_search_placeholder": "Tìm theo tên vai trò",
                    "added_text": "Đã thêm {{value, number}}",
                    "assigned_user_count": "{{value, number}} người dùng",
                    "confirm_assign": "Gán vai trò",
                    "role_assigned": "Đã gán vai trò thành công",
                    "search": "Tìm theo tên vai trò, mô tả hoặc ID",
                    "empty": "Không có vai trò nào"
                },
                "warning_no_sign_in_identifier": "Người dùng cần có ít nhất một định danh đăng nhập (tên đăng nhập, email, số điện thoại hoặc mạng xã hội) để đăng nhập. Bạn có chắc muốn tiếp tục?",
                "personal_access_tokens": {
                    "title": "Personal access token",
                    "title_other": "Personal access token",
                    "title_short": "token",
                    "empty": "Người dùng không có personal access token nào.",
                    "create": "Tạo token mới",
                    "tip": "Personal access token (PAT) cung cấp cách an toàn để người dùng cấp access token mà không cần dùng thông tin đăng nhập và đăng nhập tương tác. Điều này hữu ích cho CI/CD, script, hoặc ứng dụng cần truy cập tài nguyên theo chương trình.",
                    "value": "Giá trị",
                    "created_at": "Tạo lúc",
                    "expires_at": "Hết hạn lúc",
                    "never": "Không bao giờ",
                    "create_new_token": "Tạo token mới",
                    "delete_confirmation": "Hành động này không thể hoàn tác. Bạn có chắc muốn xoá token này?",
                    "expired": "Đã hết hạn",
                    "expired_tooltip": "Token này đã hết hạn vào {{date}}.",
                    "create_modal": {
                        "title": "Tạo personal access token",
                        "expiration": "Thời hạn",
                        "expiration_description": "Token sẽ hết hạn vào {{date}}.",
                        "expiration_description_never": "Token sẽ không bao giờ hết hạn. Chúng tôi khuyến nghị đặt ngày hết hạn để tăng cường bảo mật.",
                        "days": "{{count}} ngày",
                        "days_other": "{{count}} ngày",
                        "created": "Token {{name}} đã được tạo thành công."
                    },
                    "edit_modal": {
                        "title": "Sửa personal access token",
                        "edited": "Token {{name}} đã được sửa thành công."
                    }
                },
                "sessions": {
                    "title": "Phiên",
                    "description": "Quản lý các phiên được duy trì bởi Máy chủ Cấp quyền Logto. Việc thu hồi một phiên Logto tại đây sẽ ngăn tự động chấp thuận ở các yêu cầu cấp quyền sau này.",
                    "field_name": "Phiên",
                    "multiple_signed_in": "Người dùng này đã đăng nhập trên nhiều thiết bị hoặc trình duyệt.",
                    "not_found": "Không tìm thấy phiên Logto đang hoạt động nào. Hiện người dùng không đăng nhập trên thiết bị nào.",
                    "name_column": "Tên",
                    "session_id_column": "ID phiên",
                    "location_column": "Vị trí",
                    "browser_on_os": "{{browser}} trên {{os}}",
                    "user": "Người dùng",
                    "applications": "Ứng dụng",
                    "signed_in_at": "Đăng nhập gần nhất",
                    "ip": "IP",
                    "browser_name": "Tên trình duyệt",
                    "os_name": "Tên hệ điều hành",
                    "device_model": "Kiểu thiết bị",
                    "revoke_session": "Thu hồi phiên",
                    "revoke_session_confirmation": "Nếu bạn gỡ phiên này, người dùng sẽ buộc phải xác thực lại."
                },
                "third_party_apps": {
                    "title": "Ứng dụng bên thứ ba",
                    "description": "Dùng Logto làm nhà cung cấp danh tính để cấp quyền cho ứng dụng bên thứ ba. Xem và quản lý các ứng dụng mà người dùng này đã cấp quyền truy cập.",
                    "field_name": "Ứng dụng bên thứ ba đã cấp quyền",
                    "multiple_authorized": "Người dùng này đã cấp quyền cho nhiều ứng dụng và dịch vụ bên thứ ba.",
                    "not_authorized": "Người dùng này chưa cấp quyền cho ứng dụng hoặc dịch vụ bên thứ ba nào.",
                    "name_column": "Tên",
                    "app_id_column": "ID ứng dụng",
                    "access_created_at_column": "Quyền truy cập tạo lúc",
                    "revoke_access_title": "Thu hồi quyền truy cập?",
                    "revoke_access_description": "Việc này sẽ thu hồi quyền truy cập của ứng dụng vào tài khoản của người dùng này trên mọi thiết bị. Người dùng phải cấp quyền lại để khôi phục truy cập."
                },
                "connections": {
                    "title": "Kết nối",
                    "description": "Người dùng liên kết tài khoản bên thứ ba để đăng nhập mạng xã hội, SSO doanh nghiệp, hoặc truy cập tài nguyên.",
                    "token_status_column": "Trạng thái token",
                    "token_status": {
                        "active": "Đang hoạt động",
                        "expired": "Đã hết hạn",
                        "inactive": "Không hoạt động",
                        "not_applicable": "Không áp dụng",
                        "available": "Khả dụng",
                        "not_available": "Không khả dụng"
                    }
                }
            },
            "contact": {
                "title": "Nhận trợ giúp",
                "description": "Để yêu cầu trợ giúp hoặc góp ý sản phẩm, vui lòng liên hệ chúng tôi qua các cách sau.",
                "discord": {
                    "title": "Tham gia cộng đồng Discord",
                    "description": "Kết nối với các nhà phát triển khác để tìm giải pháp",
                    "button": "Tham gia"
                },
                "github": {
                    "title": "Trao đổi trên GitHub",
                    "description": "Tạo issue và gửi trên GitHub",
                    "button": "Mở"
                },
                "email": {
                    "title": "Liên hệ hỗ trợ qua email",
                    "description": "Gửi email cho chúng tôi để biết thêm thông tin và trợ giúp",
                    "button": "Gửi"
                },
                "reserve": {
                    "title": "Đặt lịch với đội ngũ Logto",
                    "description": "Đặt nhanh một buổi trò chuyện trực tiếp",
                    "button": "Đặt lịch"
                }
            },
            "sign_in_exp": {
                "page_title": "Trải nghiệm đăng nhập",
                "page_title_with_account": "Đăng nhập & tài khoản",
                "title": "Đăng nhập & tài khoản",
                "description": "Tuỳ chỉnh các luồng xác thực và giao diện, đồng thời xem trước trải nghiệm mặc định theo thời gian thực.",
                "tabs": {
                    "branding": "Thương hiệu",
                    "sign_up_and_sign_in": "Đăng ký và đăng nhập",
                    "collect_user_profile": "Thu thập hồ sơ người dùng",
                    "account_center": "Trung tâm tài khoản",
                    "content": "Nội dung",
                    "password_policy": "Chính sách mật khẩu"
                },
                "welcome": {
                    "title": "Tuỳ chỉnh trải nghiệm đăng nhập",
                    "description": "Bắt đầu nhanh với thiết lập đăng nhập đầu tiên của bạn. Hướng dẫn này sẽ dẫn bạn qua tất cả các cài đặt cần thiết.",
                    "get_started": "Bắt đầu",
                    "apply_remind": "Xin lưu ý rằng trải nghiệm đăng nhập sẽ áp dụng cho tất cả ứng dụng thuộc tài khoản này."
                },
                "color": {
                    "title": "MÀU SẮC",
                    "primary_color": "Màu thương hiệu",
                    "dark_primary_color": "Màu thương hiệu (tối)",
                    "dark_mode": "Bật chế độ tối",
                    "dark_mode_description": "Ứng dụng của bạn sẽ có giao diện chế độ tối được tạo tự động dựa trên màu thương hiệu và thuật toán của Logto. Bạn có thể tuỳ chỉnh thoải mái.",
                    "dark_mode_reset_tip": "Tính lại màu chế độ tối dựa trên màu thương hiệu.",
                    "reset": "Tính lại"
                },
                "branding": {
                    "title": "KHU VỰC THƯƠNG HIỆU",
                    "ui_style": "Kiểu",
                    "with_light": "{{value}}",
                    "with_dark": "{{value}} (tối)",
                    "app_logo_and_favicon": "Logo ứng dụng và favicon",
                    "company_logo_and_favicon": "Logo công ty và favicon",
                    "organization_logo_and_favicon": "Logo tổ chức và favicon",
                    "hide_logto_branding": "Ẩn thương hiệu Logto",
                    "hide_logto_branding_description": "Loại bỏ dòng \"Powered by Logto\". Làm nổi bật thương hiệu của bạn một cách độc quyền với trải nghiệm đăng nhập gọn gàng, chuyên nghiệp.",
                    "hide_logto_branding_oss_note": "Tính năng này có sẵn tự nhiên trên <a>Logto Cloud</a>."
                },
                "branding_uploads": {
                    "app_logo": {
                        "title": "Logo ứng dụng",
                        "url": "URL logo ứng dụng",
                        "url_placeholder": "https://your.cdn.domain/logo.png",
                        "error": "Logo ứng dụng: {{error}}"
                    },
                    "company_logo": {
                        "title": "Logo công ty",
                        "url": "URL logo công ty",
                        "url_placeholder": "https://your.cdn.domain/logo.png",
                        "error": "Logo công ty: {{error}}"
                    },
                    "organization_logo": {
                        "title": "Tải ảnh lên",
                        "url": "URL logo tổ chức",
                        "url_placeholder": "https://your.cdn.domain/logo.png",
                        "error": "Logo tổ chức: {{error}}"
                    },
                    "connector_logo": {
                        "title": "Tải ảnh lên",
                        "url": "URL logo trình kết nối",
                        "url_placeholder": "https://your.cdn.domain/logo.png",
                        "error": "Logo trình kết nối: {{error}}"
                    },
                    "favicon": {
                        "title": "Favicon",
                        "url": "URL favicon",
                        "url_placeholder": "https://your.cdn.domain/favicon.ico",
                        "error": "Favicon: {{error}}"
                    }
                },
                "custom_ui": {
                    "title": "Giao diện tuỳ chỉnh",
                    "cloud_tag": "Cloud",
                    "css_code_editor_title": "CSS tuỳ chỉnh",
                    "css_code_editor_field_title": "Ghi đè CSS",
                    "css_code_editor_description1": "Xem ví dụ về CSS tuỳ chỉnh.",
                    "css_code_editor_description2": "<a>{{link}}</a>",
                    "css_code_editor_description_link_content": "Tìm hiểu thêm",
                    "css_code_editor_content_placeholder": "Nhập các ghi đè CSS của bạn tại đây để điều chỉnh kiểu dáng của mọi thứ theo đúng ý bạn. Thể hiện sự sáng tạo và làm cho giao diện của bạn nổi bật.",
                    "bring_your_ui_title": "Mang giao diện của riêng bạn",
                    "bring_your_ui_upload_title": "Tải lên tài nguyên giao diện tuỳ chỉnh",
                    "bring_your_ui_description": "Tải lên một gói nén (.zip) để thay thế giao diện dựng sẵn của Logto bằng mã của riêng bạn. <a>Tìm hiểu thêm</a>",
                    "bring_your_ui_oss_description": "Tuỳ chỉnh giao diện đăng nhập bằng mã của riêng bạn.",
                    "bring_your_ui_oss_card_description": "Tải giao diện đăng nhập tuỳ chỉnh của bạn trực tiếp trên <a>Logto Cloud</a>. Không cần fork và triển khai lại.",
                    "bring_your_ui_oss_try_cloud": "Thử Cloud",
                    "preview_with_bring_your_ui_description": "Tài nguyên giao diện tuỳ chỉnh của bạn đã được tải lên thành công và đang được phục vụ. Do đó, cửa sổ xem trước tích hợp đã bị tắt.\nĐể kiểm thử giao diện đăng nhập cá nhân hoá của bạn, hãy nhấn nút \"Xem trực tiếp\" để mở trong một tab trình duyệt mới.",
                    "csp_description": "Cho phép thêm các biểu thức nguồn cho giao diện đăng nhập tuỳ chỉnh của bạn. Các giá trị này chỉ được áp dụng khi tài nguyên giao diện tuỳ chỉnh được phục vụ.",
                    "csp_script_src": "script-src được phép",
                    "csp_script_src_tip": "Cho phép các biểu thức nguồn HTTPS cho các script được tải bởi giao diện tuỳ chỉnh của bạn, chẳng hạn https://scripts.example.com hoặc https://*.example.com.",
                    "csp_connect_src": "connect-src được phép",
                    "csp_connect_src_tip": "Cho phép các biểu thức nguồn HTTPS hoặc WSS cho các yêu cầu mạng do giao diện tuỳ chỉnh của bạn thực hiện, chẳng hạn https://api.example.com hoặc wss://events.example.com.",
                    "csp_source_invalid_error": "Nhập một biểu thức nguồn hợp lệ. Dùng URL https://; connect-src cũng hỗ trợ wss://. Không hỗ trợ từ khoá CSP và dấu chấm phẩy.",
                    "csp_source_duplicate_error": "Biểu thức nguồn này đã có trong danh sách."
                },
                "account_center": {
                    "title": "TRUNG TÂM TÀI KHOẢN",
                    "description": "Triển khai trung tâm tài khoản của bạn để người dùng cuối quản lý bảo mật tài khoản và thông tin hồ sơ.",
                    "enable_account_api": "Bật trung tâm tài khoản và Account API",
                    "enable_account_api_description": "Bật cả Account API hướng người dùng và trung tâm tài khoản mặc định của Logto. Khi tắt, cả hai tính năng đều không khả dụng.",
                    "field_options": {
                        "off": "Tắt",
                        "edit": "Sửa",
                        "read_only": "Chỉ đọc",
                        "enabled": "Đã bật",
                        "disabled": "Đã tắt"
                    },
                    "sections": {
                        "account_security": {
                            "title": "BẢO MẬT TÀI KHOẢN",
                            "description": "Quản lý quyền truy cập vào Account API, cho phép người dùng xem hoặc chỉnh sửa thông tin danh tính và các yếu tố xác thực của họ sau khi đăng nhập vào ứng dụng.",
                            "security_verification": {
                                "title": "Xác minh bảo mật",
                                "description": "Trước khi thay đổi cài đặt bảo mật, người dùng phải xác minh danh tính để nhận một ID bản ghi xác minh có hiệu lực 10 phút. Để bật một phương thức xác minh (email, điện thoại, mật khẩu), hãy đặt quyền Account API thành <strong>Chỉ đọc</strong> (tối thiểu) hoặc <strong>Sửa</strong> bên dưới để hệ thống có thể phát hiện người dùng đã cấu hình phương thức đó hay chưa. <a>Tìm hiểu thêm</a>"
                            },
                            "groups": {
                                "identifiers": {
                                    "title": "Định danh"
                                },
                                "authentication_factors": {
                                    "title": "Yếu tố xác thực"
                                },
                                "session_management": {
                                    "title": "Quản lý phiên"
                                }
                            }
                        },
                        "user_profile": {
                            "title": "HỒ SƠ NGƯỜI DÙNG",
                            "description": "Quản lý quyền truy cập vào Account API, cho phép người dùng xem hoặc chỉnh sửa dữ liệu hồ sơ cơ bản hoặc tuỳ chỉnh sau khi đăng nhập vào ứng dụng.",
                            "groups": {
                                "profile_data": {
                                    "title": "Dữ liệu hồ sơ"
                                }
                            }
                        },
                        "secret_vault": {
                            "title": "KHO BÍ MẬT",
                            "description": "Đối với trình kết nối mạng xã hội và doanh nghiệp, lưu trữ an toàn các token truy cập của bên thứ ba để gọi API của họ (ví dụ: thêm sự kiện vào Google Calendar).",
                            "third_party_token_storage": {
                                "title": "Token bên thứ ba",
                                "third_party_access_token_retrieval": "Lấy token truy cập của bên thứ ba",
                                "third_party_token_tooltip": "Để lưu trữ token, bạn có thể bật tính năng này trong cài đặt của trình kết nối mạng xã hội hoặc doanh nghiệp tương ứng.",
                                "third_party_token_description": "Sau khi bật Account API, việc lấy token của bên thứ ba sẽ được kích hoạt tự động."
                            }
                        }
                    },
                    "fields": {
                        "email": "Địa chỉ email",
                        "phone": "Số điện thoại",
                        "social": "Danh tính mạng xã hội",
                        "password": "Mật khẩu",
                        "mfa": "Xác thực đa yếu tố",
                        "mfa_description": "Cho phép người dùng quản lý các phương thức MFA của họ từ trung tâm tài khoản.",
                        "passkey": "Passkey",
                        "username": "Tên đăng nhập",
                        "name": "Tên",
                        "avatar": "Ảnh đại diện",
                        "profile": "Hồ sơ",
                        "profile_description": "Kiểm soát quyền truy cập vào các thuộc tính hồ sơ có cấu trúc.",
                        "custom_data": "Dữ liệu tuỳ chỉnh",
                        "custom_data_description": "Kiểm soát quyền truy cập vào dữ liệu JSON tuỳ chỉnh được lưu trên người dùng.",
                        "sessions": "Phiên"
                    },
                    "profile_fields": {
                        "title": "Trường hồ sơ cho trung tâm tài khoản dựng sẵn",
                        "add_profile_fields": "Thêm trường hồ sơ",
                        "hint": {
                            "not_in_list": "Không có trong danh sách?",
                            "set_up": "Thiết lập",
                            "go_to": "các trường hồ sơ khác ngay."
                        },
                        "disabled_hint": {
                            "name": "Để thêm trường này, trước tiên hãy đặt quyền 'Tên' thành 'Sửa / Chỉ đọc' trong phần Hồ sơ người dùng bên dưới.",
                            "avatar": "Để thêm trường này, trước tiên hãy đặt quyền 'Ảnh đại diện' thành 'Sửa / Chỉ đọc' trong phần Hồ sơ người dùng bên dưới.",
                            "profile": "Để thêm trường này, trước tiên hãy đặt quyền 'Hồ sơ' thành 'Sửa / Chỉ đọc' trong phần Hồ sơ người dùng bên dưới.",
                            "custom_data": "Để thêm trường này, trước tiên hãy đặt quyền 'Dữ liệu tuỳ chỉnh' thành 'Sửa / Chỉ đọc' trong phần Hồ sơ người dùng bên dưới."
                        }
                    },
                    "webauthn_related_origins": "Origin liên quan của WebAuthn",
                    "webauthn_related_origins_description": "Thêm các domain của những ứng dụng front-end được phép đăng ký passkey thông qua Account API.",
                    "webauthn_related_origins_error": "Origin phải bắt đầu bằng https:// hoặc http://",
                    "delete_account_url": "Xoá tài khoản",
                    "delete_account_url_description": "Cung cấp URL endpoint của riêng bạn để xử lý việc xoá tài khoản với logic tuỳ chỉnh.",
                    "prebuilt_ui": {
                        "title": "TÍCH HỢP GIAO DIỆN DỰNG SẴN",
                        "description": "Nhanh chóng tích hợp trung tâm tài khoản mặc định, xác minh bảo mật, hoặc một luồng cập nhật hồ sơ đơn lẻ với giao diện dựng sẵn. Chỉ cần kết hợp domain của bạn với route để tạo URL trung tâm tài khoản (ví dụ: https://auth.foo.com/account/email).",
                        "permission_notice": "Để tích hợp các luồng dựng sẵn này, hãy đặt các quyền Account API liên quan thành <strong>Sửa</strong> trong phần cài đặt bên dưới.",
                        "account_center_title": "Tích hợp trung tâm tài khoản mặc định",
                        "account_center_description": "Điều hướng người dùng đến trung tâm tài khoản để quản lý các cài đặt bảo mật như email, điện thoại, tên đăng nhập, mật khẩu, MFA và các tài khoản đã liên kết.",
                        "flows_title": "Tích hợp các luồng cài đặt bảo mật mặc định",
                        "single_task_flows_title": "Tích hợp một luồng tác vụ đơn lẻ mặc định",
                        "flows_description": "Kết hợp domain của bạn với route để tạo URL cài đặt tài khoản (ví dụ: https://auth.foo.com/account/email). Tuỳ chọn thêm `redirect=` để đưa người dùng trở lại ứng dụng của bạn sau khi cập nhật thành công, `show_success=true` để giữ trang thành công hiển thị, `ui_locales=` để ghi đè ngôn ngữ mặc định, hoặc `identifier=` để điền sẵn trường nhập định danh.",
                        "single_task_flows_description": "Điều hướng người dùng thẳng vào một luồng cụ thể (ví dụ: liên kết email). Tuỳ chọn thêm `redirect=` để đưa người dùng trở lại ứng dụng của bạn sau khi cập nhật thành công, `show_success=true` để giữ trang thành công hiển thị, `ui_locales=` để ghi đè ngôn ngữ mặc định, hoặc `identifier=` để điền sẵn trường nhập định danh.",
                        "tooltips": {
                            "email": "Cập nhật địa chỉ email chính của bạn",
                            "phone": "Cập nhật số điện thoại chính của bạn",
                            "username": "Cập nhật tên đăng nhập của bạn",
                            "password": "Đặt mật khẩu mới",
                            "social": "Liên kết một tài khoản mạng xã hội để đăng nhập",
                            "social_change": "Đổi sang một tài khoản mạng xã hội đã liên kết khác",
                            "social_remove": "Gỡ một tài khoản mạng xã hội đã liên kết",
                            "authenticator_app": "Thiết lập một ứng dụng xác thực mới cho xác thực đa yếu tố",
                            "authenticator_app_replace": "Thay ứng dụng xác thực hiện có bằng ứng dụng mới",
                            "passkey_add": "Đăng ký một passkey mới",
                            "passkey_manage": "Quản lý các passkey hiện có hoặc thêm passkey mới",
                            "backup_codes_generate": "Tạo một bộ 10 mã dự phòng mới",
                            "backup_codes_manage": "Xem các mã dự phòng khả dụng hoặc tạo mã mới",
                            "account_center": "Truy cập trung tâm tài khoản để quản lý các cài đặt bảo mật như email, điện thoại, tên đăng nhập, mật khẩu, MFA và các tài khoản đã liên kết",
                            "profile": "Trung tâm để quản lý thông tin cá nhân của bạn (ví dụ: tên, ảnh đại diện)",
                            "sessions": "Xem và quản lý các phiên đang hoạt động trên các thiết bị của bạn"
                        },
                        "customize_note": "Không muốn dùng trải nghiệm mặc định? Bạn hoàn toàn có thể",
                        "customize_link": "tuỳ chỉnh các luồng của bạn bằng Account API thay thế."
                    },
                    "custom_css": {
                        "title": "CSS TUỲ CHỈNH",
                        "description": "Tuỳ chỉnh giao diện của trung tâm tài khoản bằng CSS tuỳ chỉnh."
                    }
                },
                "sign_up_and_sign_in": {
                    "identifiers_email": "Địa chỉ email",
                    "identifiers_phone": "Số điện thoại",
                    "identifiers_username": "Tên đăng nhập",
                    "identifiers_email_or_sms": "Địa chỉ email hoặc số điện thoại",
                    "identifiers_none": "Không áp dụng",
                    "and": "và",
                    "or": "hoặc",
                    "sign_up": {
                        "title": "ĐĂNG KÝ",
                        "sign_up_identifier": "Định danh đăng ký",
                        "identifier_description": "Tất cả các định danh đăng ký đã chọn đều bắt buộc khi tạo tài khoản mới.",
                        "sign_up_authentication": "Cài đặt xác thực khi đăng ký",
                        "verification_tip": "Người dùng phải xác minh email hoặc số điện thoại mà bạn đã cấu hình bằng cách nhập mã xác minh trong quá trình đăng ký.",
                        "authentication_description": "Tất cả các hành động đã chọn sẽ là bắt buộc để người dùng hoàn tất luồng.",
                        "set_a_password_option": "Tạo mật khẩu của bạn",
                        "verify_at_sign_up_option": "Xác minh khi đăng ký",
                        "social_only_creation_description": "(Điều này áp dụng cho việc tạo tài khoản chỉ bằng mạng xã hội)",
                        "collect_user_profile": "Thu thập hồ sơ người dùng",
                        "add_profile_fields": "Thêm trường hồ sơ",
                        "profile_fields_hint": {
                            "not_in_list": "Không có trong danh sách?",
                            "set_up": "Thiết lập",
                            "go_to": "các trường hồ sơ khác ngay."
                        }
                    },
                    "sign_in": {
                        "title": "ĐĂNG NHẬP",
                        "sign_in_identifier_and_auth": "Cài đặt định danh và xác thực khi đăng nhập",
                        "description": "Người dùng có thể đăng nhập bằng bất kỳ tuỳ chọn nào có sẵn.",
                        "add_sign_in_method": "Thêm phương thức đăng nhập",
                        "add_sign_up_method": "Thêm phương thức đăng ký",
                        "password_auth": "Mật khẩu",
                        "verification_code_auth": "Mã xác minh",
                        "auth_swap_tip": "Hoán đổi các tuỳ chọn bên dưới để xác định tuỳ chọn nào xuất hiện trước trong luồng.",
                        "require_auth_factor": "Bạn phải chọn ít nhất một yếu tố xác thực.",
                        "forgot_password": "Quên mật khẩu",
                        "forgot_password_description": "Người dùng có thể đặt lại mật khẩu bằng bất kỳ phương thức xác minh nào có sẵn.",
                        "add_verification_method": "Thêm phương thức xác minh",
                        "email_verification_code": "Mã xác minh qua email",
                        "phone_verification_code": "Mã xác minh qua điện thoại"
                    },
                    "social_sign_in": {
                        "title": "ĐĂNG NHẬP MẠNG XÃ HỘI",
                        "social_sign_in": "Đăng nhập mạng xã hội",
                        "description": "Tuỳ thuộc vào định danh bắt buộc mà bạn thiết lập, người dùng của bạn có thể được yêu cầu cung cấp định danh khi đăng ký qua trình kết nối mạng xã hội.",
                        "add_social_connector": "Thêm trình kết nối mạng xã hội",
                        "set_up_hint": {
                            "not_in_list": "Không có trong danh sách?",
                            "set_up_more": "Thiết lập",
                            "go_to": "các trình kết nối mạng xã hội khác ngay."
                        },
                        "settings_title": "Trải nghiệm đăng nhập mạng xã hội",
                        "automatic_account_linking": "Tự động liên kết các tài khoản có cùng định danh",
                        "automatic_account_linking_tip": "Khi bật, nếu một người dùng đăng nhập bằng danh tính mạng xã hội mới và tồn tại đúng một tài khoản hiện có với cùng định danh (ví dụ: một địa chỉ email), Logto sẽ tự động liên kết danh tính mạng xã hội đó với tài khoản này. Người dùng sẽ không được hỏi có muốn liên kết tài khoản hay không.",
                        "required_sign_up_identifiers": "Yêu cầu người dùng cung cấp định danh đăng ký còn thiếu",
                        "required_sign_up_identifiers_tip": "Khi bật, người dùng đăng nhập qua nhà cung cấp mạng xã hội phải điền bất kỳ định danh đăng ký bắt buộc nào còn thiếu (chẳng hạn email) trước khi hoàn tất đăng nhập. \n\nNếu tắt, người dùng có thể tiếp tục mà không cần cung cấp các định danh còn thiếu, ngay cả khi tài khoản mạng xã hội không đồng bộ chúng."
                    },
                    "passkey_sign_in": {
                        "title": "ĐĂNG NHẬP BẰNG PASSKEY",
                        "passkey_sign_in": "Đăng nhập bằng passkey",
                        "enable_passkey_sign_in_description": "Cho phép người dùng truy cập ứng dụng nhanh chóng và an toàn qua Passkey (WebAuthn), sử dụng sinh trắc học hoặc khoá bảo mật, v.v.",
                        "prompts": "Nhắc passkey",
                        "show_passkey_button": "Hiển thị nút “Tiếp tục với passkey” trên trang đăng nhập",
                        "show_passkey_button_tip": "Tắt nút “Tiếp tục với passkey” sẽ khiến luồng đăng nhập ưu tiên định danh trước, hiển thị các tuỳ chọn mật khẩu và passkey ở bước tiếp theo.",
                        "allow_autofill": "Cho phép nhắc và tự động điền các passkey đã đăng ký trong các trường định danh"
                    },
                    "tip": {
                        "set_a_password": "Bắt buộc phải có một bộ mật khẩu duy nhất cho tên đăng nhập của bạn.",
                        "verify_at_sign_up": "Hiện tại chúng tôi chỉ hỗ trợ email và điện thoại đã được xác minh. Cơ sở người dùng của bạn có thể chứa một số lượng lớn địa chỉ email hoặc số điện thoại kém chất lượng nếu không xác thực.",
                        "password_auth": "Điều này là cần thiết vì bạn đã bật tuỳ chọn đặt mật khẩu trong quá trình đăng ký.",
                        "verification_code_auth": "Điều này là cần thiết vì bạn chỉ bật tuỳ chọn cung cấp mã xác minh khi đăng ký. Bạn có thể bỏ chọn ô này khi việc thiết lập mật khẩu được cho phép trong quá trình đăng ký.",
                        "email_mfa_enabled": "Mã xác minh qua email đã được bật cho MFA, vì vậy không thể dùng lại làm phương thức đăng nhập chính vì lý do bảo mật.",
                        "phone_mfa_enabled": "Mã xác minh qua điện thoại đã được bật cho MFA, vì vậy không thể dùng lại làm phương thức đăng nhập chính vì lý do bảo mật.",
                        "delete_sign_in_method": "Điều này là cần thiết vì bạn đã chọn {{identifier}} làm định danh bắt buộc.",
                        "password_disabled_notification": "Tuỳ chọn \"Tạo mật khẩu của bạn\" bị tắt đối với đăng ký bằng tên đăng nhập, điều này có thể khiến người dùng không đăng nhập được. Xác nhận để tiếp tục lưu."
                    },
                    "advanced_options": {
                        "title": "TUỲ CHỌN NÂNG CAO",
                        "enable_single_sign_on": "Bật đăng nhập một lần (SSO) doanh nghiệp",
                        "enable_single_sign_on_description": "Cho phép người dùng đăng nhập vào ứng dụng bằng đăng nhập một lần với danh tính doanh nghiệp của họ.",
                        "single_sign_on_hint": {
                            "prefix": "Đến ",
                            "link": "\"SSO doanh nghiệp\"",
                            "suffix": "để thiết lập thêm các trình kết nối doanh nghiệp."
                        },
                        "enable_user_registration": "Bật đăng ký người dùng",
                        "enable_user_registration_description": "Bật hoặc cấm đăng ký người dùng. Sau khi tắt, người dùng vẫn có thể được thêm trong bảng quản trị nhưng người dùng không còn có thể tạo tài khoản qua giao diện đăng nhập.",
                        "unknown_session_redirect_url": "URL chuyển hướng khi phiên không xác định",
                        "unknown_session_redirect_url_tip": "Đôi khi, Logto có thể không nhận ra phiên của người dùng trên trang đăng nhập, chẳng hạn khi phiên hết hạn hoặc người dùng đánh dấu hay chia sẻ liên kết đăng nhập. Theo mặc định, một lỗi 404 “phiên không xác định” sẽ xuất hiện. Để nâng cao trải nghiệm người dùng, hãy đặt một URL dự phòng để chuyển hướng người dùng trở lại ứng dụng của bạn và khởi động lại quá trình xác thực."
                    },
                    "username_policy": {
                        "title": "Chính sách tên đăng nhập",
                        "description": "Tuỳ chỉnh các yêu cầu về tên đăng nhập, bao gồm độ dài, ký tự cho phép và phân biệt chữ hoa chữ thường.",
                        "manage_button": "Quản lý",
                        "modal_title": "Chính sách tên đăng nhập",
                        "modal_description": "Tuỳ chỉnh các yêu cầu về tên đăng nhập cho người dùng cuối của bạn.",
                        "length": {
                            "title": "Độ dài tên đăng nhập",
                            "minimum": "Tối thiểu",
                            "maximum": "Tối đa",
                            "min_greater_than_max": "Độ dài tối thiểu không được lớn hơn độ dài tối đa."
                        },
                        "allowed_chars": {
                            "title": "Các loại ký tự được phép",
                            "uppercase": "Chữ hoa (A-Z)",
                            "lowercase": "Chữ thường (a-z)",
                            "numbers": "Chữ số (0-9)",
                            "underscore": "Dấu gạch dưới (_)",
                            "no_valid_leading_char": "Không cho phép chỉ toàn chữ số. Hãy bật ít nhất một trong các loại: chữ hoa, chữ thường, hoặc dấu gạch dưới.",
                            "no_char_selected": "Chọn ít nhất một loại ký tự."
                        },
                        "case_sensitive": {
                            "title": "Tên đăng nhập phân biệt chữ hoa chữ thường",
                            "description": "Coi chữ hoa và chữ thường là khác nhau. ‘nguoidung123’ và ‘Nguoidung123’ được coi là các tên đăng nhập khác nhau."
                        },
                        "case_conflicts": {
                            "title": "Phát hiện xung đột tên đăng nhập hiện có",
                            "description": "Một số tên đăng nhập sẽ trùng nhau nếu tắt phân biệt chữ hoa chữ thường. Hãy giải quyết {{count}} nhóm xung đột bên dưới trước khi lưu.",
                            "sample_title": "Tên đăng nhập bị xung đột"
                        }
                    }
                },
                "content": {
                    "terms_of_use": {
                        "title": "ĐIỀU KHOẢN",
                        "description": "Thêm Điều khoản và Quyền riêng tư để đáp ứng các yêu cầu tuân thủ.",
                        "terms_of_use": "URL điều khoản sử dụng",
                        "terms_of_use_placeholder": "https://your.terms.of.use/",
                        "privacy_policy": "URL chính sách quyền riêng tư",
                        "privacy_policy_placeholder": "https://your.privacy.policy/",
                        "agree_to_terms": "Đồng ý với điều khoản",
                        "agree_policies": {
                            "automatic": "Tiếp tục để tự động đồng ý với điều khoản",
                            "manual_registration_only": "Yêu cầu tích chọn đồng ý chỉ khi đăng ký",
                            "manual": "Yêu cầu tích chọn đồng ý cả khi đăng ký và đăng nhập"
                        }
                    },
                    "languages": {
                        "title": "NGÔN NGỮ",
                        "enable_auto_detect": "Bật tự động phát hiện",
                        "description": "Phần mềm của bạn phát hiện cài đặt locale của người dùng và chuyển sang ngôn ngữ địa phương. Bạn có thể thêm ngôn ngữ mới bằng cách dịch giao diện từ tiếng Anh sang ngôn ngữ khác.",
                        "manage_language": "Quản lý ngôn ngữ",
                        "default_language": "Ngôn ngữ mặc định",
                        "default_language_description_auto": "Ngôn ngữ mặc định sẽ được sử dụng khi ngôn ngữ người dùng được phát hiện không có trong thư viện ngôn ngữ hiện tại.",
                        "default_language_description_fixed": "Khi tắt tự động phát hiện, ngôn ngữ mặc định là ngôn ngữ duy nhất mà phần mềm của bạn sẽ hiển thị. Bật tự động phát hiện để mở rộng ngôn ngữ."
                    },
                    "support": {
                        "title": "HỖ TRỢ",
                        "subtitle": "Hiển thị các kênh hỗ trợ của bạn trên các trang lỗi để hỗ trợ người dùng nhanh chóng.",
                        "support_email": "Email hỗ trợ",
                        "support_email_placeholder": "support@email.com",
                        "support_website": "Website hỗ trợ",
                        "support_website_placeholder": "https://your.website/support"
                    },
                    "manage_language": {
                        "title": "Quản lý ngôn ngữ",
                        "subtitle": "Bản địa hoá trải nghiệm sản phẩm bằng cách thêm ngôn ngữ và bản dịch. Đóng góp của bạn có thể được đặt làm ngôn ngữ mặc định.",
                        "add_language": "Thêm ngôn ngữ",
                        "logto_provided": "Do Logto cung cấp",
                        "key": "Khoá",
                        "logto_source_values": "Giá trị nguồn của Logto",
                        "custom_values": "Giá trị tuỳ chỉnh",
                        "clear_all_tip": "Xoá tất cả giá trị",
                        "unsaved_description": "Các thay đổi sẽ không được lưu nếu bạn rời trang này mà không lưu.",
                        "deletion_tip": "Xoá ngôn ngữ",
                        "deletion_title": "Bạn có muốn xoá ngôn ngữ đã thêm không?",
                        "deletion_description": "Sau khi xoá, người dùng của bạn sẽ không thể duyệt bằng ngôn ngữ đó nữa.",
                        "default_language_deletion_title": "Không thể xoá ngôn ngữ mặc định.",
                        "default_language_deletion_description": "{{language}} được đặt làm ngôn ngữ mặc định của bạn và không thể xoá. "
                    }
                },
                "setup_warning": {
                    "no_connector_sms": "Chưa thiết lập trình kết nối SMS. Trước khi hoàn tất cấu hình, người dùng sẽ không thể đăng nhập bằng phương thức này. <a>{{link}}</a> trong \"Trình kết nối\"",
                    "no_connector_email": "Chưa thiết lập trình kết nối email. Trước khi hoàn tất cấu hình, người dùng sẽ không thể đăng nhập bằng phương thức này. <a>{{link}}</a> trong \"Trình kết nối\"",
                    "no_connector_social": "Bạn chưa thiết lập trình kết nối mạng xã hội nào. Hãy thêm trình kết nối trước để áp dụng các phương thức đăng nhập mạng xã hội. <a>{{link}}</a> trong \"Trình kết nối\".",
                    "no_connector_email_account_center": "Chưa thiết lập trình kết nối email. Thiết lập trong <a>\"Trình kết nối Email và SMS\"</a>.",
                    "no_connector_sms_account_center": "Chưa thiết lập trình kết nối SMS. Thiết lập trong <a>\"Trình kết nối Email và SMS\"</a>.",
                    "no_connector_social_account_center": "Chưa thiết lập trình kết nối mạng xã hội. Thiết lập trong <a>\"Trình kết nối mạng xã hội\"</a>.",
                    "no_mfa_factor": "Chưa thiết lập yếu tố MFA nào. Thiết lập trong <a>{{link}}</a>.",
                    "setup_link": "Thiết lập"
                },
                "save_alert": {
                    "description": "Bạn đang triển khai các quy trình đăng nhập và đăng ký mới. Tất cả người dùng của bạn có thể bị ảnh hưởng bởi thiết lập mới. Bạn có chắc muốn thực hiện thay đổi này không?",
                    "before": "Trước",
                    "after": "Sau",
                    "sign_up": "Đăng ký",
                    "sign_in": "Đăng nhập",
                    "social": "Mạng xã hội",
                    "forgot_password_migration_notice": "Chúng tôi đã nâng cấp xác minh quên mật khẩu để hỗ trợ các phương thức tuỳ chỉnh. Trước đây, điều này được xác định tự động bởi các trình kết nối Email và SMS của bạn. Nhấn <strong>Xác nhận</strong> để hoàn tất nâng cấp."
                },
                "preview": {
                    "title": "Xem trước đăng nhập",
                    "live_preview": "Xem trực tiếp",
                    "live_preview_tip": "Lưu để xem trước thay đổi",
                    "native": "Native",
                    "desktop_web": "Web trên máy tính",
                    "mobile_web": "Web trên di động",
                    "desktop": "Máy tính",
                    "mobile": "Di động"
                },
                "custom_profile_fields": {
                    "table": {
                        "add_button": "Thêm trường hồ sơ",
                        "title": {
                            "field_label": "Nhãn trường",
                            "type": "Loại",
                            "user_data_key": "Khoá dữ liệu người dùng"
                        },
                        "placeholder": {
                            "title": "Thu thập hồ sơ người dùng",
                            "description": "Tuỳ chỉnh các trường để thu thập thêm thông tin hồ sơ người dùng trong quá trình đăng ký."
                        }
                    },
                    "type": {
                        "Text": "Văn bản",
                        "Number": "Số",
                        "Date": "Ngày",
                        "Checkbox": "Ô đánh dấu (Boolean)",
                        "Select": "Danh sách thả xuống (Chọn một)",
                        "Url": "URL",
                        "Regex": "Biểu thức chính quy",
                        "Address": "Địa chỉ (Tổ hợp)",
                        "Fullname": "Họ và tên (Tổ hợp)"
                    },
                    "modal": {
                        "title": "Thêm trường hồ sơ",
                        "subtitle": "Tuỳ chỉnh các trường để thu thập thêm thông tin hồ sơ người dùng trong quá trình đăng ký.",
                        "built_in_properties": "Dữ liệu người dùng cơ bản",
                        "custom_properties": "Dữ liệu người dùng tuỳ chỉnh",
                        "custom_data_field_name": "Khoá dữ liệu người dùng",
                        "custom_data_field_input_placeholder": "Nhập khoá dữ liệu người dùng, ví dụ `myFavoriteFieldName`",
                        "custom_field": {
                            "title": "Dữ liệu tuỳ chỉnh",
                            "description": "Bất kỳ thuộc tính người dùng bổ sung nào bạn có thể định nghĩa để đáp ứng các yêu cầu riêng của ứng dụng."
                        },
                        "type_required": "Vui lòng chọn một loại thuộc tính",
                        "create_button": "Tạo trường hồ sơ",
                        "avatar": {
                            "description": "Cho phép người dùng tải lên ảnh hồ sơ của họ trong quá trình đăng ký. URL ảnh đã tải lên được lưu làm ảnh đại diện người dùng.",
                            "storage_not_configured": "Việc tải ảnh đại diện lên yêu cầu một nhà cung cấp lưu trữ đã được cấu hình. Hãy cấu hình lưu trữ trước khi thêm trường này."
                        }
                    },
                    "details": {
                        "page_title": "Chi tiết trường hồ sơ",
                        "back_to_sie": "Quay lại trải nghiệm đăng nhập",
                        "enter_field_name": "Nhập tên trường hồ sơ",
                        "delete_description": "Hành động này không thể hoàn tác. Bạn có chắc muốn xoá trường hồ sơ này không?",
                        "field_deleted": "Trường hồ sơ {{name}} đã được xoá thành công.",
                        "key": "Khoá dữ liệu người dùng",
                        "field_name": "Tên trường",
                        "field_type": "Loại trường",
                        "settings": "Cài đặt",
                        "settings_description": "Tuỳ chỉnh các trường để thu thập thêm thông tin hồ sơ người dùng trong quá trình đăng ký.",
                        "address_format": "Định dạng địa chỉ",
                        "single_line_address": "Địa chỉ một dòng",
                        "multi_line_address": "Địa chỉ nhiều dòng (Ví dụ: Đường, Thành phố, Tỉnh/Bang, Mã bưu chính, Quốc gia)",
                        "components": "Thành phần",
                        "components_tip": "Chọn các thành phần để tạo nên trường phức hợp.",
                        "label": "Nhãn trường",
                        "label_placeholder": "Nhãn",
                        "label_tip": "Cần bản địa hoá? Thêm ngôn ngữ trong <a>Trải nghiệm đăng nhập > Nội dung</a>",
                        "label_tooltip": "Nhãn nổi giúp xác định trường dùng để làm gì. Nó xuất hiện bên trong ô nhập và di chuyển lên phía trên trường khi trường được chọn hoặc có giá trị.",
                        "placeholder": "Giá trị mẫu của trường",
                        "placeholder_placeholder": "Giá trị mẫu",
                        "placeholder_tooltip": "Ví dụ hoặc gợi ý định dạng inline được hiển thị bên trong ô nhập. Nó thường xuất hiện sau khi nhãn nổi lên và nên ngắn gọn (ví dụ: MM/DD/YYYY).",
                        "description": "Mô tả trường",
                        "description_placeholder": "Mô tả",
                        "description_tooltip": "Văn bản hỗ trợ hiển thị bên dưới ô nhập văn bản. Dùng nó cho các hướng dẫn dài hơn hoặc ghi chú về trợ năng.",
                        "options": "Tuỳ chọn",
                        "options_tip": "Nhập mỗi tuỳ chọn trên một dòng mới. Dùng value:label (ví dụ red:Red). Bạn cũng có thể chỉ nhập value; nếu không cung cấp label, value sẽ được hiển thị làm label.",
                        "options_placeholder": "value1:label1\nvalue2:label2\nvalue3:label3",
                        "regex": "Biểu thức chính quy",
                        "regex_tip": "Định nghĩa một biểu thức chính quy để xác thực giá trị nhập.",
                        "regex_placeholder": "^[a-zA-Z0-9]+$",
                        "date_format": "Định dạng ngày",
                        "date_format_us": "MM/dd/yyyy (ví dụ: Hoa Kỳ)",
                        "date_format_uk": "dd/MM/yyyy (ví dụ: Anh và châu Âu)",
                        "date_format_iso": "yyyy-MM-dd (Tiêu chuẩn quốc tế)",
                        "custom_date_format": "Định dạng ngày tuỳ chỉnh",
                        "custom_date_format_placeholder": "Nhập định dạng ngày tuỳ chỉnh. Ví dụ \"MM-dd-yyyy\"",
                        "custom_date_format_tip": "Xem tài liệu <a>date-fns</a> để biết các token định dạng hợp lệ.",
                        "input_length": "Độ dài giá trị nhập",
                        "value_range": "Khoảng giá trị",
                        "min": "Tối thiểu",
                        "max": "Tối đa",
                        "default_value": "Giá trị mặc định",
                        "checkbox_checked": "Đã đánh dấu (True)",
                        "checkbox_unchecked": "Chưa đánh dấu (False)",
                        "required": "Bắt buộc",
                        "required_description": "Khi bật, trường này bắt buộc người dùng phải điền. Khi tắt, trường này là tuỳ chọn.",
                        "avatar_upload_description": "Người dùng cuối tải lên ảnh đại diện của họ trong quá trình đăng ký. Giá trị được lưu là URL ảnh đã tải lên."
                    }
                }
            },
            "dashboard": {
                "page_title": "Bảng điều khiển",
                "title": "Bảng điều khiển",
                "description": "Xem tổng quan hiệu suất ứng dụng của bạn",
                "total_users": "Tổng người dùng",
                "total_users_tip": "Tổng người dùng",
                "new_users_today": "Người dùng mới hôm nay",
                "new_users_today_tip": "Số người dùng mới đăng ký trên ứng dụng của bạn hôm nay",
                "new_users_7_days": "Người dùng mới 7 ngày qua",
                "new_users_7_days_tip": "Số người dùng mới đăng ký trên ứng dụng của bạn trong 7 ngày qua",
                "daily_active_users": "Người dùng hoạt động hằng ngày",
                "daily_active_users_tip": "Số người dùng khác nhau đã trao đổi token trên ứng dụng của bạn hôm nay",
                "weekly_active_users": "Người dùng hoạt động hằng tuần",
                "weekly_active_users_tip": "Số người dùng khác nhau đã trao đổi token trên ứng dụng của bạn trong 7 ngày qua",
                "monthly_active_users": "Người dùng hoạt động hằng tháng",
                "monthly_active_users_tip": "Số người dùng khác nhau đã trao đổi token trên ứng dụng của bạn trong 30 ngày qua"
            },
            "logs": {
                "page_title": "Nhật ký kiểm toán",
                "title": "Nhật ký kiểm toán",
                "subtitle": "Xem dữ liệu nhật ký các sự kiện xác thực do người dùng của bạn thực hiện",
                "event": "Sự kiện",
                "user": "Người dùng",
                "application": "Ứng dụng",
                "time": "Thời gian",
                "filter_by": "Lọc theo",
                "last_1_hour": "1 giờ qua",
                "last_24_hours": "24 giờ qua",
                "last_7_days": "7 ngày qua",
                "last_30_days": "30 ngày qua",
                "custom_range": "Khoảng tuỳ chỉnh",
                "from": "Từ",
                "to": "Đến"
            },
            "log_details": {
                "page_title": "Chi tiết bản ghi nhật ký",
                "back_to_logs": "Quay lại Nhật ký kiểm toán",
                "back_to": "Quay lại {{name}}",
                "success": "Thành công",
                "failed": "Thất bại",
                "event_key": "Khoá sự kiện",
                "application": "Ứng dụng",
                "ip_address": "Địa chỉ IP",
                "user": "Người dùng",
                "log_id": "ID bản ghi",
                "time": "Thời gian",
                "user_agent": "User agent",
                "tab_details": "Chi tiết",
                "raw_data": "Dữ liệu thô"
            },
            "session_expired": {
                "title": "Phiên đã hết hạn",
                "subtitle": "Phiên của bạn có thể đã hết hạn và bạn bị ngắt kết nối. Bấm nút bên dưới để đăng nhập lại vào bảng quản trị.",
                "button": "Đăng nhập lại"
            },
            "welcome": {
                "title": "Chào mừng đến Bảng quản trị",
                "description": "Bảng quản trị là ứng dụng web để quản lý Logto mà không cần lập trình. Trước tiên hãy tạo một tài khoản. Với tài khoản này, bạn có thể tự quản lý Logto hoặc thay mặt công ty của bạn.",
                "create_account": "Tạo tài khoản"
            },
            "roles": {
                "page_title": "Vai trò",
                "title": "Vai trò",
                "subtitle": "Vai trò gồm các quyền quyết định người dùng được làm gì. RBAC dùng vai trò để cấp cho người dùng quyền truy cập tài nguyên cho các hành động cụ thể.",
                "create": "Tạo vai trò",
                "role_name": "Tên vai trò",
                "role_type": "Loại vai trò",
                "type_user": "Người dùng",
                "type_machine_to_machine": "Máy-với-Máy",
                "role_description": "Mô tả",
                "role_name_placeholder": "Nhập tên vai trò",
                "role_description_placeholder": "Nhập mô tả vai trò",
                "col_roles": "Vai trò",
                "col_type": "Loại",
                "col_description": "Mô tả",
                "col_assigned_entities": "Đã gán",
                "user_counts": "{{count}} người dùng",
                "application_counts": "{{count}} ứng dụng",
                "user_count": "{{count}} người dùng",
                "application_count": "{{count}} ứng dụng",
                "assign_permissions": "Gán quyền",
                "create_role_title": "Tạo vai trò",
                "create_role_description": "Dùng vai trò để tổ chức các quyền và gán cho người dùng.",
                "create_role_button": "Tạo vai trò",
                "role_created": "Vai trò {{name}} đã được tạo thành công.",
                "search": "Tìm theo tên vai trò, mô tả hoặc ID",
                "placeholder_title": "Vai trò",
                "placeholder_description": "Vai trò là nhóm các quyền có thể gán cho người dùng. Hãy thêm quyền trước khi tạo vai trò.",
                "assign_roles": "Gán vai trò",
                "management_api_access_notification": "Để truy cập Logto Management API, chọn vai trò có quyền Management API <flag/>.",
                "with_management_api_access_tip": "Vai trò Máy-với-Máy này bao gồm quyền Logto Management API",
                "role_creation_hint": "Không tìm thấy vai trò phù hợp? <a>Tạo vai trò</a>"
            },
            "role_details": {
                "back_to_roles": "Quay lại danh sách vai trò",
                "identifier": "Định danh",
                "delete_description": "Việc này sẽ gỡ các quyền gắn với vai trò này khỏi những người dùng bị ảnh hưởng và xoá liên kết giữa vai trò, người dùng và quyền.",
                "role_deleted": "Đã xoá {{name}} thành công.",
                "general_tab": "Chung",
                "users_tab": "Người dùng",
                "m2m_apps_tab": "Ứng dụng Máy-với-Máy",
                "permissions_tab": "Quyền",
                "settings": "Cài đặt",
                "settings_description": "Vai trò là một nhóm quyền có thể gán cho người dùng. Chúng cũng giúp gom các quyền được định nghĩa cho nhiều API khác nhau, giúp việc thêm, gỡ hay điều chỉnh quyền hiệu quả hơn so với gán riêng lẻ cho từng người dùng.",
                "field_name": "Tên",
                "field_description": "Mô tả",
                "field_is_default": "Vai trò mặc định",
                "field_is_default_description": "Đặt vai trò này làm vai trò mặc định cho người dùng mới. Có thể đặt nhiều vai trò mặc định. Việc này cũng ảnh hưởng đến vai trò mặc định của người dùng được tạo qua Management API.",
                "type_m2m_role_tag": "Máy-với-Máy",
                "type_user_role_tag": "Người dùng",
                "m2m_role_notification": "Gán vai trò Máy-với-Máy này cho một ứng dụng Máy-với-Máy để cấp quyền truy cập các tài nguyên API tương ứng. <a>Tạo ứng dụng Máy-với-Máy</a> trước nếu bạn chưa có.",
                "permission": {
                    "assign_button": "Gán quyền",
                    "assign_title": "Gán quyền",
                    "assign_subtitle": "Gán quyền cho vai trò này. Vai trò sẽ nhận thêm các quyền được thêm, và người dùng có vai trò này sẽ kế thừa các quyền đó.",
                    "assign_form_field": "Gán quyền",
                    "added_text": "Đã thêm {{count, number}} quyền",
                    "added_text_other": "Đã thêm {{count, number}} quyền",
                    "api_permission_count": "{{count, number}} quyền",
                    "api_permission_count_other": "{{count, number}} quyền",
                    "confirm_assign": "Gán quyền",
                    "permission_assigned": "Đã gán các quyền được chọn cho vai trò này thành công",
                    "deletion_description": "Nếu gỡ quyền này, người dùng có vai trò này sẽ mất quyền truy cập mà nó cấp.",
                    "permission_deleted": "Đã gỡ quyền \"{{name}}\" khỏi vai trò này thành công",
                    "empty": "Không có quyền nào"
                },
                "users": {
                    "assign_button": "Gán người dùng",
                    "name_column": "Người dùng",
                    "app_column": "Ứng dụng",
                    "latest_sign_in_column": "Đăng nhập gần nhất",
                    "delete_description": "Người dùng vẫn còn trong nhóm người dùng của bạn nhưng mất quyền của vai trò này.",
                    "deleted": "Đã gỡ {{name}} khỏi vai trò này thành công",
                    "assign_title": "Gán người dùng cho {{name}}",
                    "assign_subtitle": "Tìm người dùng phù hợp bằng cách tìm theo tên, email, số điện thoại hoặc ID người dùng.",
                    "assign_field": "Gán người dùng",
                    "confirm_assign": "Gán người dùng",
                    "assigned_toast_text": "Đã gán các người dùng được chọn cho vai trò này thành công",
                    "empty": "Không có người dùng nào"
                },
                "applications": {
                    "assign_button": "Gán ứng dụng Máy-với-Máy",
                    "name_column": "Ứng dụng",
                    "app_column": "Ứng dụng Máy-với-Máy",
                    "description_column": "Mô tả",
                    "delete_description": "Ứng dụng vẫn còn trong nhóm ứng dụng của bạn nhưng mất quyền của vai trò này.",
                    "deleted": "Đã gỡ {{name}} khỏi vai trò này thành công",
                    "assign_title": "Gán ứng dụng Máy-với-Máy cho {{name}}",
                    "assign_subtitle": "Tìm ứng dụng Máy-với-Máy phù hợp bằng cách tìm theo tên, mô tả hoặc ID ứng dụng.",
                    "assign_field": "Gán ứng dụng Máy-với-Máy",
                    "confirm_assign": "Gán ứng dụng Máy-với-Máy",
                    "assigned_toast_text": "Đã gán các ứng dụng được chọn cho vai trò này thành công",
                    "empty": "Không có ứng dụng nào"
                }
            },
            "permissions": {
                "search_placeholder": "Tìm theo tên API hoặc tên quyền",
                "search_placeholder_without_api": "Tìm theo tên quyền",
                "name_column": "Quyền",
                "description_column": "Mô tả",
                "api_column": "API",
                "placeholder_title": "Quyền",
                "placeholder_description": "Quyền là sự cấp phép để truy cập một tài nguyên (chúng tôi gọi là tài nguyên API).",
                "edit": "Sửa quyền",
                "delete": "Xoá quyền",
                "remove": "Xoá quyền",
                "edit_title": "Sửa quyền API"
            },
            "cloud": {
                "general": {
                    "onboarding": "Thiết lập ban đầu"
                },
                "create_tenant": {
                    "page_title": "Tạo tenant",
                    "title": "Tạo tenant đầu tiên của bạn",
                    "description": "Tenant là một môi trường tách biệt nơi bạn có thể quản lý danh tính người dùng, ứng dụng, và mọi tài nguyên Logto khác.",
                    "invite_collaborators": "Mời thành viên của bạn qua email"
                },
                "social_callback": {
                    "title": "Bạn đã đăng nhập thành công",
                    "description": "Bạn đã đăng nhập thành công bằng tài khoản mạng xã hội. Để đảm bảo tích hợp liền mạch và truy cập mọi tính năng của Logto, chúng tôi khuyên bạn tiến hành cấu hình social connector của riêng mình.",
                    "notice": "Vui lòng tránh dùng demo connector cho mục đích production. Sau khi hoàn tất thử nghiệm, hãy xoá demo connector và thiết lập connector của riêng bạn với thông tin xác thực của mình."
                },
                "tenant": {
                    "create_tenant": "Tạo tenant"
                }
            },
            "profile": {
                "link_account": {
                    "anonymous": "Ẩn danh"
                },
                "delete_account": {
                    "title": "XOÁ TÀI KHOẢN",
                    "label": "Xoá tài khoản",
                    "description": "Xoá tài khoản sẽ gỡ bỏ toàn bộ thông tin cá nhân, dữ liệu người dùng và cấu hình của bạn. Hành động này không thể hoàn tác.",
                    "button": "Xoá tài khoản",
                    "p": {
                        "has_issue": "Rất tiếc khi biết bạn muốn xoá tài khoản. Trước khi có thể xoá, bạn cần xử lý các vấn đề sau.",
                        "after_resolved": "Sau khi đã xử lý xong các vấn đề, bạn có thể xoá tài khoản. Đừng ngần ngại liên hệ với chúng tôi nếu cần hỗ trợ.",
                        "check_information": "Rất tiếc khi biết bạn muốn xoá tài khoản. Vui lòng kiểm tra kỹ các thông tin sau trước khi tiếp tục.",
                        "remove_all_data": "Xoá tài khoản sẽ xoá vĩnh viễn toàn bộ dữ liệu về bạn trên Logto Cloud. Vì vậy hãy đảm bảo sao lưu mọi dữ liệu quan trọng trước khi tiếp tục.",
                        "confirm_information": "Vui lòng xác nhận rằng thông tin ở trên đúng như bạn mong đợi. Sau khi xoá tài khoản, chúng tôi sẽ không thể khôi phục lại.",
                        "has_admin_role": "Vì bạn có vai trò quản trị trong tenant sau, nó sẽ bị xoá cùng với tài khoản của bạn:",
                        "has_admin_role_other": "Vì bạn có vai trò quản trị trong các tenant sau, chúng sẽ bị xoá cùng với tài khoản của bạn:",
                        "quit_tenant": "Bạn sắp rời khỏi tenant sau:",
                        "quit_tenant_other": "Bạn sắp rời khỏi các tenant sau:"
                    },
                    "issues": {
                        "paid_plan": "Tenant sau đang dùng gói trả phí, vui lòng huỷ đăng ký gói dịch vụ trước:",
                        "paid_plan_other": "Các tenant sau đang dùng gói trả phí, vui lòng huỷ đăng ký gói dịch vụ trước:",
                        "subscription_status": "Tenant sau đang gặp vấn đề về trạng thái gói dịch vụ:",
                        "subscription_status_other": "Các tenant sau đang gặp vấn đề về trạng thái gói dịch vụ:",
                        "open_invoice": "Tenant sau có hoá đơn chưa thanh toán:",
                        "open_invoice_other": "Các tenant sau có hoá đơn chưa thanh toán:"
                    },
                    "error_occurred": "Đã xảy ra lỗi",
                    "error_occurred_description": "Rất tiếc, đã có lỗi xảy ra khi xoá tài khoản của bạn:",
                    "request_id": "Request ID: {{requestId}}",
                    "try_again_later": "Vui lòng thử lại sau. Nếu vấn đề vẫn tiếp diễn, hãy liên hệ đội ngũ Logto kèm theo request ID.",
                    "final_confirmation": "Xác nhận cuối cùng",
                    "about_to_start_deletion": "Bạn sắp bắt đầu quá trình xoá và hành động này không thể hoàn tác.",
                    "permanently_delete": "Xoá vĩnh viễn"
                },
                "fields": {
                    "name": "Tên",
                    "name_description": "Họ tên đầy đủ của người dùng ở dạng hiển thị, bao gồm tất cả các thành phần tên (ví dụ: “Nguyễn Văn A”).",
                    "avatar": "Ảnh đại diện",
                    "avatar_description": "URL ảnh đại diện của người dùng.",
                    "familyName": "Họ",
                    "familyName_description": "Họ của người dùng (ví dụ: \"Nguyễn\").",
                    "givenName": "Tên",
                    "givenName_description": "Tên gọi của người dùng (ví dụ: \"An\").",
                    "middleName": "Tên đệm",
                    "middleName_description": "Tên đệm của người dùng (ví dụ: \"Văn\").",
                    "nickname": "Biệt danh",
                    "nickname_description": "Tên gọi thân mật của người dùng, có thể khác với tên hợp pháp.",
                    "preferredUsername": "Tên đăng nhập ưa thích",
                    "preferredUsername_description": "Định danh rút gọn mà người dùng muốn được gọi.",
                    "profile": "Hồ sơ",
                    "profile_description": "URL trang hồ sơ dạng dễ đọc của người dùng (ví dụ: hồ sơ mạng xã hội).",
                    "website": "Website",
                    "website_description": "URL website cá nhân hoặc blog của người dùng.",
                    "gender": "Giới tính",
                    "gender_description": "Giới tính do người dùng tự xác định (ví dụ: \"Nữ\", \"Nam\", \"Phi nhị nguyên\")",
                    "birthdate": "Ngày sinh",
                    "birthdate_description": "Ngày sinh của người dùng theo định dạng chỉ định (ví dụ: \"MM-dd-yyyy\").",
                    "zoneinfo": "Múi giờ",
                    "zoneinfo_description": "Múi giờ của người dùng theo định dạng IANA (ví dụ: \"America/New_York\" hoặc \"Europe/Paris\").",
                    "locale": "Ngôn ngữ",
                    "locale_description": "Ngôn ngữ của người dùng theo định dạng IETF BCP 47 (ví dụ: \"en-US\" hoặc \"zh-CN\").",
                    "address": {
                        "formatted": "Địa chỉ",
                        "streetAddress": "Địa chỉ đường phố",
                        "locality": "Thành phố",
                        "region": "Tỉnh/Thành",
                        "postalCode": "Mã bưu chính",
                        "country": "Quốc gia"
                    },
                    "address_description": "Địa chỉ đầy đủ của người dùng ở dạng hiển thị, bao gồm tất cả các thành phần địa chỉ (ví dụ: \"123 Main St, Anytown, USA 12345\").",
                    "fullname": "Họ và tên",
                    "fullname_description": "Kết hợp linh hoạt familyName, givenName và middleName dựa trên cấu hình."
                }
            },
            "components": {
                "uploader": {
                    "action_description": "Kéo thả hoặc chọn tệp",
                    "uploading": "Đang tải lên...",
                    "image_limit": "Tải ảnh dưới {{size, number}}KB, chỉ {{extensions, list(style: narrow; type: conjunction;)}}.",
                    "error_upload": "Đã có lỗi. Tải tệp lên thất bại.",
                    "error_file_size": "Tệp quá lớn. Vui lòng tải tệp dưới {{limitWithUnit}}.",
                    "error_file_type": "Định dạng tệp không được hỗ trợ. Chỉ {{extensions, list(style: narrow; type: conjunction;)}}.",
                    "error_file_count": "Bạn chỉ có thể tải lên 1 tệp."
                }
            },
            "webhooks": {
                "page_title": "Webhook",
                "title": "Webhook",
                "subtitle": "Tạo webhook để dễ dàng nhận cập nhật thời gian thực về các sự kiện cụ thể.",
                "create": "Tạo Webhook",
                "schemas": {
                    "interaction": "Tương tác người dùng",
                    "user": "Người dùng",
                    "organization": "Tổ chức",
                    "role": "Vai trò",
                    "scope": "Quyền",
                    "organization_role": "Vai trò tổ chức",
                    "organization_scope": "Quyền tổ chức",
                    "security": "Bảo mật"
                },
                "table": {
                    "name": "Tên",
                    "events": "Sự kiện",
                    "success_rate": "Tỷ lệ thành công (24h)",
                    "requests": "Số yêu cầu (24h)"
                },
                "placeholder": {
                    "title": "Webhook",
                    "description": "Tạo webhook để nhận cập nhật thời gian thực qua yêu cầu POST tới URL endpoint của bạn. Luôn nắm bắt và hành động ngay với các sự kiện như \"Tạo tài khoản\", \"Đăng nhập\" và \"Đặt lại mật khẩu\".",
                    "create_webhook": "Tạo Webhook"
                },
                "create_form": {
                    "title": "Tạo Webhook",
                    "subtitle": "Thêm webhook để gửi yêu cầu POST tới URL endpoint kèm chi tiết các sự kiện người dùng.",
                    "events": "Sự kiện",
                    "events_description": "Chọn các sự kiện kích hoạt mà Logto sẽ gửi yêu cầu POST.",
                    "name": "Tên",
                    "name_placeholder": "Nhập tên webhook",
                    "endpoint_url": "URL endpoint",
                    "endpoint_url_placeholder": "https://your.webhook.endpoint.url",
                    "endpoint_url_tip": "Nhập URL endpoint nơi payload của webhook được gửi tới khi sự kiện xảy ra.",
                    "create_webhook": "Tạo webhook",
                    "missing_event_error": "Bạn phải chọn ít nhất một sự kiện."
                },
                "webhook_created": "Webhook {{name}} đã được tạo thành công."
            },
            "webhook_details": {
                "page_title": "Chi tiết Webhook",
                "back_to_webhooks": "Quay lại danh sách Webhook",
                "not_in_use": "Không sử dụng",
                "success_rate": "tỷ lệ thành công",
                "requests": "{{value, number}} yêu cầu trong 24h",
                "disable_webhook": "Tắt webhook",
                "disable_reminder": "Bạn có chắc muốn kích hoạt lại webhook này? Việc này sẽ không gửi yêu cầu HTTP đến URL endpoint.",
                "webhook_disabled": "Đã tắt webhook.",
                "webhook_reactivated": "Đã kích hoạt lại webhook.",
                "reactivate_webhook": "Kích hoạt lại webhook",
                "delete_webhook": "Xoá webhook",
                "deletion_reminder": "Bạn đang gỡ webhook này. Sau khi xoá, nó sẽ không gửi yêu cầu HTTP đến URL endpoint.",
                "deleted": "Đã xoá webhook thành công.",
                "settings_tab": "Cài đặt",
                "recent_requests_tab": "Yêu cầu gần đây (24h)",
                "settings": {
                    "settings": "Cài đặt",
                    "settings_description": "Webhook cho phép bạn nhận cập nhật theo thời gian thực về các sự kiện cụ thể ngay khi chúng xảy ra, bằng cách gửi một yêu cầu POST đến URL endpoint của bạn. Nhờ đó bạn có thể hành động ngay dựa trên thông tin mới nhận được.",
                    "events": "Sự kiện",
                    "events_description": "Chọn các sự kiện kích hoạt mà Logto sẽ gửi yêu cầu POST.",
                    "name": "Tên",
                    "endpoint_url": "URL endpoint",
                    "signing_key": "Khoá ký",
                    "signing_key_tip": "Thêm khoá bí mật do Logto cung cấp vào endpoint của bạn dưới dạng request header để đảm bảo tính xác thực cho payload của webhook.",
                    "regenerate": "Tạo lại",
                    "regenerate_key_title": "Tạo lại khoá ký",
                    "regenerate_key_reminder": "Bạn có chắc muốn thay đổi khoá ký? Việc tạo lại sẽ có hiệu lực ngay lập tức. Hãy nhớ cập nhật khoá ký tương ứng tại endpoint của bạn.",
                    "regenerated": "Đã tạo lại khoá ký.",
                    "custom_headers": "Header tuỳ chỉnh",
                    "custom_headers_tip": "Tuỳ chọn, bạn có thể thêm header tuỳ chỉnh vào payload của webhook để cung cấp thêm ngữ cảnh hoặc siêu dữ liệu về sự kiện.",
                    "key_duplicated_error": "Khoá không được trùng lặp.",
                    "key_missing_error": "Khoá là bắt buộc.",
                    "value_missing_error": "Giá trị là bắt buộc.",
                    "invalid_key_error": "Khoá không hợp lệ",
                    "invalid_value_error": "Giá trị không hợp lệ",
                    "test": "Kiểm tra",
                    "test_webhook": "Kiểm tra webhook của bạn",
                    "test_webhook_description": "Cấu hình webhook và kiểm tra bằng payload mẫu cho từng sự kiện được chọn để xác minh việc tiếp nhận và xử lý đúng.",
                    "send_test_payload": "Gửi payload kiểm tra",
                    "test_result": {
                        "endpoint_url": "URL endpoint: {{url}}",
                        "message": "Thông báo: {{message}}",
                        "response_status": "Trạng thái phản hồi: {{status, number}}",
                        "response_body": "Nội dung phản hồi: {{body}}",
                        "request_time": "Thời gian yêu cầu: {{time}}",
                        "test_success": "Kiểm tra webhook tới endpoint đã thành công."
                    }
                }
            },
            "domain": {
                "status": {
                    "connecting": "Đang kết nối...",
                    "in_use": "Đang sử dụng",
                    "failed_to_connect": "Kết nối thất bại"
                },
                "update_endpoint_notice": "Đừng quên cập nhật tên miền cho callback URI của Trình kết nối mạng xã hội và endpoint Logto trong ứng dụng của bạn nếu bạn muốn dùng tên miền tuỳ chỉnh cho các tính năng này.",
                "error_hint": "Hãy đảm bảo cập nhật bản ghi DNS của bạn. Chúng tôi sẽ tiếp tục kiểm tra sau mỗi {{value}} giây.",
                "custom": {
                    "custom_domain": "Tên miền tuỳ chỉnh",
                    "custom_domain_description": "Nâng tầm thương hiệu bằng cách dùng tên miền tuỳ chỉnh. Tên miền này sẽ được dùng trong trải nghiệm đăng nhập của bạn.",
                    "custom_domain_field": "Tên miền tuỳ chỉnh",
                    "custom_domain_placeholder": "auth.domain.com",
                    "add_custom_domain_field": "Thêm tên miền tuỳ chỉnh",
                    "custom_domains_field": "Tên miền tuỳ chỉnh",
                    "add_domain": "Thêm tên miền",
                    "invalid_domain_format": "Vui lòng cung cấp URL tên miền hợp lệ với tối thiểu ba phần, ví dụ \"auth.domain.com.\"",
                    "verify_domain": "Xác minh tên miền",
                    "enable_ssl": "Bật SSL",
                    "checking_dns_tip": "Sau khi bạn cấu hình các bản ghi DNS, quá trình sẽ chạy tự động và có thể mất tới 24 giờ. Bạn có thể rời khỏi giao diện này trong khi nó đang chạy.",
                    "enable_ssl_tip": "Việc bật SSL sẽ chạy tự động và có thể mất tới 24 giờ. Bạn có thể rời khỏi giao diện này trong khi nó đang chạy.",
                    "generating_dns_records": "Đang tạo các bản ghi DNS...",
                    "add_dns_records": "Vui lòng thêm các bản ghi DNS này vào nhà cung cấp DNS của bạn.",
                    "dns_table": {
                        "type_field": "Loại",
                        "name_field": "Tên",
                        "value_field": "Giá trị"
                    },
                    "deletion": {
                        "delete_domain": "Xoá tên miền",
                        "reminder": "Xoá tên miền tuỳ chỉnh",
                        "description": "Bạn có chắc muốn xoá tên miền tuỳ chỉnh này không?",
                        "in_used_description": "Bạn có chắc muốn xoá tên miền tuỳ chỉnh \"<span>{{domain}}</span>\" này không?",
                        "in_used_tip": "Nếu trước đó bạn đã thiết lập tên miền tuỳ chỉnh này ở nhà cung cấp trình kết nối mạng xã hội hoặc endpoint ứng dụng, bạn sẽ cần sửa URI về tên miền mặc định của Logto \"<span>{{domain}}</span>\" trước. Điều này cần thiết để nút đăng nhập mạng xã hội hoạt động đúng.",
                        "deleted": "Xoá tên miền tuỳ chỉnh thành công!"
                    },
                    "config_custom_domain_description": "Cấu hình tên miền tuỳ chỉnh để thiết lập các tính năng sau: ứng dụng, trình kết nối mạng xã hội và trình kết nối doanh nghiệp."
                },
                "default": {
                    "default_domain": "Tên miền mặc định",
                    "default_domain_description": "Logto cung cấp sẵn một tên miền mặc định đã được cấu hình, sẵn sàng dùng ngay mà không cần thiết lập thêm. Tên miền mặc định này đóng vai trò là phương án dự phòng ngay cả khi bạn đã bật tên miền tuỳ chỉnh.",
                    "default_domain_field": "Tên miền mặc định của Logto"
                },
                "custom_endpoint_note": "Bạn có thể tuỳ chỉnh tên miền của các endpoint này theo nhu cầu. Chọn \"{{custom}}\" hoặc \"{{default}}\".",
                "custom_social_callback_url_note": "Bạn có thể tuỳ chỉnh tên miền của URI này để khớp với endpoint của ứng dụng. Chọn \"{{custom}}\" hoặc \"{{default}}\".",
                "custom_acs_url_note": "Bạn có thể tuỳ chỉnh tên miền của URI này để khớp với URL Assertion Consumer Service của nhà cung cấp danh tính. Chọn \"{{custom}}\" hoặc \"{{default}}\".",
                "switch_custom_domain_tip": "Đổi tên miền để xem endpoint tương ứng. Thêm tên miền qua <a>tên miền tuỳ chỉnh</a>.",
                "switch_saml_app_domain_tip": "Đổi tên miền để xem các URL tương ứng. Với giao thức SAML, các URL metadata có thể được lưu trên bất kỳ tên miền nào truy cập được. Tuy nhiên, tên miền được chọn sẽ quyết định URL dịch vụ SSO mà các SP dùng để chuyển hướng người dùng cuối đến xác thực, điều này ảnh hưởng đến trải nghiệm đăng nhập và cách hiển thị URL.",
                "switch_saml_connector_domain_tip": "Đổi tên miền để xem các URL tương ứng. Tên miền được chọn sẽ quyết định ACS URL của bạn, ảnh hưởng đến nơi người dùng được chuyển hướng đến sau khi đăng nhập SSO. Hãy chọn tên miền khớp với hành vi chuyển hướng mong đợi của ứng dụng."
            },
            "tenants": {
                "title": "Cài đặt",
                "description": "Quản lý cài đặt tenant hiệu quả và tuỳ chỉnh tên miền của bạn.",
                "oss_description": "Thay đổi cài đặt tài khoản và quản lý thông tin cá nhân của bạn tại đây để đảm bảo an toàn cho tài khoản.",
                "tabs": {
                    "settings": "Cài đặt",
                    "members": "Thành viên",
                    "domains": "Tên miền",
                    "oidc_configs": "Cấu hình OIDC",
                    "subscription": "Gói và thanh toán",
                    "billing_history": "Lịch sử thanh toán"
                },
                "members": {
                    "card_title": "Quản lý tenant an toàn hơn với Logto Cloud",
                    "card_description": "Thêm quản trị viên hoặc thành viên vào tenant của bạn mà không cần chia sẻ chung một tài khoản quản trị.",
                    "card_action": "Khám phá Logto Cloud"
                },
                "settings": {
                    "title": "CÀI ĐẶT",
                    "description": "Đặt tên tenant và xem vùng lưu trữ dữ liệu cùng loại tenant của bạn.",
                    "tenant_id": "Tenant ID",
                    "tenant_name": "Tên tenant",
                    "tenant_instance": "Chọn phiên bản của bạn",
                    "tenant_instance_description": "Chọn nơi tenant của bạn sẽ được lưu trữ. Chọn Logto Cloud cho hạ tầng chung công khai, hoặc phiên bản riêng để có tài nguyên chuyên dụng.",
                    "tenant_region": "Vùng dữ liệu",
                    "tenant_region_description": "Vị trí vật lý nơi lưu trữ tài nguyên tenant của bạn (người dùng, ứng dụng, v.v.). Không thể thay đổi sau khi tạo.",
                    "tenant_region_tip": "Tài nguyên tenant của bạn được lưu trữ tại {{region}}. <a>Tìm hiểu thêm</a>",
                    "environment_tag_development": "Dev",
                    "environment_tag_production": "Prod",
                    "tenant_type": "Loại tenant",
                    "development_description": "Chỉ dùng để thử nghiệm và không nên dùng trong môi trường production. Không yêu cầu gói đăng ký. Nó có đầy đủ tính năng pro nhưng có giới hạn như banner đăng nhập.",
                    "production_description": "Dành cho các ứng dụng đang được người dùng cuối sử dụng và có thể yêu cầu gói đăng ký trả phí.",
                    "tenant_info_saved": "Đã lưu thông tin tenant thành công.",
                    "tenant_mfa": "Xác thực đa yếu tố",
                    "tenant_mfa_description": "Yêu cầu các thành viên của bạn thiết lập xác thực đa yếu tố để truy cập tenant này.",
                    "enterprise_sso": "Enterprise SSO",
                    "enterprise_sso_description": "Có sẵn trên các gói trả phí. Liên hệ với chúng tôi để bật enterprise SSO để mọi thành viên có thể đăng nhập vào Logto Cloud Console bằng nhà cung cấp danh tính của tổ chức bạn."
                },
                "full_env_tag": {
                    "development": "Development",
                    "production": "Production"
                },
                "deletion_card": {
                    "title": "XOÁ",
                    "tenant_deletion": "Xoá tenant",
                    "tenant_deletion_description": "Xoá tenant sẽ dẫn đến việc gỡ bỏ vĩnh viễn toàn bộ dữ liệu người dùng và cấu hình liên quan. Vui lòng thực hiện thận trọng.",
                    "tenant_deletion_button": "Xoá tenant"
                },
                "leave_tenant_card": {
                    "title": "RỜI KHỎI",
                    "leave_tenant": "Rời khỏi tenant",
                    "leave_tenant_description": "Mọi tài nguyên trong tenant sẽ được giữ lại nhưng bạn không còn quyền truy cập tenant này.",
                    "last_admin_note": "Để rời khỏi tenant này, hãy đảm bảo có ít nhất một thành viên khác giữ vai trò Admin."
                },
                "create_modal": {
                    "title": "Tạo tenant",
                    "subtitle": "Tạo một tenant mới có tài nguyên và người dùng tách biệt.",
                    "tenant_id": "Tenant ID",
                    "tenant_usage_purpose": "Bạn muốn dùng tenant này để làm gì?",
                    "development_description": "Chỉ dùng để thử nghiệm và không nên dùng trong môi trường production. Không yêu cầu gói đăng ký.",
                    "development_description_for_private_regions": "Chỉ dùng để thử nghiệm và không nên dùng trong môi trường production.",
                    "development_hint": "Nó có đầy đủ tính năng pro nhưng có giới hạn như banner đăng nhập.",
                    "production_description": "Dành cho người dùng cuối và có thể yêu cầu gói đăng ký trả phí.",
                    "available_plan": "Gói khả dụng:",
                    "create_button": "Tạo tenant",
                    "tenant_name_placeholder": "Tenant của tôi",
                    "tenant_created": "Đã tạo tenant thành công.",
                    "invitation_failed": "Một số lời mời gửi không thành công. Vui lòng thử lại sau trong Cài đặt -> Thành viên.",
                    "tenant_type_description": "Không thể thay đổi sau khi tạo.",
                    "tenant_id_invalid": "Tenant ID chỉ có thể chứa chữ thường, số và dấu gạch ngang, và không được vượt quá {{max}} ký tự.",
                    "tenant_id_placeholder": "Tenant ID của bạn",
                    "tenant_id_tip": "Tuỳ chỉnh Tenant ID. Nếu để trống, Logto sẽ tạo một ID mặc định. Không thể thay đổi Tenant ID sau khi tạo."
                },
                "dev_tenant_migration": {
                    "title": "Giờ đây bạn có thể dùng thử các tính năng Pro miễn phí bằng cách tạo một \"Development tenant\" mới!",
                    "affect_title": "Điều này ảnh hưởng đến bạn như thế nào?",
                    "hint_1": "Chúng tôi đang thay thế các <strong>nhãn môi trường</strong> cũ bằng hai loại tenant mới: <strong>“Development”</strong> và <strong>“Production”</strong>.",
                    "hint_2": "Để đảm bảo quá trình chuyển đổi liền mạch và chức năng không bị gián đoạn, tất cả các tenant tạo sớm sẽ được nâng lên loại tenant <strong>Production</strong> cùng với gói đăng ký trước đó của bạn.",
                    "hint_3": "Đừng lo, mọi cài đặt khác của bạn sẽ vẫn giữ nguyên.",
                    "about_tenant_type": "Về loại tenant"
                },
                "delete_modal": {
                    "title": "Xoá tenant",
                    "description_line1": "Bạn có chắc muốn xoá tenant \"<span>{{name}}</span>\" với nhãn hậu tố môi trường \"<span>{{tag}}</span>\" không? Hành động này không thể hoàn tác, và sẽ dẫn đến việc xoá vĩnh viễn toàn bộ dữ liệu cùng thông tin tenant của bạn.",
                    "description_line2": "Trước khi xoá tenant, có thể chúng tôi giúp được bạn. <span><a>Liên hệ chúng tôi qua Email</a></span>",
                    "description_line3": "Nếu bạn muốn tiếp tục, vui lòng nhập tên tenant \"<span>{{name}}</span>\" để xác nhận.",
                    "delete_button": "Xoá vĩnh viễn",
                    "cannot_delete_title": "Không thể xoá tenant này",
                    "cannot_delete_description": "Rất tiếc, bạn không thể xoá tenant này ngay lúc này. Vui lòng đảm bảo bạn đang dùng gói Free và đã thanh toán mọi khoản còn nợ."
                },
                "leave_tenant_modal": {
                    "description": "Bạn có chắc muốn rời khỏi tenant này không?",
                    "leave_button": "Rời khỏi"
                },
                "tenant_landing_page": {
                    "title": "Bạn chưa tạo tenant nào",
                    "description": "Để bắt đầu cấu hình dự án của bạn với Logto, vui lòng tạo một tenant mới. Nếu bạn cần đăng xuất hoặc xoá tài khoản, chỉ cần nhấp vào nút ảnh đại diện ở góc trên bên phải.",
                    "create_tenant_button": "Tạo tenant"
                },
                "status": {
                    "mau_exceeded": "Vượt MAU",
                    "token_exceeded": "Vượt token",
                    "suspended": "Đã tạm ngưng",
                    "overdue": "Quá hạn"
                },
                "tenant_suspended_page": {
                    "title": "Tenant đã bị tạm ngưng. Liên hệ chúng tôi để khôi phục quyền truy cập.",
                    "description_1": "Chúng tôi rất tiếc phải thông báo rằng tài khoản tenant của bạn đã bị tạm ngưng do sử dụng không đúng cách, bao gồm vượt hạn mức MAU, thanh toán quá hạn, hoặc các hành động trái phép khác.",
                    "description_2": "Nếu bạn cần làm rõ thêm, có bất kỳ thắc mắc nào, hoặc muốn khôi phục đầy đủ chức năng và bỏ chặn các tenant của mình, vui lòng đừng ngần ngại liên hệ với chúng tôi ngay lập tức."
                },
                "production_tenant_notification": {
                    "text": "Bạn đang ở trong một dev tenant để thử nghiệm miễn phí. Tạo một production tenant để đưa vào hoạt động.",
                    "action": "Tạo tenant"
                }
            },
            "tenant_members": {
                "members": "Thành viên",
                "invitations": "Lời mời",
                "invite_members": "Mời thành viên",
                "user": "Người dùng",
                "roles": "Vai trò",
                "admin": "Admin",
                "collaborator": "Collaborator",
                "invitation_status": "Trạng thái lời mời",
                "inviter": "Người mời",
                "expiration_date": "Ngày hết hạn",
                "invite_modal": {
                    "title": "Mời mọi người vào Logto Cloud",
                    "subtitle": "Để mời thành viên vào một tổ chức, họ phải chấp nhận lời mời.",
                    "to": "Đến",
                    "added_as": "Thêm với vai trò",
                    "email_input_placeholder": "johndoe@example.com"
                },
                "invitation_statuses": {
                    "pending": "Đang chờ",
                    "accepted": "Đã chấp nhận",
                    "expired": "Đã hết hạn",
                    "revoked": "Đã thu hồi"
                },
                "invitation_empty_placeholder": {
                    "title": "Mời thành viên nhóm",
                    "description": "Tenant của bạn hiện chưa có thành viên nào được mời.\nĐể hỗ trợ việc tích hợp, hãy cân nhắc thêm nhiều thành viên hoặc quản trị viên hơn."
                },
                "menu_options": {
                    "edit": "Sửa vai trò tenant",
                    "delete": "Gỡ người dùng khỏi tenant",
                    "resend_invite": "Gửi lại lời mời",
                    "revoke": "Thu hồi lời mời",
                    "delete_invitation_record": "Xoá bản ghi lời mời này"
                },
                "edit_modal": {
                    "title": "Thay đổi vai trò của {{name}}"
                },
                "delete_user_confirm": "Bạn có chắc muốn gỡ người dùng này khỏi tenant này không?",
                "assign_admin_confirm": "Bạn có chắc muốn cấp quyền admin cho (những) người dùng đã chọn không? Cấp quyền admin sẽ trao cho (những) người dùng đó các quyền sau.<ul><li>Thay đổi gói thanh toán của tenant</li><li>Thêm hoặc gỡ thành viên</li><li>Xoá tenant</li></ul>",
                "revoke_invitation_confirm": "Bạn có chắc muốn thu hồi lời mời này không?",
                "delete_invitation_confirm": "Bạn có chắc muốn xoá bản ghi lời mời này không?",
                "messages": {
                    "invitation_sent": "Đã gửi lời mời.",
                    "invitation_revoked": "Đã thu hồi lời mời.",
                    "invitation_resend": "Đã gửi lại lời mời.",
                    "invitation_deleted": "Đã xoá bản ghi lời mời."
                },
                "errors": {
                    "email_required": "Cần có email của người được mời.",
                    "email_exists": "Địa chỉ email đã tồn tại.",
                    "member_exists": "Người dùng này đã là thành viên của tổ chức này.",
                    "pending_invitation_exists": "Đã có lời mời đang chờ. Hãy xoá email liên quan hoặc thu hồi lời mời.",
                    "invalid_email": "Địa chỉ email không hợp lệ. Vui lòng đảm bảo email đúng định dạng.",
                    "max_member_limit": "Bạn đã đạt số lượng thành viên tối đa ({{limit}}) cho tenant này."
                }
            },
            "topbar": {
                "docs": "Tài liệu",
                "help": "Trợ giúp",
                "subscription": "Gói dịch vụ"
            },
            "subscription": {
                "free_plan": "Gói Free",
                "free_plan_description": "Dành cho dự án phụ và dùng thử Logto ban đầu. Không cần thẻ tín dụng.",
                "pro_plan": "Gói Pro",
                "pro_plan_description": "Dành cho doanh nghiệp an tâm tận hưởng Logto.",
                "enterprise": "Gói Enterprise",
                "enterprise_description": "Dành cho đội nhóm và doanh nghiệp lớn với yêu cầu ở cấp doanh nghiệp.",
                "admin_plan": "Gói Admin",
                "dev_plan": "Gói Development",
                "current_plan": "Gói hiện tại",
                "current_plan_description": "Đây là gói hiện tại của bạn. Bạn có thể dễ dàng xem mức sử dụng gói, kiểm tra hoá đơn sắp tới và thay đổi gói khi cần.",
                "plan_usage": "Mức sử dụng gói",
                "plan_cycle": "Chu kỳ gói: {{period}}. Mức sử dụng làm mới vào {{renewDate}}.",
                "next_bill": "Hoá đơn sắp tới của bạn",
                "next_bill_hint": "Để tìm hiểu thêm về cách tính, vui lòng tham khảo <a>bài viết này</a>.",
                "next_bill_tip": "Giá hiển thị ở đây chưa bao gồm thuế và có thể chậm cập nhật đôi chút. Số thuế sẽ được tính dựa trên thông tin bạn cung cấp và yêu cầu pháp lý tại địa phương của bạn, và sẽ hiển thị trong hoá đơn của bạn.",
                "manage_payment": "Quản lý thanh toán",
                "overfill_quota_warning": "Bạn đã đạt hạn mức. Để tránh sự cố, hãy nâng cấp gói.",
                "upgrade_pro": "Nâng cấp lên Pro",
                "update_payment": "Cập nhật thanh toán",
                "payment_error": "Phát hiện sự cố thanh toán. Không thể xử lý ${{price, number}} cho chu kỳ trước. Hãy cập nhật thanh toán để tránh việc dịch vụ Logto bị tạm ngưng.",
                "downgrade": "Hạ gói",
                "current": "Hiện tại",
                "upgrade": "Nâng cấp",
                "quota_table": {
                    "quota": {
                        "title": "Cơ bản",
                        "base_price": "Giá cơ bản",
                        "mau_limit": "Hạn mức MAU",
                        "included_tokens": "Token đã bao gồm"
                    },
                    "application": {
                        "title": "Ứng dụng",
                        "total": "Tổng số ứng dụng",
                        "m2m": "Ứng dụng máy-với-máy (M2M)",
                        "third_party": "Ứng dụng bên thứ ba OIDC/OAuth",
                        "saml_app": "Ứng dụng SAML"
                    },
                    "resource": {
                        "title": "Tài nguyên API",
                        "resource_count": "Số tài nguyên",
                        "scopes_per_resource": "Số quyền mỗi tài nguyên"
                    },
                    "branding": {
                        "title": "Giao diện và thương hiệu",
                        "custom_domain": "Tên miền tuỳ chỉnh",
                        "custom_css": "CSS tuỳ chỉnh",
                        "logo_and_favicon": "Logo và favicon",
                        "bring_your_ui": "Dùng giao diện của bạn",
                        "dark_mode": "Chế độ tối",
                        "i18n": "Đa ngôn ngữ"
                    },
                    "user_authn": {
                        "title": "Xác thực người dùng",
                        "omni_sign_in": "Đăng nhập đa kênh",
                        "password": "Mật khẩu",
                        "passwordless": "Không mật khẩu - Email và SMS",
                        "email_connector": "Trình kết nối email",
                        "sms_connector": "Trình kết nối SMS",
                        "social_connectors": "Trình kết nối mạng xã hội",
                        "standard_connectors": "Trình kết nối tiêu chuẩn",
                        "built_in_email_connector": "Trình kết nối email tích hợp sẵn",
                        "mfa": "Xác thực đa yếu tố",
                        "sso": "Enterprise SSO",
                        "impersonation": "Mạo danh"
                    },
                    "user_management": {
                        "title": "Quản lý người dùng",
                        "user_management": "Quản lý người dùng",
                        "roles": "Vai trò",
                        "machine_to_machine_roles": "Vai trò máy-với-máy",
                        "scopes_per_role": "Số quyền mỗi vai trò"
                    },
                    "organizations": {
                        "title": "Tổ chức",
                        "organizations": "Tổ chức",
                        "organization": "Tổ chức",
                        "organization_count": "Số tổ chức",
                        "allowed_users_per_org": "Số người dùng mỗi tổ chức",
                        "invitation": "Lời mời (Management API)",
                        "org_roles": "Vai trò tổ chức",
                        "org_permissions": "Quyền tổ chức",
                        "just_in_time_provisioning": "Cấp phát đúng lúc"
                    },
                    "support": {
                        "title": "Hỗ trợ",
                        "community": "Cộng đồng",
                        "customer_ticket": "Hỗ trợ qua ticket",
                        "premium": "Premium",
                        "email_ticket_support": "Hỗ trợ qua ticket email",
                        "discord_private_channel": "Kênh Discord riêng",
                        "premium_support": "Hỗ trợ cao cấp",
                        "developer_onboarding": "Hướng dẫn khởi tạo cho nhà phát triển",
                        "solution_engineer_support": "Kỹ sư giải pháp",
                        "sla": "SLA",
                        "dedicated_computing_resources": "Tài nguyên tính toán riêng"
                    },
                    "compliance": {
                        "title": "Tuân thủ",
                        "soc2_compliant": "Tuân thủ SOC2",
                        "soc2_report": "Báo cáo SOC2",
                        "hipaa_or_baa_report": "Báo cáo HIPAA/BAA"
                    },
                    "developers_and_platform": {
                        "title": "Nhà phát triển và nền tảng",
                        "hooks": "Webhook",
                        "audit_logs_retention": "Thời gian lưu nhật ký kiểm toán",
                        "jwt_claims": "JWT claims",
                        "tenant_members": "Thành viên tenant"
                    },
                    "unlimited": "Không giới hạn",
                    "contact": "Liên hệ",
                    "monthly_price": "${{value, number}}/tháng",
                    "days": "{{count, number}} ngày",
                    "days_other": "{{count, number}} ngày",
                    "add_on": "Tiện ích bổ sung",
                    "tier": "Bậc {{value, number}}: ",
                    "million": "{{value, number}} triệu",
                    "mau_tip": "MAU (người dùng hoạt động hàng tháng) là số người dùng duy nhất đã trao đổi ít nhất một token với Logto trong một chu kỳ thanh toán.",
                    "tokens_tip": "Mọi loại token do Logto cấp, bao gồm access token, refresh token, v.v.",
                    "mao_tip": "MAO (tổ chức hoạt động hàng tháng) là số tổ chức duy nhất có ít nhất một MAU (người dùng hoạt động hàng tháng) trong một chu kỳ thanh toán.",
                    "third_party_tip": "Dùng Logto làm nhà cung cấp danh tính OIDC cho việc đăng nhập và cấp quyền của ứng dụng bên thứ ba.",
                    "included": "Đã bao gồm {{value, number}}",
                    "included_mao": "Đã bao gồm {{value, number}} MAO",
                    "extra_quota_price": "Sau đó ${{value, number}}/tháng / mỗi cái khi vượt",
                    "extra_token_price": "Sau đó ${{value, number}}/tháng / {{amount, number}} khi vượt",
                    "per_month_each": "${{value, number}}/tháng / mỗi cái",
                    "extra_mao_price": "Sau đó ${{value, number}} mỗi MAO",
                    "per_month": "${{value, number}}/tháng",
                    "per_member": "Sau đó ${{value, number}} mỗi thành viên"
                },
                "billing_history": {
                    "invoice_column": "Hoá đơn",
                    "status_column": "Trạng thái",
                    "amount_column": "Số tiền",
                    "invoice_created_date_column": "Ngày tạo hoá đơn",
                    "invoice_status": {
                        "void": "Đã huỷ",
                        "paid": "Đã thanh toán",
                        "open": "Đang mở",
                        "uncollectible": "Quá hạn"
                    }
                },
                "quota_item": {
                    "tenant_limit": {
                        "name": "Tenant",
                        "limited": "{{count, number}} tenant",
                        "limited_other": "{{count, number}} tenant",
                        "unlimited": "Không giới hạn tenant",
                        "not_eligible": "Xoá bớt tenant của bạn"
                    },
                    "mau_limit": {
                        "name": "Người dùng hoạt động hàng tháng",
                        "limited": "{{count, number}} MAU",
                        "unlimited": "Không giới hạn MAU",
                        "not_eligible": "Xoá tất cả người dùng của bạn"
                    },
                    "token_limit": {
                        "name": "Token",
                        "limited": "{{count, number}} token",
                        "limited_other": "{{count, number}} token",
                        "unlimited": "Không giới hạn token",
                        "not_eligible": "Xoá tất cả người dùng của bạn để ngăn cấp token mới"
                    },
                    "applications_limit": {
                        "name": "Ứng dụng",
                        "limited": "{{count, number}} ứng dụng",
                        "limited_other": "{{count, number}} ứng dụng",
                        "unlimited": "Không giới hạn ứng dụng",
                        "not_eligible": "Xoá bớt ứng dụng của bạn"
                    },
                    "machine_to_machine_limit": {
                        "name": "Máy-với-máy",
                        "limited": "{{count, number}} ứng dụng máy-với-máy",
                        "limited_other": "{{count, number}} ứng dụng máy-với-máy",
                        "unlimited": "Không giới hạn ứng dụng máy-với-máy",
                        "not_eligible": "Xoá bớt ứng dụng máy-với-máy của bạn"
                    },
                    "third_party_applications_limit": {
                        "name": "Ứng dụng bên thứ ba",
                        "limited": "{{count, number}} ứng dụng bên thứ ba",
                        "limited_other": "{{count, number}} ứng dụng bên thứ ba",
                        "unlimited": "Không giới hạn ứng dụng bên thứ ba",
                        "not_eligible": "Xoá bớt ứng dụng bên thứ ba của bạn"
                    },
                    "resources_limit": {
                        "name": "Tài nguyên API",
                        "limited": "{{count, number}} tài nguyên API",
                        "limited_other": "{{count, number}} tài nguyên API",
                        "unlimited": "Không giới hạn tài nguyên API",
                        "not_eligible": "Xoá bớt tài nguyên API của bạn"
                    },
                    "scopes_per_resource_limit": {
                        "name": "Quyền tài nguyên",
                        "limited": "{{count, number}} quyền mỗi tài nguyên",
                        "limited_other": "{{count, number}} quyền mỗi tài nguyên",
                        "unlimited": "Không giới hạn quyền mỗi tài nguyên",
                        "not_eligible": "Xoá bớt quyền tài nguyên của bạn"
                    },
                    "custom_domain_enabled": {
                        "name": "Tên miền tuỳ chỉnh",
                        "limited": "Tên miền tuỳ chỉnh",
                        "unlimited": "Tên miền tuỳ chỉnh",
                        "not_eligible": "Xoá tên miền tuỳ chỉnh của bạn"
                    },
                    "omni_sign_in_enabled": {
                        "name": "Đăng nhập đa kênh",
                        "limited": "Đăng nhập đa kênh",
                        "unlimited": "Đăng nhập đa kênh",
                        "not_eligible": "Tắt đăng nhập đa kênh của bạn"
                    },
                    "built_in_email_connector_enabled": {
                        "name": "Trình kết nối email tích hợp sẵn",
                        "limited": "Trình kết nối email tích hợp sẵn",
                        "unlimited": "Trình kết nối email tích hợp sẵn",
                        "not_eligible": "Xoá trình kết nối email tích hợp sẵn của bạn"
                    },
                    "social_connectors_limit": {
                        "name": "Trình kết nối mạng xã hội",
                        "limited": "{{count, number}} trình kết nối mạng xã hội",
                        "limited_other": "{{count, number}} trình kết nối mạng xã hội",
                        "unlimited": "Không giới hạn trình kết nối mạng xã hội",
                        "not_eligible": "Xoá bớt trình kết nối mạng xã hội của bạn"
                    },
                    "standard_connectors_limit": {
                        "name": "Trình kết nối tiêu chuẩn miễn phí",
                        "limited": "{{count, number}} trình kết nối tiêu chuẩn miễn phí",
                        "limited_other": "{{count, number}} trình kết nối tiêu chuẩn miễn phí",
                        "unlimited": "Không giới hạn trình kết nối tiêu chuẩn",
                        "not_eligible": "Xoá bớt trình kết nối tiêu chuẩn của bạn"
                    },
                    "roles_limit": {
                        "name": "Vai trò",
                        "limited": "{{count, number}} vai trò",
                        "limited_other": "{{count, number}} vai trò",
                        "unlimited": "Không giới hạn vai trò",
                        "not_eligible": "Xoá bớt vai trò của bạn"
                    },
                    "machine_to_machine_roles_limit": {
                        "name": "Vai trò máy-với-máy",
                        "limited": "{{count, number}} vai trò máy-với-máy",
                        "limited_other": "{{count, number}} vai trò máy-với-máy",
                        "unlimited": "Không giới hạn vai trò máy-với-máy",
                        "not_eligible": "Xoá bớt vai trò máy-với-máy của bạn"
                    },
                    "scopes_per_role_limit": {
                        "name": "Quyền vai trò",
                        "limited": "{{count, number}} quyền mỗi vai trò",
                        "limited_other": "{{count, number}} quyền mỗi vai trò",
                        "unlimited": "Không giới hạn quyền mỗi vai trò",
                        "not_eligible": "Xoá bớt quyền vai trò của bạn"
                    },
                    "hooks_limit": {
                        "name": "Webhook",
                        "limited": "{{count, number}} webhook",
                        "limited_other": "{{count, number}} webhook",
                        "unlimited": "Không giới hạn webhook",
                        "not_eligible": "Xoá bớt webhook của bạn"
                    },
                    "organizations_enabled": {
                        "name": "Tổ chức",
                        "limited": "Tổ chức",
                        "unlimited": "Tổ chức",
                        "not_eligible": "Xoá bớt tổ chức của bạn"
                    },
                    "audit_logs_retention_days": {
                        "name": "Thời gian lưu nhật ký kiểm toán",
                        "limited": "Thời gian lưu nhật ký kiểm toán: {{count, number}} ngày",
                        "limited_other": "Thời gian lưu nhật ký kiểm toán: {{count, number}} ngày",
                        "unlimited": "Không giới hạn số ngày",
                        "not_eligible": "Không có nhật ký kiểm toán"
                    },
                    "email_ticket_support": {
                        "name": "Hỗ trợ qua ticket email",
                        "limited": "Hỗ trợ qua ticket email {{count, number}} giờ",
                        "limited_other": "Hỗ trợ qua ticket email {{count, number}} giờ",
                        "unlimited": "Hỗ trợ qua ticket email",
                        "not_eligible": "Không hỗ trợ qua ticket email"
                    },
                    "mfa_enabled": {
                        "name": "Xác thực đa yếu tố",
                        "limited": "Xác thực đa yếu tố",
                        "unlimited": "Xác thực đa yếu tố",
                        "not_eligible": "Xoá xác thực đa yếu tố của bạn"
                    },
                    "sso_enabled": {
                        "name": "Enterprise SSO",
                        "limited": "Enterprise SSO",
                        "unlimited": "Enterprise SSO",
                        "not_eligible": "Xoá Enterprise SSO của bạn"
                    },
                    "tenant_members_limit": {
                        "name": "Thành viên tenant",
                        "limited": "{{count, number}} thành viên tenant",
                        "limited_other": "{{count, number}} thành viên tenant",
                        "unlimited": "Không giới hạn thành viên tenant",
                        "not_eligible": "Xoá bớt thành viên tenant của bạn"
                    },
                    "custom_jwt_enabled": {
                        "name": "JWT tuỳ chỉnh",
                        "limited": "JWT tuỳ chỉnh",
                        "unlimited": "JWT tuỳ chỉnh",
                        "not_eligible": "Xoá trình tuỳ chỉnh JWT claims của bạn"
                    },
                    "impersonation_enabled": {
                        "name": "Mạo danh",
                        "limited": "Mạo danh",
                        "unlimited": "Mạo danh",
                        "not_eligible": "Không cho phép mạo danh"
                    },
                    "bring_your_ui_enabled": {
                        "name": "Dùng giao diện của bạn",
                        "limited": "Dùng giao diện của bạn",
                        "unlimited": "Dùng giao diện của bạn",
                        "not_eligible": "Xoá tài nguyên giao diện tuỳ chỉnh của bạn"
                    },
                    "collect_user_profile_enabled": {
                        "name": "Thu thập hồ sơ người dùng",
                        "limited": "Thu thập hồ sơ người dùng",
                        "unlimited": "Thu thập hồ sơ người dùng",
                        "not_eligible": "Xoá các trường thu thập hồ sơ người dùng của bạn"
                    },
                    "idp_initiated_sso_enabled": {
                        "name": "SSO khởi tạo từ IDP",
                        "limited": "SSO khởi tạo từ IDP",
                        "unlimited": "SSO khởi tạo từ IDP",
                        "not_eligible": "Không cho phép SSO khởi tạo từ IDP"
                    },
                    "saml_applications_limit": {
                        "name": "Ứng dụng SAML",
                        "limited": "{{count, number}} ứng dụng SAML",
                        "limited_other": "{{count, number}} ứng dụng SAML",
                        "unlimited": "Không giới hạn ứng dụng SAML",
                        "not_eligible": "Xoá bớt ứng dụng SAML của bạn"
                    },
                    "captcha_enabled": {
                        "name": "CAPTCHA",
                        "limited": "CAPTCHA",
                        "unlimited": "CAPTCHA",
                        "not_eligible": "Xoá CAPTCHA của bạn"
                    },
                    "security_features_enabled": {
                        "name": "Bảo mật nâng cao",
                        "limited": "Bảo mật nâng cao",
                        "unlimited": "Bảo mật nâng cao",
                        "not_eligible": "Xoá cài đặt bảo mật nâng cao của bạn"
                    },
                    "custom_domains_limit": {
                        "name": "Tên miền tuỳ chỉnh",
                        "limited": "{{count, number}} tên miền tuỳ chỉnh",
                        "limited_other": "{{count, number}} tên miền tuỳ chỉnh",
                        "unlimited": "Không giới hạn tên miền tuỳ chỉnh",
                        "not_eligible": "Xoá bớt tên miền tuỳ chỉnh của bạn"
                    },
                    "passkey_sign_in_enabled": {
                        "name": "Đăng nhập bằng passkey",
                        "limited": "Đăng nhập bằng passkey",
                        "unlimited": "Đăng nhập bằng passkey",
                        "not_eligible": "Không hỗ trợ đăng nhập bằng passkey"
                    }
                },
                "downgrade_modal": {
                    "title": "Bạn có chắc muốn hạ gói không?",
                    "description": "Nếu bạn chọn chuyển sang <targetName/>, xin lưu ý rằng bạn sẽ không còn được dùng hạn mức và tính năng vốn có trước đây trong <currentName/>.",
                    "before": "Trước: <name/>",
                    "after": "Sau: <name />",
                    "downgrade": "Hạ gói"
                },
                "not_eligible_modal": {
                    "downgrade_title": "Bạn chưa đủ điều kiện để hạ gói",
                    "downgrade_description": "Hãy đảm bảo bạn đáp ứng các tiêu chí sau trước khi hạ xuống <name/>.",
                    "downgrade_help_tip": "Cần trợ giúp hạ gói? <a>Liên hệ</a>.",
                    "upgrade_title": "Lời nhắc thân thiện dành cho những người dùng tiên phong đáng quý của chúng tôi",
                    "upgrade_description": "Bạn hiện đang dùng vượt quá mức mà <name /> cho phép. Logto nay đã chính thức, bao gồm các tính năng được thiết kế riêng cho từng gói. Trước khi cân nhắc nâng cấp lên <name />, hãy đảm bảo bạn đáp ứng các tiêu chí sau trước khi nâng cấp.",
                    "upgrade_pro_tip": " Hoặc cân nhắc nâng cấp lên gói Pro.",
                    "upgrade_help_tip": "Cần trợ giúp nâng cấp? <a>Liên hệ</a>.",
                    "a_maximum_of": "Tối đa <item/>"
                },
                "upgrade_success": "Đã nâng cấp thành công lên <name/>",
                "downgrade_success": "Đã hạ gói thành công xuống <name/>",
                "subscription_check_timeout": "Kiểm tra gói đăng ký đã quá thời gian. Vui lòng làm mới lại sau.",
                "no_subscription": "Không có gói đăng ký",
                "usage": {
                    "status_active": "Đang dùng",
                    "status_inactive": "Không dùng",
                    "limited_status_quota_description": "(Đã bao gồm {{quota}} đầu tiên)",
                    "unlimited_status_quota_description": "(Đã bao gồm)",
                    "disabled_status_quota_description": "(Không bao gồm)",
                    "usage_description_with_unlimited_quota": "{{usage}}<span> (Không giới hạn)</span>",
                    "usage_description_with_limited_quota": "{{usage}}<span> (Đã bao gồm {{basicQuota}} đầu tiên)</span>",
                    "usage_description_without_quota": "{{usage}}<span> (Không bao gồm)</span>",
                    "mau": {
                        "title": "MAU",
                        "tooltip": "MAU là người dùng duy nhất đã trao đổi ít nhất một token với Logto trong một chu kỳ thanh toán. Không giới hạn với gói Pro. <a>Tìm hiểu thêm</a>",
                        "tooltip_for_enterprise": "MAU là người dùng duy nhất đã trao đổi ít nhất một token với Logto trong một chu kỳ thanh toán. Không giới hạn với gói Enterprise."
                    },
                    "organizations": {
                        "title": "Tổ chức",
                        "tooltip": "Tính năng tiện ích bổ sung với mức phí cố định ${{price, number}} mỗi tháng. Giá không phụ thuộc vào số lượng tổ chức hay mức độ hoạt động của chúng.",
                        "description_for_enterprise": "(Đã bao gồm)",
                        "tooltip_for_enterprise": "Việc bao gồm tuỳ thuộc vào gói của bạn. Nếu tính năng tổ chức không có trong hợp đồng ban đầu, nó sẽ được thêm vào hoá đơn khi bạn kích hoạt. Tiện ích bổ sung có giá ${{price, number}}/tháng, bất kể số lượng tổ chức hay mức độ hoạt động của chúng.",
                        "tooltip_for_enterprise_with_numbered_basic_quota": "Gói của bạn đã bao gồm {{basicQuota}} tổ chức đầu tiên miễn phí. Nếu cần thêm, bạn có thể bổ sung bằng tiện ích tổ chức với mức phí cố định ${{price, number}} mỗi tháng, bất kể số lượng tổ chức hay mức độ hoạt động của chúng."
                    },
                    "mfa": {
                        "title": "MFA",
                        "tooltip": "Tính năng tiện ích bổ sung với mức phí cố định ${{price, number}} mỗi tháng. Giá không phụ thuộc vào số lượng yếu tố xác thực được dùng.",
                        "tooltip_for_enterprise": "Việc bao gồm tuỳ thuộc vào gói của bạn. Nếu tính năng MFA không có trong hợp đồng ban đầu, nó sẽ được thêm vào hoá đơn khi bạn kích hoạt. Tiện ích bổ sung có giá ${{price, number}}/tháng, bất kể số lượng yếu tố xác thực được dùng."
                    },
                    "enterprise_sso": {
                        "title": "Enterprise SSO",
                        "tooltip": "Tính năng tiện ích bổ sung với giá ${{price, number}} mỗi kết nối SSO mỗi tháng.",
                        "tooltip_for_enterprise": "Tính năng tiện ích bổ sung với giá ${{price, number}} mỗi kết nối SSO mỗi tháng. {{basicQuota}} SSO đầu tiên đã được bao gồm và dùng miễn phí trong gói theo hợp đồng của bạn."
                    },
                    "api_resources": {
                        "title": "Tài nguyên API",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi tài nguyên mỗi tháng. 3 tài nguyên API đầu tiên miễn phí.",
                        "tooltip_for_enterprise": "{{basicQuota}} tài nguyên API đầu tiên đã được bao gồm và dùng miễn phí trong gói theo hợp đồng của bạn. Nếu cần thêm, ${{price, number}} mỗi tài nguyên API mỗi tháng."
                    },
                    "machine_to_machine": {
                        "title": "Máy-với-máy",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi ứng dụng mỗi tháng. Ứng dụng máy-với-máy đầu tiên miễn phí.",
                        "tooltip_for_enterprise": "{{basicQuota}} ứng dụng máy-với-máy đầu tiên được dùng miễn phí trong gói theo hợp đồng của bạn. Nếu cần thêm, ${{price, number}} mỗi ứng dụng mỗi tháng."
                    },
                    "tenant_members": {
                        "title": "Thành viên tenant",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi thành viên mỗi tháng. {{count}} thành viên tenant đầu tiên miễn phí.",
                        "tooltip_one": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi thành viên mỗi tháng. {{count}} thành viên tenant đầu tiên miễn phí.",
                        "tooltip_other": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi thành viên mỗi tháng. {{count}} thành viên tenant đầu tiên miễn phí.",
                        "tooltip_for_enterprise": "{{count}} thành viên tenant đầu tiên đã được bao gồm và dùng miễn phí trong gói theo hợp đồng của bạn. Nếu cần thêm, ${{price, number}} mỗi thành viên tenant mỗi tháng."
                    },
                    "custom_domains": {
                        "title": "Tên miền tuỳ chỉnh",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} cho tối đa 10 tên miền tuỳ chỉnh mỗi tháng. 1 tên miền tuỳ chỉnh đầu tiên miễn phí."
                    },
                    "tokens": {
                        "title": "Token",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi {{tokenLimit}} token. {{basicQuota}} token đầu tiên đã được bao gồm.",
                        "tooltip_for_enterprise": "{{basicQuota}} token đầu tiên đã được bao gồm và dùng miễn phí trong gói theo hợp đồng của bạn. Nếu cần thêm, ${{price, number}} mỗi {{tokenLimit}} token mỗi tháng."
                    },
                    "m2mTokens": {
                        "title": "Token M2M"
                    },
                    "hooks": {
                        "title": "Hook",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi hook. 10 hook đầu tiên đã được bao gồm.",
                        "tooltip_for_enterprise": "{{basicQuota}} hook đầu tiên đã được bao gồm và dùng miễn phí trong gói theo hợp đồng của bạn. Nếu cần thêm, ${{price, number}} mỗi hook mỗi tháng."
                    },
                    "security_features": {
                        "title": "Bảo mật nâng cao",
                        "tooltip": "Tính năng tiện ích bổ sung với giá ${{price, number}}/tháng cho trọn bộ bảo mật nâng cao, bao gồm CAPTCHA, khoá theo định danh, danh sách chặn email, và nhiều hơn nữa."
                    },
                    "saml_applications": {
                        "title": "Ứng dụng SAML",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi ứng dụng SAML mỗi tháng. "
                    },
                    "third_party_applications": {
                        "title": "Ứng dụng bên thứ ba",
                        "tooltip": "Tính năng tiện ích bổ sung có giá ${{price, number}} mỗi ứng dụng mỗi tháng."
                    },
                    "rbacEnabled": {
                        "title": "Vai trò",
                        "tooltip": "Tính năng tiện ích bổ sung với mức phí cố định ${{price, number}} mỗi tháng. Giá không phụ thuộc vào số lượng vai trò toàn cục."
                    },
                    "pricing": {
                        "add_on_changes_in_current_cycle_notice": "Nếu bạn thực hiện bất kỳ thay đổi nào trong chu kỳ thanh toán hiện tại, hoá đơn tiếp theo của bạn có thể cao hơn đôi chút trong tháng đầu sau khi thay đổi. Đó sẽ là giá cơ bản ${{price, number}} cộng với chi phí tiện ích bổ sung cho mức sử dụng chưa lập hoá đơn trong chu kỳ hiện tại và toàn bộ phí cho chu kỳ tiếp theo. <a>Tìm hiểu thêm</a>"
                    }
                },
                "token_usage_notification": {
                    "exceeded": "Bạn đã vượt 100% hạn mức. Người dùng sẽ không thể đăng nhập bình thường nữa. Vui lòng nâng cấp ngay để tránh bất tiện.",
                    "close_to_limit": "Bạn gần đạt hạn mức sử dụng token. Logto sẽ ngừng cấp token nếu mức sử dụng của bạn vượt 100%. Vui lòng nâng cấp gói Free để tránh bất tiện.",
                    "dev_plan_exceeded": "Tenant này đã đạt hạn mức token theo chính sách giới hạn thực thể của Logto."
                }
            },
            "system_limit": {
                "limit_exceeded": "Tenant <planName/> này đã đạt hạn mức {{entity}} theo <a>chính sách thực thể của Logto</a>.",
                "entities": {
                    "application": "ứng dụng",
                    "third_party_application": "ứng dụng bên thứ ba",
                    "scope_per_resource": "quyền trên mỗi API resource",
                    "social_connector": "social connector",
                    "user_role": "vai trò người dùng",
                    "machine_to_machine_role": "vai trò máy-với-máy",
                    "scope_per_role": "quyền trên mỗi vai trò",
                    "hook": "hook",
                    "machine_to_machine": "ứng dụng máy-với-máy",
                    "resource": "API resource",
                    "enterprise_sso": "Enterprise SSO",
                    "tenant_member": "thành viên tenant",
                    "organization": "tổ chức",
                    "saml_application": "ứng dụng SAML",
                    "custom_domain": "tên miền tuỳ chỉnh",
                    "user_per_organization": "người dùng trên mỗi tổ chức",
                    "organization_user_role": "vai trò người dùng của tổ chức",
                    "organization_machine_to_machine_role": "vai trò máy-với-máy của tổ chức",
                    "organization_scope": "quyền của tổ chức"
                }
            },
            "upsell": {
                "upgrade_plan": "Nâng cấp gói",
                "compare_plans": "So sánh các gói",
                "try_with_product_name": "Dùng thử {{productName}} ngay",
                "view_plans": "Xem các gói",
                "create_tenant": {
                    "title": "Chọn gói tenant của bạn",
                    "description": "Logto cung cấp các lựa chọn gói cạnh tranh với mức giá sáng tạo và hợp lý, được thiết kế cho các công ty đang tăng trưởng. <a>Tìm hiểu thêm</a>",
                    "base_price": "Giá cơ bản",
                    "monthly_price": "{{value, number}}/tháng",
                    "view_all_features": "Xem tất cả tính năng",
                    "select_plan": "Chọn <name/>",
                    "free_tenants_limit": "Tối đa {{count, number}} tenant miễn phí",
                    "free_tenants_limit_other": "Tối đa {{count, number}} tenant miễn phí",
                    "most_popular": "Phổ biến nhất",
                    "upgrade_success": "Đã nâng cấp thành công lên <name/>"
                },
                "mau_exceeded_modal": {
                    "title": "MAU đã vượt hạn mức. Hãy nâng cấp gói của bạn.",
                    "notification": "MAU hiện tại của bạn đã vượt hạn mức của <planName/>. Vui lòng nâng cấp gói lên bản cao cấp kịp thời để tránh bị tạm ngưng dịch vụ Logto. ",
                    "update_plan": "Cập nhật gói"
                },
                "token_exceeded_modal": {
                    "title": "Mức sử dụng token đã vượt hạn mức. Hãy nâng cấp gói của bạn.",
                    "notification": "Bạn đã vượt hạn mức sử dụng token của <planName/>. Người dùng sẽ không thể truy cập dịch vụ Logto bình thường. Vui lòng nâng cấp gói lên bản cao cấp kịp thời để tránh mọi bất tiện."
                },
                "payment_overdue_modal": {
                    "title": "Hoá đơn thanh toán quá hạn",
                    "notification": "Rất tiếc! Thanh toán cho hoá đơn của tenant <span>{{name}}</span> đã thất bại. Vui lòng thanh toán hoá đơn kịp thời để tránh bị tạm ngưng dịch vụ Logto.",
                    "unpaid_bills": "Hoá đơn chưa thanh toán",
                    "update_payment": "Cập nhật thanh toán"
                },
                "add_on_quota_item": {
                    "api_resource": "API resource",
                    "machine_to_machine": "ứng dụng máy-với-máy",
                    "tokens": "{{limit}}M token",
                    "tenant_member": "thành viên tenant"
                },
                "charge_notification_for_quota_limit": "Bạn đã vượt hạn mức {{item}}. Logto sẽ tính thêm phí cho phần sử dụng vượt hạn mức của bạn. Việc tính phí sẽ bắt đầu vào ngày biểu giá tiện ích bổ sung mới được công bố. <a>Tìm hiểu thêm</a>",
                "paywall": {
                    "applications": "Đã đạt hạn mức {{count, number}} ứng dụng của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "applications_other": "Đã đạt hạn mức {{count, number}} ứng dụng của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "machine_to_machine_feature": "Chuyển sang gói <strong>Pro</strong> để có thêm ứng dụng máy-với-máy và tận hưởng mọi tính năng cao cấp. <a>Liên hệ</a> nếu bạn có thắc mắc.",
                    "machine_to_machine": "Đã đạt hạn mức {{count, number}} ứng dụng máy-với-máy của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "machine_to_machine_other": "Đã đạt hạn mức {{count, number}} ứng dụng máy-với-máy của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "resources": "Đã đạt hạn mức {{count, number}} API resource của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. <a>Liên hệ</a> nếu cần hỗ trợ.",
                    "resources_other": "Đã đạt hạn mức {{count, number}} API resource của <planName/>. Hãy nâng cấp gói để đáp ứng nhu cầu của nhóm bạn. <a>Liên hệ</a> nếu cần hỗ trợ.",
                    "scopes_per_resource": "Đã đạt hạn mức {{count, number}} quyền trên mỗi API resource của <planName/>. Hãy nâng cấp ngay để mở rộng. <a>Liên hệ</a> nếu cần hỗ trợ.",
                    "scopes_per_resource_other": "Đã đạt hạn mức {{count, number}} quyền trên mỗi API resource của <planName/>. Hãy nâng cấp ngay để mở rộng. <a>Liên hệ</a> nếu cần hỗ trợ.",
                    "custom_domain": "Đã đạt hạn mức {{count, number}} tên miền tuỳ chỉnh của <planName/>. Hãy nâng cấp lên gói trả phí để thêm nhiều tên miền tuỳ chỉnh và các quyền lợi cao cấp. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc.",
                    "custom_domain_others": "Đã đạt hạn mức {{count, number}} tên miền tuỳ chỉnh của <planName/>. Hãy nâng cấp lên gói trả phí để thêm nhiều tên miền tuỳ chỉnh và các quyền lợi cao cấp. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc.",
                    "social_connectors": "Đã đạt hạn mức {{count, number}} social connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp gói để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "social_connectors_other": "Đã đạt hạn mức {{count, number}} social connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp gói để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "standard_connectors_feature": "Nâng cấp lên gói <strong>Hobby</strong> hoặc <strong>Pro</strong> để tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML, cùng với social connector không giới hạn và mọi tính năng cao cấp. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "standard_connectors": "Đã đạt hạn mức {{count, number}} social connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp gói để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "standard_connectors_other": "Đã đạt hạn mức {{count, number}} social connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp gói để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "standard_connectors_pro": "Đã đạt hạn mức {{count, number}} standard connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp lên gói Enterprise để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "standard_connectors_pro_other": "Đã đạt hạn mức {{count, number}} standard connector của <planName/>. Để đáp ứng nhu cầu của nhóm bạn, hãy nâng cấp lên gói Enterprise để có thêm social connector và khả năng tự tạo connector bằng giao thức OIDC, OAuth 2.0 và SAML. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "roles": "Hãy nâng cấp gói để thêm vai trò và quyền. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "scopes_per_role": "Đã đạt hạn mức {{count, number}} quyền trên mỗi vai trò của <planName/>. Hãy nâng cấp gói để thêm vai trò và quyền. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "scopes_per_role_other": "Đã đạt hạn mức {{count, number}} quyền trên mỗi vai trò của <planName/>. Hãy nâng cấp gói để thêm vai trò và quyền. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "saml_applications_oss": "Ứng dụng SAML bổ sung có sẵn trong gói Logto Enterprise. Hãy liên hệ nếu bạn cần hỗ trợ.",
                    "saml_applications_oss_limit_notice": "Phiên bản mã nguồn mở của bạn hỗ trợ tối đa {{limit}} ứng dụng SAML. Bạn có thể dùng Logto Cloud hoặc liên hệ để có thêm lựa chọn.",
                    "logto_pricing_button_text": "Biểu giá Logto Cloud",
                    "saml_applications": "Ứng dụng SAML bổ sung có sẵn trong gói Logto Enterprise. Hãy liên hệ nếu bạn cần hỗ trợ.",
                    "saml_applications_add_on": "Mở khoá tính năng ứng dụng SAML bằng cách nâng cấp lên gói trả phí. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "hooks": "Đã đạt hạn mức {{count, number}} webhook của <planName/>. Hãy nâng cấp gói để tạo thêm webhook. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "hooks_other": "Đã đạt hạn mức {{count, number}} webhook của <planName/>. Hãy nâng cấp gói để tạo thêm webhook. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "mfa": "Mở khoá MFA để tăng bảo mật xác minh bằng cách nâng cấp lên gói trả phí. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "organizations": "Mở khoá tổ chức bằng cách nâng cấp lên gói trả phí. Đừng ngại <a>liên hệ</a> nếu bạn cần hỗ trợ.",
                    "third_party_apps": "Mở khoá Logto làm IdP cho ứng dụng bên thứ ba bằng cách nâng cấp lên gói trả phí. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "sso_connectors": "Mở khoá enterprise SSO bằng cách nâng cấp lên gói trả phí. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "tenant_members": "Mở khoá tính năng cộng tác bằng cách nâng cấp lên gói trả phí. Nếu cần hỗ trợ, đừng ngại <a>liên hệ</a>.",
                    "tenant_members_dev_plan": "Bạn đã đạt hạn mức {{limit}} thành viên. Hãy gỡ một thành viên hoặc thu hồi lời mời đang chờ để thêm người mới. Cần thêm chỗ? Đừng ngại liên hệ với chúng tôi.",
                    "custom_jwt": {
                        "title": "Thêm claim tuỳ chỉnh",
                        "description": "Nâng cấp lên gói trả phí để có chức năng JWT tuỳ chỉnh và các quyền lợi cao cấp. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc."
                    },
                    "branding_customization": "Mở khoá toàn quyền kiểm soát thương hiệu với các tính năng \"Ẩn thương hiệu Logto\" và \"Mang giao diện của bạn\" bằng cách nâng cấp gói.",
                    "bring_your_ui": "Nâng cấp lên gói trả phí để có chức năng mang giao diện tuỳ chỉnh của bạn và các quyền lợi cao cấp.",
                    "security_features": "Mở khoá các tính năng bảo mật nâng cao bằng cách nâng cấp lên gói Pro. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc.",
                    "collect_user_profile": "Nâng cấp lên gói trả phí để thu thập thêm thông tin hồ sơ người dùng trong quá trình đăng ký. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc.",
                    "passkey_sign_in": "Nâng cấp lên gói trả phí để có chức năng đăng nhập bằng passkey và các quyền lợi cao cấp. Đừng ngại <a>liên hệ</a> nếu bạn có thắc mắc."
                },
                "featured_plan_content": {
                    "mau": {
                        "free_plan": "Tối đa {{count, number}} MAU",
                        "pro_plan": "MAU không giới hạn"
                    },
                    "m2m": {
                        "free_plan": "{{count, number}} máy-với-máy",
                        "pro_plan": "Máy-với-máy bổ sung"
                    },
                    "saml_and_third_party_apps": "Ứng dụng SAML & ứng dụng bên thứ ba",
                    "third_party_apps": "IdP cho ứng dụng bên thứ ba",
                    "mfa": "Xác thực đa yếu tố",
                    "sso": "Enterprise SSO",
                    "role_and_permissions": {
                        "free_plan": "{{roleCount, number}} vai trò và {{permissionCount, number}} quyền trên mỗi vai trò",
                        "pro_plan": "Vai trò và quyền trên mỗi vai trò không giới hạn"
                    },
                    "rbac": "Kiểm soát truy cập theo vai trò",
                    "organizations": "Tổ chức",
                    "audit_logs": "Thời gian lưu nhật ký kiểm toán: {{count, number}} ngày"
                },
                "add_on": {
                    "mfa_inline_notification": "MFA là tiện ích bổ sung ${{price, number}}/tháng cho {{planName}}. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                    "security_features_inline_notification": "Bật CAPTCHA, trải nghiệm khoá tài khoản tuỳ chỉnh và các tính năng bảo mật nâng cao khác—tất cả bao gồm trong gói tiện ích bổ sung chỉ với ${{price, number}}/tháng.",
                    "custom_domain": "Mở rộng lên tới 10 tên miền tuỳ chỉnh chỉ với ${{price, number}}. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                    "footer": {
                        "api_resource": "API resource bổ sung có giá <span>${{price, number}}/tháng/cái</span>. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "machine_to_machine_app": "Ứng dụng máy-với-máy bổ sung có giá <span>${{price, number}}/tháng/cái</span>. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "enterprise_sso": "Enterprise SSO có giá <span>${{price, number}}/tháng/cái</span> làm tiện ích bổ sung cho {{planName}}. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "tenant_members": "Thành viên bổ sung có giá <span>${{price, number}}/tháng/cái</span>. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "organization": "Tổ chức là tiện ích bổ sung <span>${{price, number}}/tháng</span> cho {{planName}} với số lượng tổ chức không giới hạn. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "saml_apps": "Ứng dụng SAML bổ sung có giá <span>${{price, number}}/tháng/cái</span>. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "third_party_apps": "Ứng dụng bên thứ ba bổ sung có giá <span>${{price, number}}/tháng/cái</span>. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>",
                        "roles": "Kiểm soát truy cập theo vai trò là tiện ích bổ sung <span>${{price, number}}/tháng</span> cho gói Pro với số lượng vai trò không giới hạn. Tháng đầu được tính theo tỷ lệ dựa trên chu kỳ thanh toán của bạn. <a>Tìm hiểu thêm</a>"
                    }
                },
                "convert_to_production_modal": {
                    "title": "Bạn sắp chuyển tenant phát triển của mình thành tenant sản xuất",
                    "description": "Sẵn sàng vận hành thực tế? Chuyển tenant phát triển này thành tenant sản xuất sẽ mở khoá toàn bộ chức năng",
                    "benefits": {
                        "stable_environment": "Cho người dùng cuối: Một môi trường ổn định để sử dụng thực tế.",
                        "keep_pro_features": "Giữ các tính năng Pro: Bạn sắp đăng ký gói Pro. <a>Xem các tính năng Pro.</a>",
                        "no_dev_restrictions": "Không hạn chế của bản phát triển: Gỡ bỏ giới hạn hệ thống về thực thể và API resource cùng biểu ngữ đăng nhập."
                    },
                    "cards": {
                        "dev_description": "Mục đích kiểm thử",
                        "prod_description": "Sản xuất thực tế",
                        "convert_label": "chuyển đổi"
                    },
                    "button": "Chuyển thành tenant sản xuất"
                }
            },
            "guide": {
                "start_building": "Bắt đầu xây dựng",
                "get_started": "Bắt đầu",
                "categories": {
                    "featured": "Phổ biến và dành cho bạn",
                    "Traditional": "Ứng dụng web truyền thống",
                    "SPA": "Ứng dụng một trang",
                    "Native": "Native",
                    "MachineToMachine": "Máy-với-Máy",
                    "Protected": "Tích hợp không dùng SDK",
                    "ThirdParty": "Ứng dụng bên thứ ba",
                    "SAML": "Ứng dụng SAML"
                },
                "filter": {
                    "title": "Lọc framework",
                    "placeholder": "Tìm framework"
                },
                "checkout_tutorial": "Xem hướng dẫn {{name}}",
                "do_not_need_tutorial": "Nếu bạn không cần hướng dẫn, bạn có thể tiếp tục mà không cần hướng dẫn framework",
                "finish_and_done": "Hoàn tất",
                "cannot_find_guide": "Không tìm thấy hướng dẫn bạn cần?",
                "describe_guide_looking_for": "Mô tả hướng dẫn bạn đang tìm",
                "request_guide_successfully": "Yêu cầu của bạn đã được gửi thành công. Cảm ơn bạn!",
                "app": {
                    "select_framework_or_tutorial": "Chọn một framework hoặc hướng dẫn",
                    "guide_modal_title": "Bắt đầu với SDK và hướng dẫn",
                    "modal_subtitle": "Khởi động quá trình phát triển ứng dụng với SDK và hướng dẫn dựng sẵn của chúng tôi.",
                    "select_a_framework": "Chọn một framework",
                    "continue_without_framework": "Tạo ứng dụng không dùng framework",
                    "describe_guide_looking_for_placeholder": "Ví dụ: Tôi muốn tích hợp Logto vào ứng dụng Angular của mình."
                },
                "api": {
                    "modal_title": "Bắt đầu với hướng dẫn",
                    "modal_subtitle": "Khởi động quá trình phát triển ứng dụng với các hướng dẫn dựng sẵn của chúng tôi.",
                    "select_a_tutorial": "Chọn một hướng dẫn",
                    "continue_without_tutorial": "Tiếp tục mà không cần hướng dẫn",
                    "describe_guide_looking_for_placeholder": "Ví dụ: Tôi muốn bảo vệ API của mình bằng deno."
                }
            },
            "mfa": {
                "title": "Xác thực đa yếu tố",
                "description": "Thêm xác thực đa yếu tố để nâng cao bảo mật cho trải nghiệm đăng nhập của bạn.",
                "factors": "Yếu tố",
                "multi_factors": "Đa yếu tố",
                "multi_factors_description": "Người dùng cần xác minh một trong các yếu tố đã bật để xác thực 2 bước.",
                "totp": "Ứng dụng xác thực",
                "otp_description": "Liên kết Google Authenticator, v.v., để xác minh mật khẩu dùng một lần.",
                "webauthn": "Passkey",
                "webauthn_description": "Xác minh qua phương thức trình duyệt hỗ trợ: sinh trắc học, quét bằng điện thoại, hoặc khoá bảo mật, v.v.",
                "webauthn_domain_tip": "WebAuthn gắn khoá công khai với một tên miền cụ thể. Thay đổi tên miền dịch vụ sẽ khiến người dùng không thể xác thực bằng các passkey hiện có.",
                "backup_code": "Mã dự phòng",
                "backup_code_description": "Tạo 10 mã dự phòng dùng một lần sau khi người dùng thiết lập bất kỳ phương thức MFA nào.",
                "backup_code_setup_hint": "Khi người dùng không thể xác minh các yếu tố MFA ở trên, hãy dùng tùy chọn dự phòng.",
                "backup_code_error_hint": "Để dùng mã dự phòng, bạn cần thêm ít nhất một phương thức MFA nữa để xác thực người dùng thành công.",
                "email_verification_code": "Mã xác minh qua email",
                "email_verification_code_description": "Liên kết địa chỉ email để nhận và xác minh mã xác minh.",
                "phone_verification_code": "Mã xác minh qua SMS",
                "phone_verification_code_description": "Liên kết số điện thoại để nhận và xác minh mã xác minh qua SMS.",
                "policy": "Chính sách",
                "policy_description": "Đặt chính sách MFA cho luồng đăng nhập và đăng ký.",
                "two_step_sign_in_policy": "Chính sách xác thực 2 bước khi đăng nhập",
                "user_controlled": "Người dùng có thể tự bật hoặc tắt MFA",
                "user_controlled_tip": "Người dùng có thể bỏ qua việc thiết lập MFA trong lần đăng nhập hoặc đăng ký đầu tiên, hoặc bật/tắt trong cài đặt tài khoản.",
                "mandatory": "Người dùng luôn bắt buộc dùng MFA khi đăng nhập",
                "mandatory_tip": "Người dùng phải thiết lập MFA trong lần đăng nhập hoặc đăng ký đầu tiên, và dùng nó cho mọi lần đăng nhập sau này.",
                "require_mfa": "Yêu cầu MFA",
                "require_mfa_label": "Bật tùy chọn này để bắt buộc xác thực 2 bước khi truy cập ứng dụng của bạn. Nếu tắt, người dùng có thể tự quyết định có bật MFA hay không.",
                "require_mfa_optional": "MFA tùy chọn: Để người dùng tự chọn bật MFA cho bảo mật tài khoản của họ",
                "require_mfa_adaptive": "MFA thích ứng: Chỉ yêu cầu MFA khi lần đăng nhập có vẻ rủi ro (vd: quốc gia mới / lâu không hoạt động)",
                "require_mfa_mandatory": "MFA bắt buộc: Yêu cầu mọi người dùng hoàn tất MFA mỗi lần đăng nhập",
                "set_up_prompt": "Nhắc thiết lập MFA",
                "no_prompt": "Không nhắc người dùng thiết lập MFA",
                "prompt_at_sign_in_and_sign_up": "Nhắc người dùng thiết lập MFA khi đăng ký (có thể bỏ qua, nhắc một lần)",
                "prompt_only_at_sign_in": "Nhắc người dùng thiết lập MFA ở lần đăng nhập tiếp theo sau khi đăng ký (có thể bỏ qua, nhắc một lần)",
                "prompt_at_sign_in_and_sign_up_mandatory": "Nhắc người dùng thiết lập MFA khi đăng ký (không thể bỏ qua)",
                "prompt_only_at_sign_in_mandatory": "Nhắc người dùng thiết lập MFA ở lần đăng nhập tiếp theo sau khi đăng ký (không thể bỏ qua)",
                "set_up_organization_required_mfa_prompt": "Nhắc thiết lập MFA cho người dùng sau khi tổ chức bật MFA",
                "prompt_at_sign_in_non_skippable": "Nhắc người dùng thiết lập MFA ở lần đăng nhập tiếp theo (không thể bỏ qua)",
                "email_primary_method_tip": "Mã xác minh qua email đã là phương thức đăng nhập chính của bạn. Để đảm bảo bảo mật, nó không thể được dùng lại cho MFA.",
                "phone_primary_method_tip": "Mã xác minh qua SMS đã là phương thức đăng nhập chính của bạn. Để đảm bảo bảo mật, nó không thể được dùng lại cho MFA.",
                "no_email_connector_warning": "Chưa thiết lập trình kết nối Email. Trước khi hoàn tất cấu hình, người dùng sẽ không thể dùng mã xác minh qua email cho MFA. <a>{{link}}</a> trong \"Trình kết nối\".",
                "no_sms_connector_warning": "Chưa thiết lập trình kết nối SMS. Trước khi hoàn tất cấu hình, người dùng sẽ không thể dùng mã xác minh qua SMS cho MFA. <a>{{link}}</a> trong \"Trình kết nối\".",
                "no_email_connector_error": "Không thể bật MFA mã xác minh qua email khi chưa có trình kết nối Email. Vui lòng cấu hình trình kết nối Email trước.",
                "no_sms_connector_error": "Không thể bật MFA mã xác minh qua SMS khi chưa có trình kết nối SMS. Vui lòng cấu hình trình kết nối SMS trước.",
                "setup_link": "Thiết lập"
            },
            "organizations": {
                "organization": "Tổ chức",
                "page_title": "Tổ chức",
                "title": "Tổ chức",
                "subtitle": "Tổ chức thường dùng trong ứng dụng SaaS hoặc đa-tenant, đại diện cho khách hàng của bạn là các nhóm, tổ chức hay cả công ty. Tổ chức là nền tảng cho xác thực và phân quyền B2B.",
                "organization_template": "Mẫu tổ chức",
                "organization_id": "ID tổ chức",
                "members": "Thành viên",
                "machine_to_machine": "Ứng dụng Máy-với-Máy",
                "branding": "Thương hiệu",
                "create_organization": "Tạo tổ chức",
                "setup_organization": "Thiết lập tổ chức của bạn",
                "organization_list_placeholder_title": "Tổ chức",
                "organization_list_placeholder_text": "Tổ chức thường được dùng trong ứng dụng SaaS hoặc đa-tenant như một thực hành tốt. Chúng cho phép bạn phát triển ứng dụng để khách hàng tạo và quản lý tổ chức, mời thành viên và gán vai trò.",
                "organization_name_placeholder": "Tổ chức của tôi",
                "organization_description_placeholder": "Mô tả ngắn về tổ chức",
                "organization_permission": "Quyền tổ chức",
                "organization_permission_other": "Quyền tổ chức",
                "create_permission_placeholder": "Xem lịch sử cuộc hẹn",
                "organization_role": "Vai trò tổ chức",
                "organization_role_other": "Vai trò tổ chức",
                "organization_role_description": "Vai trò tổ chức là nhóm các quyền có thể gán cho người dùng. Các quyền phải đến từ các quyền tổ chức đã định nghĩa trước.",
                "role": "Vai trò",
                "search_placeholder": "Tìm theo tên tổ chức hoặc ID",
                "search_role_placeholder": "Gõ để tìm và chọn vai trò",
                "empty_placeholder": "🤔 Bạn chưa thiết lập {{entity}} nào.",
                "organization_and_member": "Tổ chức và thành viên",
                "organization_and_member_description": "Tổ chức là một nhóm người dùng, có thể đại diện cho đội nhóm, khách hàng doanh nghiệp và công ty đối tác, mỗi người dùng là một \"Thành viên\". Đây là các thực thể nền tảng để xử lý nhu cầu đa-tenant của bạn.",
                "guide": {
                    "title": "Bắt đầu với hướng dẫn",
                    "subtitle": "Khởi động thiết lập tổ chức với các hướng dẫn của chúng tôi",
                    "introduction": {
                        "title": "Cùng hiểu tổ chức hoạt động thế nào trong Logto",
                        "section_1": {
                            "title": "Tổ chức là một nhóm người dùng (danh tính)"
                        },
                        "section_2": {
                            "title": "Mẫu tổ chức được thiết kế cho kiểm soát truy cập ứng dụng đa-tenant",
                            "description": "Trong ứng dụng SaaS đa-tenant, nhiều tổ chức thường dùng chung một mẫu kiểm soát truy cập gồm các quyền và vai trò. Trong Logto, chúng tôi gọi đó là \"mẫu tổ chức\".",
                            "permission_description": "Quyền tổ chức là sự cho phép truy cập một tài nguyên trong ngữ cảnh tổ chức.",
                            "role_description_deprecated": "Vai trò tổ chức là nhóm các quyền tổ chức có thể gán cho thành viên.",
                            "role_description": "Vai trò tổ chức là nhóm các quyền tổ chức hoặc quyền API có thể gán cho thành viên."
                        },
                        "section_3": {
                            "title": "Tôi có thể gán quyền API cho vai trò tổ chức không?",
                            "description": "Có, bạn có thể gán quyền API cho vai trò tổ chức. Logto cho phép quản lý vai trò tổ chức linh hoạt, bao gồm cả quyền tổ chức lẫn quyền API trong các vai trò đó."
                        },
                        "section_4": {
                            "title": "Tương tác với hình minh hoạ để xem mọi thứ kết nối ra sao",
                            "description": "Lấy một ví dụ. John và Sarah ở các tổ chức khác nhau với vai trò khác nhau trong ngữ cảnh từng tổ chức. Di chuột qua các mô-đun khác nhau để xem điều gì xảy ra."
                        }
                    },
                    "organization_permissions": "Quyền tổ chức",
                    "organization_roles": "Vai trò tổ chức",
                    "admin": "Quản trị",
                    "member": "Thành viên",
                    "guest": "Khách",
                    "role_description": "Vai trò \"{{role}}\" dùng chung một mẫu tổ chức trên các tổ chức khác nhau.",
                    "john": "John",
                    "john_tip": "John thuộc hai tổ chức với email \"john@email.com\" là định danh duy nhất. Anh là quản trị của tổ chức A và là khách của tổ chức B.",
                    "sarah": "Sarah",
                    "sarah_tip": "Sarah thuộc một tổ chức với email \"sarah@email.com\" là định danh duy nhất. Cô là quản trị của tổ chức B."
                }
            },
            "oss_onboarding": {
                "page_title": "Thiết lập ban đầu",
                "title": "Đôi chút về bạn",
                "description": "Hãy cho chúng tôi biết đôi chút về bạn và dự án của bạn. Điều này giúp chúng tôi xây dựng Logto tốt hơn cho mọi người.",
                "email": {
                    "label": "Địa chỉ email",
                    "description": "Chúng tôi sẽ dùng địa chỉ này nếu cần liên hệ với bạn về tài khoản của bạn.",
                    "placeholder": "email@example.com"
                },
                "newsletter": "Nhận cập nhật sản phẩm, khuyến cáo bảo mật và nội dung chọn lọc từ Logto.",
                "project": {
                    "label": "Tôi dùng Logto cho",
                    "personal": "Dự án cá nhân",
                    "company": "Dự án công ty"
                },
                "project_name": {
                    "label": "Tên dự án",
                    "placeholder": "Dự án của tôi"
                },
                "company_name": {
                    "label": "Tên công ty",
                    "placeholder": "Acme.co"
                },
                "company_size": {
                    "label": "Quy mô công ty của bạn là bao nhiêu?"
                },
                "errors": {
                    "email_required": "Địa chỉ email là bắt buộc",
                    "email_invalid": "Nhập địa chỉ email hợp lệ",
                    "project_name_too_long": "Tên dự án phải có tối đa 200 ký tự"
                }
            },
            "oidc_configs": {
                "sessions_card_title": "Phiên Logto",
                "sessions_card_description": "Tuỳ chỉnh chính sách phiên được lưu bởi máy chủ cấp quyền Logto. Nó ghi lại trạng thái xác thực toàn cục của người dùng để bật SSO và cho phép tái xác thực ngầm giữa các ứng dụng.",
                "session_max_ttl_in_days": "Thời gian sống tối đa của phiên (TTL) tính bằng ngày",
                "session_max_ttl_in_days_tip": "Giới hạn thời gian tồn tại tuyệt đối kể từ khi tạo phiên. Bất kể có hoạt động hay không, phiên sẽ kết thúc khi hết khoảng thời gian cố định này.",
                "cloud_private_key_rotation_notice": "Trong Logto Cloud, việc luân chuyển khoá riêng có hiệu lực sau thời gian ân hạn 4 giờ."
            },
            "organization_details": {
                "page_title": "Chi tiết tổ chức",
                "delete_confirmation": "Sau khi xoá, tất cả thành viên sẽ mất tư cách thành viên và vai trò trong tổ chức này. Hành động này không thể hoàn tác.",
                "organization_id": "ID tổ chức",
                "settings_description": "Tổ chức đại diện cho các nhóm, khách hàng doanh nghiệp và công ty đối tác có thể truy cập ứng dụng của bạn.",
                "name_placeholder": "Tên của tổ chức, không bắt buộc phải là duy nhất.",
                "description_placeholder": "Mô tả về tổ chức.",
                "member": "Thành viên",
                "member_other": "Thành viên",
                "add_members_to_organization": "Thêm thành viên vào tổ chức {{name}}",
                "add_members_to_organization_description": "Tìm người dùng phù hợp bằng cách tìm theo tên, email, số điện thoại hoặc ID người dùng. Các thành viên hiện có không hiển thị trong kết quả tìm kiếm.",
                "add_with_organization_role": "Thêm kèm vai trò tổ chức",
                "user": "Người dùng",
                "application": "Ứng dụng",
                "application_other": "Ứng dụng",
                "add_applications_to_organization": "Thêm ứng dụng vào tổ chức {{name}}",
                "add_applications_to_organization_description": "Tìm ứng dụng phù hợp bằng cách tìm theo ID ứng dụng, tên hoặc mô tả. Các ứng dụng hiện có không hiển thị trong kết quả tìm kiếm.",
                "at_least_one_application": "Cần ít nhất một ứng dụng.",
                "remove_application_from_organization": "Gỡ ứng dụng khỏi tổ chức",
                "remove_application_from_organization_description": "Sau khi gỡ, ứng dụng sẽ mất liên kết và vai trò trong tổ chức này. Hành động này không thể hoàn tác.",
                "search_application_placeholder": "Tìm theo ID ứng dụng, tên hoặc mô tả",
                "roles": "Vai trò tổ chức",
                "authorize_to_roles": "Cấp quyền cho {{name}} truy cập các vai trò sau:",
                "edit_organization_roles": "Sửa vai trò tổ chức",
                "edit_organization_roles_title": "Sửa vai trò tổ chức của {{name}}",
                "remove_user_from_organization": "Gỡ người dùng khỏi tổ chức",
                "remove_user_from_organization_description": "Sau khi gỡ, người dùng sẽ mất tư cách thành viên và vai trò trong tổ chức này. Hành động này không thể hoàn tác.",
                "search_user_placeholder": "Tìm theo tên, email, số điện thoại hoặc ID người dùng",
                "at_least_one_user": "Cần ít nhất một người dùng.",
                "organization_roles_tooltip": "Các vai trò được gán cho {{type}} trong tổ chức này.",
                "custom_data": "Dữ liệu tuỳ chỉnh",
                "custom_data_tip": "Dữ liệu tuỳ chỉnh là một đối tượng JSON dùng để lưu thêm dữ liệu gắn với tổ chức.",
                "invalid_json_object": "Đối tượng JSON không hợp lệ.",
                "branding": {
                    "name": "Thương hiệu",
                    "description": "Tuỳ chỉnh trải nghiệm đăng nhập ở cấp tổ chức.",
                    "organization_level_sie": "Trải nghiệm đăng nhập cấp tổ chức",
                    "organization_level_sie_switch": "Bật trải nghiệm đăng nhập cấp tổ chức và thiết lập thương hiệu riêng cho tổ chức. Nếu tắt, hệ thống sẽ ưu tiên dùng đăng nhập cấp ứng dụng, sau đó đến trải nghiệm đăng nhập chung.",
                    "logo": "Logo tổ chức",
                    "logo_tooltip": "Bạn có thể truyền ID tổ chức để hiển thị logo này trong trải nghiệm đăng nhập; cần phiên bản logo cho chế độ tối nếu chế độ tối được bật trong cài đặt trải nghiệm đăng nhập chung. <a>Tìm hiểu thêm</a>"
                },
                "jit": {
                    "title": "Cấp phát tức thời (JIT)",
                    "description": "Người dùng có thể tự động tham gia tổ chức và được gán vai trò ngay lần đăng nhập đầu tiên qua một số phương thức xác thực. Bạn có thể đặt các điều kiện cần đáp ứng để cấp phát tức thời.",
                    "email_domain": "Cấp phát theo tên miền email",
                    "email_domain_description": "Người dùng mới đăng ký bằng địa chỉ email đã xác minh hoặc đăng nhập mạng xã hội với email đã xác minh sẽ tự động tham gia tổ chức. <a>Tìm hiểu thêm</a>",
                    "email_domain_placeholder": "Nhập các tên miền email cho cấp phát tức thời",
                    "invalid_domain": "Tên miền không hợp lệ",
                    "domain_already_added": "Tên miền đã được thêm",
                    "sso_enabled_domain_warning": "Bạn đã nhập một hoặc nhiều tên miền email gắn với SSO doanh nghiệp. Người dùng có các email này sẽ đi theo luồng SSO chuẩn và sẽ không được cấp phát vào tổ chức này trừ khi bạn cấu hình cấp phát qua SSO doanh nghiệp.",
                    "enterprise_sso": "Cấp phát qua SSO doanh nghiệp",
                    "no_enterprise_connector_set": "Bạn chưa thiết lập trình kết nối SSO doanh nghiệp nào. Hãy thêm trình kết nối trước để bật cấp phát qua SSO doanh nghiệp. <a>Thiết lập</a>",
                    "add_enterprise_connector": "Thêm trình kết nối doanh nghiệp",
                    "enterprise_sso_description": "Người dùng mới hoặc người dùng hiện có đăng nhập qua SSO doanh nghiệp lần đầu sẽ tự động tham gia tổ chức. <a>Tìm hiểu thêm</a>",
                    "organization_roles": "Vai trò tổ chức mặc định",
                    "organization_roles_description": "Gán vai trò cho người dùng khi họ tham gia tổ chức qua cấp phát tức thời."
                },
                "mfa": {
                    "title": "Xác thực đa yếu tố (MFA)",
                    "tip": "Khi bắt buộc MFA, người dùng chưa cấu hình MFA sẽ bị từ chối khi cố gắng đổi lấy token tổ chức. Cài đặt này không ảnh hưởng đến việc xác thực người dùng.",
                    "description": "Yêu cầu người dùng cấu hình xác thực đa yếu tố để truy cập tổ chức này.",
                    "no_mfa_warning": "Chưa có phương thức xác thực đa yếu tố nào được bật cho tenant của bạn. Người dùng sẽ không thể truy cập tổ chức này cho đến khi có ít nhất một <a>phương thức xác thực đa yếu tố</a> được bật."
                }
            },
            "protected_app": {
                "name": "Ứng dụng được bảo vệ",
                "title": "Tạo Ứng dụng được bảo vệ: Thêm xác thực đơn giản với tốc độ ấn tượng",
                "fast_create": "Tạo nhanh",
                "modal_title": "Tạo Ứng dụng được bảo vệ",
                "modal_subtitle": "Bật bảo vệ an toàn và nhanh chóng chỉ với vài cú nhấp. Thêm xác thực vào ứng dụng web hiện có một cách dễ dàng.",
                "form": {
                    "url_field_label": "URL gốc của bạn",
                    "url_field_placeholder": "https://domain.com/",
                    "url_field_description": "Cung cấp địa chỉ của ứng dụng cần được bảo vệ bằng xác thực.",
                    "url_field_modification_notice": "Việc thay đổi URL gốc có thể mất 1-2 phút để có hiệu lực trên toàn bộ các vị trí mạng toàn cầu.",
                    "url_field_tooltip": "Cung cấp địa chỉ của ứng dụng, không bao gồm bất kỳ '/pathname' nào. Sau khi tạo, bạn có thể tuỳ chỉnh quy tắc xác thực cho từng route.\n\nLưu ý: Bản thân URL gốc không yêu cầu xác thực; việc bảo vệ chỉ áp dụng cho các truy cập qua app domain được chỉ định.",
                    "domain_field_label": "App domain",
                    "domain_field_placeholder": "your-domain",
                    "domain_field_description": "URL này đóng vai trò proxy bảo vệ xác thực cho URL gốc. Có thể áp dụng domain tuỳ chỉnh sau khi tạo.",
                    "domain_field_description_short": "URL này đóng vai trò proxy bảo vệ xác thực cho URL gốc.",
                    "domain_field_tooltip": "Ứng dụng được Logto bảo vệ sẽ được lưu trữ tại 'your-domain.{{domain}}' theo mặc định. Có thể áp dụng domain tuỳ chỉnh sau khi tạo.",
                    "create_application": "Tạo ứng dụng",
                    "create_protected_app": "Tạo nhanh",
                    "errors": {
                        "domain_required": "Domain của bạn là bắt buộc.",
                        "domain_in_use": "Tên subdomain này đã được sử dụng.",
                        "invalid_domain_format": "Định dạng subdomain không hợp lệ: chỉ dùng chữ thường, số và dấu gạch nối '-'.",
                        "url_required": "URL gốc là bắt buộc.",
                        "invalid_url": "Định dạng URL gốc không hợp lệ: Dùng http:// hoặc https://. Lưu ý: hiện chưa hỗ trợ '/pathname'.",
                        "localhost": "Vui lòng đưa máy chủ cục bộ của bạn lên internet trước. Tìm hiểu thêm về <a>phát triển cục bộ</a>."
                    }
                },
                "id_token_claims": {
                    "card_title": "Claim của ID token",
                    "card_description": "Yêu cầu thêm scope người dùng trong quá trình đăng nhập Ứng dụng được bảo vệ để đưa các claim mở rộng đã bật vào ID token được chuyển tiếp.",
                    "field_title": "Scope bổ sung",
                    "field_description": "Claim chỉ được đưa vào khi chúng được bật trong <a>JWT tuỳ chỉnh > ID token</a> và scope tương ứng được yêu cầu tại đây.",
                    "table_column_scope": "Scope",
                    "table_column_claims_forwarded": "Claim được chuyển tiếp",
                    "disabled_claims_hint": "Các claim bị làm mờ chưa được chuyển tiếp. Hãy bật chúng trong <a>JWT tuỳ chỉnh > ID token</a> để đưa vào ID token."
                },
                "success_message": "🎉 Đã bật xác thực cho ứng dụng thành công! Khám phá trải nghiệm mới của website của bạn."
            },
            "jwt_claims": {
                "title": "JWT tuỳ chỉnh",
                "description": "Tuỳ chỉnh access token hoặc ID token, cung cấp thêm thông tin cho ứng dụng của bạn.",
                "access_token": {
                    "card_title": "Access token",
                    "card_description": "Access token là thông tin xác thực mà API dùng để cấp quyền cho các yêu cầu, chỉ chứa những claim cần thiết cho quyết định truy cập."
                },
                "user_jwt": {
                    "card_field": "Access token của người dùng",
                    "card_description": "Thêm dữ liệu riêng của người dùng khi phát hành access token.",
                    "for": "cho người dùng"
                },
                "machine_to_machine_jwt": {
                    "card_field": "Access token Máy-với-Máy",
                    "card_description": "Thêm dữ liệu bổ sung khi phát hành token Máy-với-Máy.",
                    "for": "cho M2M"
                },
                "id_token": {
                    "card_title": "ID token",
                    "card_description": "ID token là một khai báo danh tính nhận được sau khi đăng nhập, chứa các claim danh tính của người dùng để client dùng cho việc hiển thị hoặc tạo phiên.",
                    "card_field": "ID token của người dùng",
                    "card_field_description": "Các claim 'sub', 'email', 'phone', 'profile' và 'address' luôn có sẵn. Các claim khác phải được bật ở đây trước. Trong mọi trường hợp, ứng dụng của bạn phải yêu cầu đúng scope tương ứng khi tích hợp để nhận được chúng."
                },
                "code_editor_title": "Tuỳ chỉnh các claim của {{token}}",
                "custom_jwt_create_button": "Thêm claim tuỳ chỉnh",
                "custom_jwt_item": "Claim tuỳ chỉnh {{for}}",
                "delete_modal_title": "Xoá claim tuỳ chỉnh",
                "delete_modal_content": "Bạn có chắc muốn xoá các claim tuỳ chỉnh không?",
                "clear": "Bắt đầu lại",
                "cleared": "Đã xoá",
                "restore": "Khôi phục mặc định",
                "restored": "Đã khôi phục",
                "data_source_tab": "Nguồn dữ liệu",
                "error_handling_tab": "Xử lý lỗi",
                "test_tab": "Ngữ cảnh kiểm thử",
                "jwt_claims_description": "Các claim mặc định được tự động thêm vào  và không thể ghi đè.",
                "user_data": {
                    "title": "Ngữ cảnh người dùng",
                    "subtitle": "Dùng tham số đầu vào `context.user` để cung cấp thông tin người dùng thiết yếu."
                },
                "grant_data": {
                    "title": "Ngữ cảnh grant",
                    "subtitle": "Dùng tham số đầu vào `context.grant` để cung cấp thông tin grant thiết yếu, chỉ có sẵn khi trao đổi token."
                },
                "interaction_data": {
                    "title": "Ngữ cảnh tương tác người dùng",
                    "subtitle": "Dùng tham số `context.interaction` để truy cập chi tiết tương tác của người dùng cho phiên xác thực hiện tại."
                },
                "application_data": {
                    "title": "Ngữ cảnh ứng dụng",
                    "subtitle": "Dùng tham số đầu vào `context.application` để cung cấp thông tin ứng dụng gắn với token."
                },
                "organization_data": {
                    "title": "Ngữ cảnh tổ chức",
                    "subtitle": "Dùng tham số đầu vào `context.organization` để cung cấp thông tin tổ chức đích, chỉ có sẵn với token tổ chức."
                },
                "token_data": {
                    "title": "Payload của token",
                    "subtitle": "Dùng tham số đầu vào `token` cho payload của access token hiện tại. "
                },
                "api_context": {
                    "title": "Ngữ cảnh API: kiểm soát truy cập",
                    "subtitle": "Dùng phương thức `api.denyAccess` để từ chối yêu cầu token."
                },
                "error_handling": {
                    "title": "Xử lý lỗi",
                    "subtitle": "Kiểm soát việc có nên chặn phát hành token khi script gặp lỗi hay không.",
                    "input_field_title": "Hành vi phát hành token khi script lỗi",
                    "block_issuance_switch": "Chặn phát hành token khi script gặp lỗi",
                    "default_hint_create": "Các script claim tuỳ chỉnh mới mặc định chặn phát hành token khi script lỗi. Nếu API đã cung cấp một giá trị, giá trị đã lưu sẽ được dùng thay thế.",
                    "default_hint_edit": "Các script claim tuỳ chỉnh hiện có mà chưa có thiết lập này sẽ giữ mặc định cũ là tắt cho đến khi bạn lưu một giá trị một cách rõ ràng.",
                    "warning": "Khi bật, lỗi thời gian chạy của script sẽ từ chối yêu cầu token với `invalid_request` (400) và một `error_description` đã bản địa hoá. Các lệnh gọi tới `api.denyAccess` vẫn trả về `access_denied`."
                },
                "fetch_external_data": {
                    "title": "Lấy dữ liệu bên ngoài",
                    "subtitle": "Kết hợp dữ liệu từ các API bên ngoài của bạn trực tiếp vào claim.",
                    "description": "Dùng hàm `fetch` để gọi các API bên ngoài của bạn và đưa dữ liệu vào các claim tuỳ chỉnh. Ví dụ: "
                },
                "environment_variables": {
                    "title": "Đặt biến môi trường",
                    "subtitle": "Dùng biến môi trường để lưu trữ thông tin nhạy cảm.",
                    "input_field_title": "Thêm biến môi trường",
                    "sample_code": "Truy cập biến môi trường trong handler claim token tuỳ chỉnh của bạn. Ví dụ: "
                },
                "jwt_claims_hint": "Giới hạn claim tuỳ chỉnh dưới 50KB. Các claim token mặc định được tự động thêm vào token và không thể ghi đè.",
                "tester": {
                    "subtitle": "Điều chỉnh token giả lập và dữ liệu người dùng để kiểm thử.",
                    "run_button": "Chạy kiểm thử",
                    "result_title": "Kết quả kiểm thử"
                },
                "form_error": {
                    "invalid_json": "Định dạng JSON không hợp lệ"
                }
            },
            "invitation": {
                "find_your_tenants": "Tìm các tenant của bạn",
                "find_tenants_description": "Địa chỉ email của bạn có thể đã được đăng ký với nhiều tenant. Bạn có thể chọn tham gia các tenant hiện có hoặc tiếp tục tạo một tenant mới.",
                "create_new_tenant": "Tạo một tenant mới",
                "email_not_match_title": "Bạn hiện đang đăng nhập với\n{{email}}",
                "email_not_match_description": "Vui lòng đăng nhập bằng đúng tài khoản để chấp nhận lời mời và trở thành thành viên của tổ chức.",
                "switch_account": "Đăng nhập vào tài khoản khác",
                "invalid_invitation_status": "Lời mời không hợp lệ. Vui lòng liên hệ quản trị viên và thử lại.",
                "invitation_not_found": "Không tìm thấy lời mời. Vui lòng liên hệ quản trị viên."
            },
            "signing_keys": {
                "title": "Khoá ký",
                "description": "Quản lý an toàn các khoá ký được ứng dụng của bạn sử dụng.",
                "private_key": "OIDC private keys",
                "private_keys_description": "OIDC private keys được dùng để ký các JWT token.",
                "cookie_key": "OIDC cookie keys",
                "cookie_keys_description": "OIDC cookie keys được dùng để ký cookie.",
                "private_keys_in_use": "Private key đang dùng",
                "cookie_keys_in_use": "Cookie key đang dùng",
                "rotate_private_keys": "Xoay vòng private key",
                "rotate_cookie_keys": "Xoay vòng cookie key",
                "rotate_private_keys_description": "Hành động này sẽ tạo một private signing key mới, xoay vòng khoá hiện tại và xoá khoá trước đó. Các JWT token đã ký bằng khoá hiện tại vẫn còn hiệu lực cho đến khi bị xoá hoặc đến lượt xoay vòng tiếp theo.",
                "rotate_cookie_keys_description": "Hành động này sẽ tạo một cookie key mới, xoay vòng khoá hiện tại và xoá khoá trước đó. Các cookie dùng khoá hiện tại vẫn còn hiệu lực cho đến khi bị xoá hoặc đến lượt xoay vòng tiếp theo.",
                "select_private_key_algorithm": "Chọn thuật toán khoá ký cho private key mới",
                "rotate_button": "Xoay vòng",
                "table_column": {
                    "id": "ID",
                    "status": "Trạng thái",
                    "algorithm": "Thuật toán khoá ký",
                    "effective_at": "Có hiệu lực lúc"
                },
                "status": {
                    "next": "Kế tiếp",
                    "current": "Hiện tại",
                    "previous": "Trước đó",
                    "effective_in": "Có hiệu lực sau {{time}}"
                },
                "reminder": {
                    "rotate_private_key": "Bạn có chắc muốn xoay vòng <strong>OIDC private keys</strong> không? Các JWT token mới cấp sẽ được ký bằng khoá mới. Các JWT token hiện có vẫn còn hiệu lực cho đến khi bạn xoay vòng lần nữa.",
                    "rotate_cookie_key": "Bạn có chắc muốn xoay vòng <strong>OIDC cookie keys</strong> không? Các cookie mới tạo trong phiên đăng nhập sẽ được ký bằng cookie key mới. Các cookie hiện có vẫn còn hiệu lực cho đến khi bạn xoay vòng lần nữa.",
                    "delete_private_key": "Bạn có chắc muốn xoá <strong>OIDC private key</strong> không? Các JWT token hiện có đã ký bằng private signing key này sẽ không còn hiệu lực.",
                    "delete_cookie_key": "Bạn có chắc muốn xoá <strong>OIDC cookie key</strong> không? Các phiên đăng nhập cũ có cookie ký bằng cookie key này sẽ không còn hiệu lực. Những người dùng này cần xác thực lại."
                },
                "messages": {
                    "rotate_key_success": "Đã xoay vòng khoá ký thành công.",
                    "delete_key_success": "Đã xoá khoá thành công."
                }
            },
            "organization_template": {
                "title": "Mẫu tổ chức",
                "subtitle": "Trong các ứng dụng SaaS đa tổ chức (multi-tenant), mẫu tổ chức xác định các chính sách kiểm soát truy cập dùng chung (quyền và vai trò) cho nhiều tổ chức.",
                "roles": {
                    "tab_name": "Vai trò tổ chức",
                    "search_placeholder": "Tìm theo tên vai trò",
                    "create_title": "Tạo vai trò tổ chức",
                    "role_column": "Vai trò tổ chức",
                    "permissions_column": "Quyền",
                    "placeholder_title": "Vai trò tổ chức",
                    "placeholder_description": "Vai trò tổ chức là một nhóm quyền có thể gán cho người dùng. Các quyền này phải lấy từ những quyền tổ chức đã định nghĩa sẵn.",
                    "create_modal": {
                        "title": "Tạo vai trò tổ chức",
                        "create": "Tạo vai trò",
                        "name": "Tên vai trò",
                        "description": "Mô tả",
                        "type": "Loại vai trò",
                        "created": "Vai trò tổ chức {{name}} đã được tạo thành công."
                    }
                },
                "permissions": {
                    "tab_name": "Quyền tổ chức",
                    "search_placeholder": "Tìm theo tên quyền",
                    "create_org_permission": "Tạo quyền tổ chức",
                    "permission_column": "Quyền tổ chức",
                    "description_column": "Mô tả",
                    "placeholder_title": "Quyền tổ chức",
                    "placeholder_description": "Quyền tổ chức là sự cho phép truy cập một tài nguyên trong phạm vi của tổ chức.",
                    "delete_confirm": "Nếu quyền này bị xoá, mọi vai trò tổ chức có chứa quyền này sẽ mất quyền đó, và những người dùng từng có quyền này sẽ mất quyền truy cập do nó cấp.",
                    "create_title": "Tạo quyền tổ chức",
                    "edit_title": "Sửa quyền tổ chức",
                    "permission_field_name": "Tên quyền",
                    "description_field_name": "Mô tả",
                    "description_field_placeholder": "Xem lịch sử cuộc hẹn",
                    "create_permission": "Tạo quyền",
                    "created": "Quyền tổ chức {{name}} đã được tạo thành công."
                }
            },
            "organization_role_details": {
                "page_title": "Chi tiết vai trò tổ chức",
                "back_to_org_roles": "Quay lại Vai trò tổ chức",
                "delete_confirm": "Làm vậy sẽ gỡ các quyền gắn với vai trò này khỏi những người dùng bị ảnh hưởng và xoá các liên kết giữa vai trò tổ chức, thành viên trong tổ chức, và quyền tổ chức.",
                "deleted": "Vai trò tổ chức {{name}} đã được xoá thành công.",
                "permissions": {
                    "tab": "Quyền",
                    "name_column": "Quyền",
                    "description_column": "Mô tả",
                    "type_column": "Loại quyền",
                    "type": {
                        "api": "Quyền API",
                        "org": "Quyền tổ chức"
                    },
                    "assign_permissions": "Gán quyền",
                    "remove_permission": "Xoá quyền",
                    "remove_confirmation": "Nếu quyền này bị xoá, người dùng có vai trò tổ chức này sẽ mất quyền truy cập được cấp bởi nó.",
                    "removed": "Quyền {{name}} đã được xoá thành công khỏi vai trò tổ chức này",
                    "assign_description": "Gán quyền cho các vai trò trong tổ chức này. Các quyền này có thể bao gồm cả quyền tổ chức và quyền API.",
                    "organization_permissions": "Quyền tổ chức",
                    "api_permissions": "Quyền API",
                    "assign_organization_permissions": "Gán quyền tổ chức",
                    "assign_api_permissions": "Gán quyền API"
                },
                "general": {
                    "tab": "Chung",
                    "settings": "Cài đặt",
                    "description": "Vai trò tổ chức là một nhóm quyền có thể gán cho người dùng. Các quyền có thể đến từ quyền tổ chức định sẵn và quyền API.",
                    "name_field": "Tên",
                    "description_field": "Mô tả",
                    "description_field_placeholder": "Người dùng chỉ có quyền xem"
                }
            },
            "inkeep_ai_bot": {
                "intro_message": "Chào bạn, tôi là Logto AI!\n\nTôi là trợ lý AI được huấn luyện trên tài liệu, bài viết trợ giúp và các nội dung khác.\n\nHãy hỏi tôi bất cứ điều gì về `Logto`.",
                "chat_placeholder": "Hỏi Logto AI câu hỏi của bạn để nhận hướng dẫn từng bước",
                "disclaimer_label": "Tuyên bố miễn trừ của Logto AI",
                "disclaimer_tooltip": "Câu trả lời do AI tạo ra và có thể cần được kiểm chứng.",
                "example_questions_label": "Câu hỏi mẫu",
                "example_questions": [
                    "Hướng dẫn nhanh để thiết lập Logto",
                    "Cấu hình kiến trúc đa tenant",
                    "Làm sao để tích hợp hồ sơ người dùng?"
                ],
                "stop": "Dừng",
                "clear": "Bắt đầu lại",
                "get_help": "Nhận hỗ trợ",
                "copy_chat": "Sao chép",
                "ask_ai_label": "Hỏi AI",
                "contact": "Liên hệ",
                "discord": "Discord"
            },
            "user_identity_details": {
                "social_identity_page_title": "Chi tiết danh tính mạng xã hội",
                "back_to_user_details": "Quay lại chi tiết người dùng",
                "delete_identity": "Gỡ liên kết danh tính",
                "social_account": {
                    "title": "Tài khoản mạng xã hội",
                    "description": "Xem dữ liệu người dùng và thông tin hồ sơ được đồng bộ từ tài khoản {{connectorName}} đã liên kết.",
                    "provider_name": "Tên nhà cung cấp danh tính mạng xã hội",
                    "identity_id": "ID danh tính mạng xã hội",
                    "user_profile": "Hồ sơ người dùng đồng bộ từ nhà cung cấp danh tính mạng xã hội"
                },
                "sso_account": {
                    "title": "Tài khoản SSO doanh nghiệp",
                    "description": "Xem dữ liệu người dùng và thông tin hồ sơ được đồng bộ từ tài khoản {{connectorName}} đã liên kết.",
                    "provider_name": "Tên nhà cung cấp danh tính SSO doanh nghiệp",
                    "identity_id": "ID danh tính SSO doanh nghiệp",
                    "user_profile": "Hồ sơ người dùng đồng bộ từ nhà cung cấp danh tính SSO doanh nghiệp"
                },
                "token_storage": {
                    "title": "Access token",
                    "description": "Lưu access token và refresh token từ {{connectorName}} vào Secret Vault. Cho phép gọi API tự động mà không cần người dùng đồng ý lại nhiều lần."
                },
                "access_token": {
                    "title": "Access token",
                    "description_active": "Access token đang hoạt động và được lưu an toàn trong Secret Vault. Sản phẩm của bạn có thể dùng nó để truy cập các API của {{connectorName}}.",
                    "description_inactive": "Access token này không hoạt động (ví dụ: đã bị thu hồi). Người dùng phải cấp quyền truy cập lại để khôi phục chức năng.",
                    "description_expired": "Access token này đã hết hạn. Việc gia hạn sẽ diễn ra tự động ở lần gọi API tiếp theo bằng refresh token. Nếu không có refresh token, người dùng cần xác thực lại."
                },
                "refresh_token": {
                    "available": "Refresh token khả dụng. Nếu access token hết hạn, nó sẽ được làm mới tự động bằng refresh token.",
                    "not_available": "Refresh token không khả dụng. Sau khi access token hết hạn, người dùng phải xác thực lại để lấy token mới."
                },
                "token_status": "Trạng thái token",
                "created_at": "Tạo lúc",
                "updated_at": "Cập nhật lúc",
                "expires_at": "Hết hạn lúc",
                "scopes": "Scope",
                "delete_tokens": {
                    "title": "Xoá token",
                    "description": "Xoá các token đã lưu. Người dùng phải cấp quyền truy cập lại để khôi phục chức năng.",
                    "confirmation_message": "Bạn có chắc muốn xoá các token không? Logto Secret Vault sẽ xoá access token và refresh token của {{connectorName}} đã lưu. Người dùng này phải cấp quyền lại để khôi phục quyền truy cập API {{connectorName}}."
                },
                "token_storage_disabled": {
                    "title": "Lưu trữ token đang tắt cho trình kết nối này",
                    "description": "Hiện tại người dùng chỉ có thể dùng {{connectorName}} để đăng nhập, liên kết tài khoản hoặc đồng bộ hồ sơ trong mỗi luồng đồng ý. Để truy cập các API của {{connectorName}} và thực hiện hành động thay mặt người dùng, vui lòng bật lưu trữ token trong"
                }
            },
            "enterprise_subscription": {
                "page_title": "Gói đăng ký",
                "title": "Quản lý gói đăng ký của bạn",
                "subtitle": "Đây là nơi quản lý gói đăng ký đa tenant và lịch sử thanh toán của bạn",
                "tab": {
                    "subscription": "Gói đăng ký",
                    "billing_history": "Lịch sử thanh toán"
                },
                "subscription": {
                    "title": "Gói đăng ký",
                    "description": "Dễ dàng theo dõi mức sử dụng, xem hoá đơn kế tiếp và xem lại hợp đồng gốc của bạn.",
                    "enterprise_plan_title": "Gói Enterprise",
                    "enterprise_plan_description": "Đây là gói đăng ký Enterprise của bạn và hạn mức này được chia sẻ giữa các tenant. Mức sử dụng có thể cập nhật hơi chậm một chút. ",
                    "add_on_title": "Tiện ích bổ sung trả theo mức dùng",
                    "add_on_description": "Đây là các tiện ích bổ sung trả theo mức dùng dựa trên hợp đồng của bạn hoặc theo biểu giá trả theo mức dùng tiêu chuẩn của Logto. Bạn sẽ được tính phí theo mức sử dụng thực tế.",
                    "included": "Đã bao gồm",
                    "over_quota": "Vượt hạn mức",
                    "basic_plan_column_title": {
                        "product": "Sản phẩm",
                        "usage": "Mức sử dụng",
                        "quota": "Hạn mức"
                    },
                    "add_on_column_title": {
                        "product": "Sản phẩm",
                        "unit_price": "Đơn giá",
                        "quantity": "Số lượng",
                        "total_price": "Tổng"
                    },
                    "add_on_sku_price": "${{price}}/tháng",
                    "private_region_title": "Phiên bản đám mây riêng ({{regionName}})",
                    "shared_cross_tenants": "Giữa các tenant"
                }
            }
        },
        "demo_app": {
            "title": "Bạn đã đăng nhập thành công vào bản xem thử trực tiếp!",
            "subtitle": "Đây là thông tin người dùng của bạn:",
            "username": "Tên đăng nhập: ",
            "user_id": "ID người dùng: ",
            "sign_out": "Đăng xuất khỏi bản xem thử",
            "continue_explore": "Hoặc tiếp tục khám phá",
            "customize_sign_in_experience": "Tuỳ chỉnh trải nghiệm đăng nhập",
            "enable_passwordless": "Bật đăng nhập không mật khẩu",
            "add_social_connector": "Thêm trình kết nối mạng xã hội"
        },
        "oidc": {
            "logout_success": "Bạn đã đăng xuất thành công."
        }
    },
    "errors": {
        "request": {
            "invalid_input": "Dữ liệu nhập không hợp lệ. {{details}}",
            "general": "Đã xảy ra lỗi yêu cầu.",
            "range_not_satisfiable": "Không thể đáp ứng khoảng (range) yêu cầu.",
            "feature_not_supported": "Tính năng này không được hỗ trợ trong môi trường hiện tại.",
            "rate_limited": "Quá nhiều yêu cầu. Vui lòng thử lại sau.",
            "message_rate_limited": "Đã gửi quá nhiều tin nhắn đến người nhận này. Vui lòng thử lại sau."
        },
        "auth": {
            "authorization_header_missing": "Thiếu header Authorization.",
            "authorization_token_type_not_supported": "Loại Authorization không được hỗ trợ.",
            "unauthorized": "Không có quyền truy cập. Vui lòng kiểm tra thông tin xác thực và phạm vi (scope) của nó.",
            "forbidden": "Bị cấm truy cập. Vui lòng kiểm tra vai trò và quyền của người dùng.",
            "expected_role_not_found": "Không tìm thấy vai trò mong đợi. Vui lòng kiểm tra vai trò và quyền của người dùng.",
            "jwt_sub_missing": "Thiếu `sub` trong JWT.",
            "require_re_authentication": "Cần xác thực lại để thực hiện thao tác được bảo vệ.",
            "exceed_token_limit": "Đã vượt giới hạn token. Vui lòng liên hệ quản trị viên."
        },
        "guard": {
            "invalid_input": "Yêu cầu {{type}} không hợp lệ.",
            "invalid_pagination": "Giá trị phân trang của yêu cầu không hợp lệ.",
            "can_not_get_tenant_id": "Không thể lấy tenant id từ yêu cầu.",
            "file_size_exceeded": "Kích thước tệp vượt quá giới hạn.",
            "mime_type_not_allowed": "Không cho phép loại MIME này.",
            "not_allowed_for_admin_tenant": "Không được phép với tenant quản trị."
        },
        "oidc": {
            "aborted": "Người dùng cuối đã huỷ tương tác.",
            "invalid_scope": "Scope không hợp lệ: {{error_description}}.",
            "invalid_token": "Token được cung cấp không hợp lệ.",
            "invalid_client_metadata": "Client metadata được cung cấp không hợp lệ.",
            "insufficient_scope": "Token thiếu scope `{{scope}}`.",
            "invalid_request": "Yêu cầu không hợp lệ.",
            "invalid_grant": "Yêu cầu grant không hợp lệ.",
            "invalid_issuer": "Issuer không hợp lệ.",
            "invalid_redirect_uri": "`redirect_uri` không khớp với bất kỳ `redirect_uris` nào đã đăng ký của client.",
            "access_denied": "Truy cập bị từ chối.",
            "invalid_target": "Chỉ báo tài nguyên (resource indicator) không hợp lệ.",
            "unsupported_grant_type": "`grant_type` được yêu cầu không được hỗ trợ.",
            "unsupported_response_mode": "`response_mode` được yêu cầu không được hỗ trợ.",
            "unsupported_response_type": "`response_type` được yêu cầu không được hỗ trợ.",
            "provider_error": "Lỗi nội bộ OIDC: {{message}}.",
            "server_error": "Đã xảy ra lỗi OIDC không xác định. Vui lòng thử lại sau.",
            "provider_error_fallback": "Đã xảy ra lỗi OIDC: {{code}}.",
            "custom_claims_script_error": "Lỗi script custom claims: {{error_description}}",
            "key_required": "Cần ít nhất một khoá.",
            "key_not_found": "Không tìm thấy khoá có ID {{id}}.",
            "only_previous_key_can_be_deleted": "Chỉ có thể xoá khoá trước đó (previous key).",
            "invalid_session_payload": "Payload phiên không hợp lệ.",
            "session_not_found": "Không tìm thấy phiên.",
            "invalid_session_account_id": "accountId của phiên không khớp.",
            "failed_to_revoke_grant": "Không thể thu hồi grant.",
            "failed_to_cleanup_session_authorization": "Không thể dọn dẹp phân quyền của phiên."
        },
        "user": {
            "username_already_in_use": "Tên đăng nhập này đã được sử dụng.",
            "username_starts_with_number": "Tên đăng nhập không được bắt đầu bằng số.",
            "username_invalid_charset_hard": "Tên đăng nhập chỉ được chứa chữ cái, số và dấu gạch dưới.",
            "username_too_short": "Tên đăng nhập quá ngắn.",
            "username_too_long": "Tên đăng nhập quá dài.",
            "username_uppercase_not_allowed": "Tên đăng nhập không được chứa chữ in hoa.",
            "username_lowercase_not_allowed": "Tên đăng nhập không được chứa chữ thường.",
            "username_numbers_not_allowed": "Tên đăng nhập không được chứa số.",
            "username_underscore_not_allowed": "Tên đăng nhập không được chứa dấu gạch dưới.",
            "email_already_in_use": "Email này đã gắn với một tài khoản hiện có.",
            "phone_already_in_use": "Số điện thoại này đã gắn với một tài khoản hiện có.",
            "invalid_email": "Địa chỉ email không hợp lệ.",
            "invalid_phone": "Số điện thoại không hợp lệ.",
            "email_not_exist": "Địa chỉ email này chưa được đăng ký.",
            "phone_not_exist": "Số điện thoại này chưa được đăng ký.",
            "identity_not_exist": "Tài khoản mạng xã hội này chưa được đăng ký.",
            "sso_identity_not_exist": "Tài khoản SSO doanh nghiệp này chưa được đăng ký.",
            "identity_already_in_use": "Tài khoản mạng xã hội này đã được gắn với một tài khoản hiện có.",
            "social_account_exists_in_profile": "Bạn đã gắn tài khoản mạng xã hội này rồi.",
            "cannot_delete_self": "Bạn không thể tự xoá chính mình.",
            "sign_up_method_not_enabled": "Phương thức đăng ký này chưa được bật.",
            "sign_in_method_not_enabled": "Phương thức đăng nhập này chưa được bật.",
            "same_password": "Mật khẩu mới không được trùng với mật khẩu cũ.",
            "password_required_in_profile": "Bạn cần đặt mật khẩu trước khi đăng nhập.",
            "new_password_required_in_profile": "Bạn cần đặt mật khẩu mới.",
            "password_exists_in_profile": "Hồ sơ của bạn đã có mật khẩu.",
            "username_required_in_profile": "Bạn cần đặt tên đăng nhập trước khi đăng nhập.",
            "username_exists_in_profile": "Hồ sơ của bạn đã có tên đăng nhập.",
            "email_required_in_profile": "Bạn cần thêm địa chỉ email trước khi đăng nhập.",
            "email_exists_in_profile": "Hồ sơ của bạn đã gắn với một địa chỉ email.",
            "phone_required_in_profile": "Bạn cần thêm số điện thoại trước khi đăng nhập.",
            "phone_exists_in_profile": "Hồ sơ của bạn đã gắn với một số điện thoại.",
            "email_or_phone_required_in_profile": "Bạn cần thêm địa chỉ email hoặc số điện thoại trước khi đăng nhập.",
            "suspended": "Tài khoản này đã bị tạm ngưng.",
            "user_not_exist": "Người dùng với {{ identifier }} không tồn tại.",
            "missing_profile": "Bạn cần cung cấp thêm thông tin trước khi đăng nhập.",
            "role_exists": "Vai trò có id {{roleId}} đã được thêm vào người dùng này",
            "invalid_role_type": "Loại vai trò không hợp lệ, không thể gán vai trò Máy-với-Máy cho người dùng.",
            "suggest_mfa": "Để tài khoản an toàn hơn, chúng tôi khuyến nghị bạn gắn MFA vào tài khoản.",
            "missing_mfa": "Bạn cần gắn thêm MFA trước khi đăng nhập.",
            "totp_already_in_use": "TOTP đã được sử dụng.",
            "backup_code_already_in_use": "Mã dự phòng đã được sử dụng.",
            "password_algorithm_required": "Cần có thuật toán mật khẩu.",
            "password_and_digest": "Bạn không thể đặt cả mật khẩu dạng văn bản thuần và password digest.",
            "personal_access_token_name_exists": "Tên personal access token đã tồn tại.",
            "totp_secret_invalid": "TOTP secret được cung cấp không hợp lệ.",
            "wrong_backup_code_format": "Định dạng mã dự phòng không hợp lệ.",
            "username_required": "Tên đăng nhập là định danh bắt buộc, bạn không thể đặt nó thành null.",
            "email_or_phone_required": "Địa chỉ email hoặc số điện thoại là định danh bắt buộc, cần có ít nhất một.",
            "last_sign_in_method_required": "Bạn cần giữ lại ít nhất một định danh trong tài khoản.",
            "email_required": "Địa chỉ email là định danh bắt buộc, bạn không thể đặt nó thành null.",
            "phone_required": "Số điện thoại là định danh bắt buộc, bạn không thể đặt nó thành null.",
            "enterprise_sso_identity_not_exists": "Người dùng không có định danh doanh nghiệp nào được liên kết với trình kết nối SSO có ID: {{ ssoConnectorId }}.",
            "identity_not_exists_in_current_user": "Định danh được chỉ định không tồn tại trong tài khoản người dùng hiện tại. Vui lòng liên kết định danh trước khi tiếp tục.",
            "passkey_preferred": "Tạo passkey để đơn giản hoá quá trình đăng nhập của bạn."
        },
        "password": {
            "unsupported_encryption_method": "Phương thức mã hoá {{name}} không được hỗ trợ.",
            "pepper_not_found": "Không tìm thấy password pepper. Vui lòng kiểm tra các biến môi trường core của bạn.",
            "rejected": "Mật khẩu bị từ chối. Vui lòng kiểm tra xem mật khẩu có đáp ứng yêu cầu không.",
            "invalid_legacy_password_format": "Định dạng mật khẩu cũ (legacy) không hợp lệ.",
            "unsupported_legacy_hash_algorithm": "Thuật toán hash cũ không được hỗ trợ: {{algorithm}}.",
            "expired": "Mật khẩu của bạn đã hết hạn. Vui lòng đặt lại mật khẩu để tiếp tục."
        },
        "session": {
            "not_found": "Không tìm thấy phiên. Vui lòng quay lại và đăng nhập lại.",
            "invalid_credentials": "Tài khoản hoặc mật khẩu không đúng. Vui lòng kiểm tra lại thông tin nhập.",
            "invalid_sign_in_method": "Phương thức đăng nhập hiện tại không khả dụng.",
            "invalid_connector_id": "Không tìm thấy trình kết nối khả dụng có id {{connectorId}}.",
            "insufficient_info": "Thông tin đăng nhập chưa đủ.",
            "connector_id_mismatch": "connectorId không khớp với bản ghi phiên.",
            "connector_session_not_found": "Không tìm thấy phiên trình kết nối. Vui lòng quay lại và đăng nhập lại.",
            "verification_session_not_found": "Xác minh không thành công. Hãy khởi động lại luồng xác minh và thử lại.",
            "verification_expired": "Kết nối đã hết thời gian chờ. Hãy xác minh lại để đảm bảo an toàn cho tài khoản.",
            "verification_blocked_too_many_attempts": "Quá nhiều lần thử trong thời gian ngắn. Vui lòng thử lại {{relativeTime}}.",
            "unauthorized": "Vui lòng đăng nhập trước.",
            "unsupported_prompt_name": "Tên prompt không được hỗ trợ.",
            "forgot_password_not_enabled": "Chức năng quên mật khẩu chưa được bật.",
            "verification_failed": "Xác minh không thành công. Hãy khởi động lại luồng xác minh và thử lại.",
            "connector_validation_session_not_found": "Không tìm thấy phiên trình kết nối để xác thực token.",
            "csrf_token_mismatch": "CSRF token không khớp.",
            "identifier_not_found": "Không tìm thấy định danh người dùng. Vui lòng quay lại và đăng nhập lại.",
            "interaction_not_found": "Không tìm thấy phiên tương tác. Vui lòng quay lại và bắt đầu lại phiên.",
            "invalid_interaction_type": "Thao tác này không được hỗ trợ với tương tác hiện tại. Vui lòng khởi tạo một phiên mới.",
            "not_supported_for_forgot_password": "Thao tác này không được hỗ trợ cho chức năng quên mật khẩu.",
            "identity_conflict": "Phát hiện định danh không khớp. Vui lòng khởi tạo một phiên mới để tiếp tục với định danh khác.",
            "identifier_not_verified": "Định danh {{identifier}} được cung cấp chưa được xác minh. Vui lòng tạo bản ghi xác minh cho định danh này và hoàn tất quá trình xác minh.",
            "mfa": {
                "require_mfa_verification": "Cần xác minh MFA để đăng nhập.",
                "mfa_sign_in_only": "MFA chỉ khả dụng cho tương tác đăng nhập.",
                "pending_info_not_found": "Không tìm thấy thông tin MFA đang chờ, vui lòng khởi tạo MFA trước.",
                "invalid_totp_code": "Mã TOTP không hợp lệ.",
                "webauthn_verification_failed": "Xác minh WebAuthn thất bại.",
                "webauthn_verification_not_found": "Không tìm thấy xác minh WebAuthn.",
                "bind_mfa_existed": "MFA đã tồn tại.",
                "backup_code_can_not_be_alone": "Mã dự phòng không thể là MFA duy nhất.",
                "backup_code_required": "Cần có mã dự phòng.",
                "invalid_backup_code": "Mã dự phòng không hợp lệ.",
                "mfa_policy_not_user_controlled": "Chính sách MFA không do người dùng kiểm soát.",
                "mfa_factor_not_enabled": "Yếu tố MFA chưa được bật.",
                "suggest_additional_mfa": "Để bảo vệ mạnh hơn, hãy cân nhắc thêm một phương thức MFA khác. Bạn có thể bỏ qua bước này và tiếp tục."
            },
            "passkey_sign_in": {
                "pending_info_not_found": "Không tìm thấy thông tin đăng nhập bằng passkey đang chờ. Vui lòng khởi động lại luồng đăng nhập.",
                "conflict_rp_id": "Relying Party ID không khớp. Vui lòng sử dụng đúng client để đăng nhập.",
                "sso_users_not_allowed": "Tuỳ chọn đăng nhập bằng passkey không áp dụng cho người dùng SSO."
            },
            "password_expiration": {
                "reset_not_allowed": "Chỉ được phép đặt lại mật khẩu sau khi mật khẩu đã hết hạn trong phiên đăng nhập hiện tại."
            },
            "sso_enabled": "Đăng nhập một lần (SSO) đã được bật cho email này. Vui lòng đăng nhập bằng SSO.",
            "captcha_required": "Cần có Captcha.",
            "captcha_failed": "Xác minh Captcha thất bại.",
            "email_blocklist": {
                "disposable_email_validation_failed": "Xác thực địa chỉ email thất bại.",
                "invalid_email": "Địa chỉ email không hợp lệ.",
                "email_subaddressing_not_allowed": "Không cho phép email subaddressing.",
                "email_not_allowed": "Địa chỉ email \"{{email}}\" bị hạn chế. Vui lòng chọn địa chỉ khác."
            },
            "google_one_tap": {
                "cookie_mismatch": "Cookie Google One Tap không khớp.",
                "invalid_id_token": "Google ID Token không hợp lệ.",
                "unverified_email": "Email chưa được xác minh."
            }
        },
        "connector": {
            "general": "Đã xảy ra lỗi ở trình kết nối: {{errorDescription}}",
            "not_found": "Không tìm thấy trình kết nối khả dụng nào cho loại: {{type}}.",
            "not_enabled": "Trình kết nối chưa được bật.",
            "invalid_metadata": "Metadata của trình kết nối không hợp lệ.",
            "invalid_config_guard": "Config guard của trình kết nối không hợp lệ.",
            "unexpected_type": "Loại của trình kết nối không như mong đợi.",
            "invalid_request_parameters": "Yêu cầu có (các) tham số nhập sai.",
            "insufficient_request_parameters": "Yêu cầu có thể thiếu một số tham số nhập.",
            "invalid_config": "Cấu hình của trình kết nối không hợp lệ.",
            "invalid_certificate": "Chứng chỉ của trình kết nối không hợp lệ, vui lòng đảm bảo chứng chỉ ở dạng mã hoá PEM.",
            "invalid_response": "Phản hồi của trình kết nối không hợp lệ.",
            "template_not_found": "Không tìm thấy template phù hợp trong cấu hình trình kết nối.",
            "template_not_supported": "Trình kết nối không hỗ trợ loại template này.",
            "rate_limit_exceeded": "Đã chạm giới hạn tần suất. Vui lòng thử lại sau.",
            "not_implemented": "{{method}}: chưa được triển khai.",
            "social_invalid_access_token": "Access token của trình kết nối không hợp lệ.",
            "invalid_auth_code": "Auth code của trình kết nối không hợp lệ.",
            "social_invalid_id_token": "Id token của trình kết nối không hợp lệ.",
            "authorization_failed": "Quá trình cấp quyền của người dùng không thành công.",
            "social_auth_code_invalid": "Không thể lấy access token, vui lòng kiểm tra mã cấp quyền (authorization code).",
            "more_than_one_sms": "Số lượng trình kết nối SMS lớn hơn 1.",
            "more_than_one_email": "Số lượng trình kết nối Email lớn hơn 1.",
            "more_than_one_connector_factory": "Tìm thấy nhiều connector factory (với id {{connectorIds}}), bạn có thể gỡ bỏ những cái không cần thiết.",
            "db_connector_type_mismatch": "Có một trình kết nối trong cơ sở dữ liệu không khớp với loại.",
            "not_found_with_connector_id": "Không tìm thấy trình kết nối với standard connector id đã cho.",
            "multiple_instances_not_supported": "Không thể tạo nhiều instance với trình kết nối chuẩn đã chọn.",
            "invalid_type_for_syncing_profile": "Bạn chỉ có thể đồng bộ hồ sơ người dùng với trình kết nối mạng xã hội.",
            "can_not_modify_target": "Không thể sửa 'target' của trình kết nối.",
            "should_specify_target": "Bạn cần chỉ định 'target'.",
            "multiple_target_with_same_platform": "Bạn không thể có nhiều trình kết nối mạng xã hội có cùng target và platform.",
            "cannot_overwrite_metadata_for_non_standard_connector": "Không thể ghi đè 'metadata' của trình kết nối này.",
            "email_connector": {
                "bulk_deletion_no_filter": "Phải cung cấp ít nhất một điều kiện lọc để thực hiện xoá hàng loạt theo thuộc tính. Các thuộc tính được hỗ trợ là: {{properties, list(type:conjunction)}}."
            },
            "token_storage_not_supported": "Trình kết nối này không hỗ trợ lưu trữ token. "
        },
        "verification_code": {
            "phone_email_empty": "Cả số điện thoại và email đều trống.",
            "not_found": "Không tìm thấy mã xác minh. Vui lòng gửi mã xác minh trước.",
            "phone_mismatch": "Số điện thoại không khớp. Vui lòng yêu cầu mã xác minh mới.",
            "email_mismatch": "Email không khớp. Vui lòng yêu cầu mã xác minh mới.",
            "code_mismatch": "Mã xác minh không hợp lệ.",
            "expired": "Mã xác minh đã hết hạn. Vui lòng yêu cầu mã xác minh mới.",
            "exceed_max_try": "Đã vượt giới hạn số lần thử mã xác minh. Vui lòng yêu cầu mã xác minh mới."
        },
        "sign_in_experiences": {
            "empty_content_url_of_terms_of_use": "URL nội dung \"Điều khoản sử dụng\" đang trống. Vui lòng thêm URL nội dung nếu \"Điều khoản sử dụng\" được bật.",
            "empty_social_connectors": "Chưa có trình kết nối mạng xã hội. Vui lòng thêm các trình kết nối mạng xã hội đã bật khi phương thức đăng nhập mạng xã hội được bật.",
            "enabled_connector_not_found": "Không tìm thấy trình kết nối {{type}} đã bật.",
            "not_one_and_only_one_primary_sign_in_method": "Phải có một và chỉ một phương thức đăng nhập chính. Vui lòng kiểm tra thông tin nhập của bạn.",
            "username_requires_password": "Phải bật đặt mật khẩu cho định danh đăng ký bằng tên đăng nhập.",
            "passwordless_requires_verify": "Phải bật xác minh cho định danh đăng ký bằng email/số điện thoại.",
            "miss_sign_up_identifier_in_sign_in": "Các phương thức đăng nhập phải chứa định danh đăng ký.",
            "password_sign_in_must_be_enabled": "Phải bật đăng nhập bằng mật khẩu khi bắt buộc đặt mật khẩu lúc đăng ký.",
            "code_sign_in_must_be_enabled": "Phải bật đăng nhập bằng mã xác minh khi không bắt buộc đặt mật khẩu lúc đăng ký.",
            "unsupported_default_language": "Ngôn ngữ này - {{language}} hiện chưa được hỗ trợ.",
            "at_least_one_authentication_factor": "Bạn phải chọn ít nhất một yếu tố xác thực.",
            "backup_code_cannot_be_enabled_alone": "Không thể bật mã dự phòng một mình.",
            "duplicated_mfa_factors": "Trùng lặp các yếu tố MFA.",
            "email_verification_code_cannot_be_used_for_mfa": "Không thể dùng mã xác minh email cho MFA khi xác minh email đã được bật cho đăng nhập.",
            "phone_verification_code_cannot_be_used_for_mfa": "Không thể dùng mã xác minh SMS cho MFA khi xác minh SMS đã được bật cho đăng nhập.",
            "email_verification_code_cannot_be_used_for_sign_in": "Không thể dùng mã xác minh email cho đăng nhập khi nó đã được bật cho MFA.",
            "phone_verification_code_cannot_be_used_for_sign_in": "Không thể dùng mã xác minh SMS cho đăng nhập khi nó đã được bật cho MFA.",
            "adaptive_mfa_requires_mfa": "Phải bật MFA trước khi bật MFA thích ứng (adaptive MFA).",
            "adaptive_mfa_requires_non_skippable_policy": "MFA thích ứng yêu cầu chính sách nhắc MFA không thể bỏ qua. Hãy dùng PromptOnlyAtSignInMandatory hoặc PromptAtSignInAndSignUpMandatory.",
            "non_adaptive_mfa_requires_skippable_policy": "Khi MFA thích ứng bị tắt, chính sách nhắc MFA phải có thể bỏ qua. Không dùng PromptOnlyAtSignInMandatory hoặc PromptAtSignInAndSignUpMandatory.",
            "duplicated_sign_up_identifiers": "Phát hiện định danh đăng ký trùng lặp.",
            "missing_sign_up_identifiers": "Định danh đăng ký chính không được để trống.",
            "invalid_custom_email_blocklist_format": "Các mục danh sách chặn email tuỳ chỉnh không hợp lệ: {{items, list(type:conjunction)}}. Mỗi mục phải là một địa chỉ email hoặc tên miền email hợp lệ, ví dụ: foo@example.com hoặc @example.com.",
            "forgot_password_method_requires_connector": "Phương thức quên mật khẩu yêu cầu phải cấu hình trình kết nối {{method}} tương ứng.",
            "password_expiration_requires_forgot_password": "Hết hạn mật khẩu yêu cầu ít nhất một phương thức quên mật khẩu với trình kết nối hợp lệ.",
            "password_expiration_not_enabled": "Chính sách hết hạn mật khẩu chưa được bật. Hãy bật nó trong cài đặt trải nghiệm đăng nhập trước khi cho mật khẩu hết hạn.",
            "password_expiration_invalid_period_days": "Số ngày của kỳ hạn hợp lệ phải là số nguyên dương khi bật hết hạn mật khẩu.",
            "username_policy_case_conflicts_exist": "Không thể chuyển sang tên đăng nhập không phân biệt chữ hoa/thường khi còn tồn tại các tên đăng nhập chỉ khác nhau về chữ hoa/thường. Hãy giải quyết các xung đột và thử lại."
        },
        "inline_hook": {
            "general": "Đã xảy ra lỗi khi chạy inline hook. Vui lòng thử lại sau."
        },
        "jwt_customizer": {
            "general": "Đã xảy ra lỗi khi tuỳ chỉnh claims của token. Vui lòng thử lại sau.",
            "can_not_create_for_admin_tenant": "Không thể tạo trình tuỳ chỉnh token cho tenant quản trị."
        },
        "localization": {
            "cannot_delete_default_language": "{{languageTag}} đang được đặt làm ngôn ngữ mặc định của bạn và không thể xoá.",
            "invalid_translation_structure": "Cấu trúc dữ liệu (schema) không hợp lệ. Vui lòng kiểm tra thông tin nhập và thử lại."
        },
        "swagger": {
            "invalid_zod_type": "Loại Zod không hợp lệ. Vui lòng kiểm tra cấu hình route guard.",
            "not_supported_zod_type_for_params": "Loại Zod không được hỗ trợ cho các tham số. Vui lòng kiểm tra cấu hình route guard."
        },
        "entity": {
            "invalid_input": "Dữ liệu nhập không hợp lệ. Danh sách giá trị không được để trống.",
            "value_too_long": "Độ dài của giá trị quá dài và vượt quá giới hạn.",
            "create_failed": "Không thể tạo {{name}}.",
            "db_constraint_violated": "Vi phạm ràng buộc cơ sở dữ liệu.",
            "not_exists": "{{name}} không tồn tại.",
            "not_exists_with_id": "{{name}} với ID `{{id}}` không tồn tại.",
            "not_found": "Tài nguyên không tồn tại.",
            "relation_foreign_key_not_found": "Không tìm thấy một hoặc nhiều khoá ngoại. Vui lòng kiểm tra dữ liệu nhập và đảm bảo tất cả các thực thể được tham chiếu đều tồn tại.",
            "unique_integrity_violation": "Thực thể đã tồn tại. Vui lòng kiểm tra dữ liệu nhập và thử lại."
        },
        "log": {
            "invalid_type": "Loại nhật ký không hợp lệ.",
            "invalid_time_window": "`end_time` phải sau `start_time`."
        },
        "role": {
            "name_in_use": "Tên vai trò {{name}} này đã được sử dụng",
            "scope_exists": "Scope id {{scopeId}} đã được thêm vào vai trò này",
            "management_api_scopes_not_assignable_to_user_role": "Không thể gán scope của Management API cho vai trò người dùng.",
            "user_exists": "User id {{userId}} đã được thêm vào vai trò này",
            "application_exists": "Application id {{applicationId}} đã được thêm vào vai trò này",
            "default_role_missing": "Một số roleNames mặc định không tồn tại trong cơ sở dữ liệu, vui lòng đảm bảo tạo các vai trò trước",
            "internal_role_violation": "Có thể bạn đang cố cập nhật hoặc xoá một vai trò nội bộ, điều này bị Logto cấm. Nếu bạn đang tạo vai trò mới, hãy thử một tên khác không bắt đầu bằng \"#internal:\"."
        },
        "scope": {
            "name_exists": "Tên scope {{name}} đã được sử dụng",
            "name_with_space": "Tên của scope không được chứa khoảng trắng."
        },
        "storage": {
            "not_configured": "Nhà cung cấp lưu trữ (storage provider) chưa được cấu hình.",
            "missing_parameter": "Thiếu tham số {{parameter}} cho nhà cung cấp lưu trữ.",
            "upload_error": "Không thể tải tệp lên nhà cung cấp lưu trữ.",
            "download_error": "Không thể tải tệp xuống từ nhà cung cấp lưu trữ."
        },
        "resource": {
            "resource_identifier_in_use": "Định danh API {{indicator}} đã được sử dụng",
            "cannot_delete_management_api": "Không thể xoá Logto Management API.",
            "cannot_modify_management_api": "Không thể sửa Logto Management API."
        },
        "hook": {
            "missing_events": "Bạn cần cung cấp ít nhất một sự kiện.",
            "send_test_payload_failed": "Không thể gửi payload thử nghiệm: {{message}}",
            "endpoint_responded_with_error": "Endpoint phản hồi với lỗi."
        },
        "domain": {
            "not_configured": "Nhà cung cấp hostname miền chưa được cấu hình.",
            "cloudflare_data_missing": "Thiếu cloudflare_data, vui lòng kiểm tra.",
            "cloudflare_unknown_error": "Gặp lỗi không xác định khi gọi Cloudflare API",
            "cloudflare_response_error": "Nhận được phản hồi không mong muốn từ Cloudflare.",
            "limit_to_one_domain": "Bạn chỉ có thể có một miền tuỳ chỉnh.",
            "hostname_already_exists": "Miền này đã tồn tại trên máy chủ của chúng tôi.",
            "cloudflare_not_found": "Không tìm thấy hostname trong Cloudflare",
            "domain_is_not_allowed": "Miền này không được phép.",
            "domain_in_use": "Miền {{domain}} đã được sử dụng",
            "exceed_domain_limit": "Bạn có thể có tối đa {{limit}} miền tuỳ chỉnh."
        },
        "subscription": {
            "limit_exceeded": "Bạn đã đạt đến giới hạn của gói dịch vụ.",
            "get_plan_failed": "Không thể lấy gói dịch vụ cho tenant.",
            "tenant_suspended": "Tenant đã bị tạm ngưng. Vui lòng liên hệ quản trị viên."
        },
        "system_limit": {
            "limit_exceeded": "Bạn đã đạt đến giới hạn hệ thống. Vui lòng liên hệ bộ phận hỗ trợ để được trợ giúp."
        },
        "application": {
            "invalid_type": "Chỉ ứng dụng Máy-với-Máy mới có thể gắn với các vai trò.",
            "role_exists": "Vai trò có id {{roleId}} đã được thêm vào ứng dụng này.",
            "invalid_role_type": "Không thể gán vai trò loại người dùng cho ứng dụng Máy-với-Máy.",
            "invalid_third_party_application_type": "Chỉ các ứng dụng web truyền thống, một trang (single-page) và native mới có thể được đánh dấu là ứng dụng bên thứ ba.",
            "third_party_application_only": "Tính năng này chỉ khả dụng cho các ứng dụng bên thứ ba.",
            "third_party_application_cannot_enable_token_exchange": "Ứng dụng bên thứ ba không được phép bật token exchange.",
            "user_consent_scopes_not_found": "Các scope đồng thuận của người dùng không hợp lệ.",
            "consent_management_api_scopes_not_allowed": "Không cho phép các scope của Management API.",
            "device_flow_native_only": "Device flow chỉ khả dụng cho các ứng dụng native.",
            "device_flow_not_changeable": "Không thể thay đổi device flow sau khi tạo ứng dụng.",
            "protected_app_metadata_is_required": "Cần có metadata của ứng dụng được bảo vệ.",
            "protected_app_not_configured": "Nhà cung cấp ứng dụng được bảo vệ chưa được cấu hình. Tính năng này không khả dụng cho phiên bản mã nguồn mở.",
            "cloudflare_unknown_error": "Gặp lỗi không xác định khi gọi Cloudflare API",
            "protected_application_only": "Tính năng này chỉ khả dụng cho các ứng dụng được bảo vệ.",
            "protected_application_misconfigured": "Ứng dụng được bảo vệ bị cấu hình sai.",
            "protected_application_subdomain_exists": "Subdomain của ứng dụng được bảo vệ đã được sử dụng.",
            "invalid_subdomain": "Subdomain không hợp lệ.",
            "custom_domain_not_found": "Không tìm thấy miền tuỳ chỉnh.",
            "should_delete_custom_domains_first": "Cần xoá các miền tuỳ chỉnh trước.",
            "no_legacy_secret_found": "Ứng dụng không có secret cũ (legacy secret).",
            "secret_name_exists": "Tên secret đã tồn tại.",
            "sync_application_secret_failed": "Đồng bộ secret của ứng dụng thất bại.",
            "saml": {
                "use_saml_app_api": "Dùng API `[METHOD] /saml-applications(/.*)?` để thao tác với ứng dụng SAML.",
                "saml_application_only": "API này chỉ khả dụng cho các ứng dụng SAML.",
                "reach_oss_limit": "Bạn KHÔNG THỂ tạo thêm ứng dụng SAML vì đã chạm giới hạn {{limit}}.",
                "acs_url_binding_not_supported": "Chỉ hỗ trợ binding HTTP-POST để nhận SAML assertion.",
                "acs_url_scheme_not_supported": "Chỉ hỗ trợ scheme HTTP và HTTPS cho URL Assertion Consumer Service.",
                "can_not_delete_active_secret": "Không thể xoá secret đang hoạt động.",
                "no_active_secret": "Không tìm thấy secret đang hoạt động.",
                "entity_id_required": "Cần có Entity ID để tạo metadata.",
                "name_id_format_required": "Cần có định dạng Name ID.",
                "unsupported_name_id_format": "Định dạng Name ID không được hỗ trợ.",
                "missing_email_address": "Người dùng không có địa chỉ email.",
                "email_address_unverified": "Địa chỉ email của người dùng chưa được xác minh.",
                "invalid_certificate_pem_format": "Định dạng chứng chỉ PEM không hợp lệ",
                "acs_url_required": "Cần có URL Assertion Consumer Service.",
                "private_key_required": "Cần có khoá riêng (private key).",
                "certificate_required": "Cần có chứng chỉ.",
                "invalid_saml_request": "Yêu cầu xác thực SAML không hợp lệ.",
                "auth_request_issuer_not_match": "Issuer của yêu cầu xác thực SAML không khớp với entity ID của nhà cung cấp dịch vụ.",
                "sp_initiated_saml_sso_session_not_found_in_cookies": "Không tìm thấy ID phiên SAML SSO do nhà cung cấp dịch vụ khởi tạo trong cookie.",
                "sp_initiated_saml_sso_session_not_found": "Không tìm thấy phiên SAML SSO do nhà cung cấp dịch vụ khởi tạo.",
                "state_mismatch": "`state` không khớp."
            }
        },
        "organization": {
            "require_membership": "Người dùng phải là thành viên của tổ chức để tiếp tục.",
            "role_names_not_found": "Phát hiện tên vai trò không hợp lệ: {{names,list(type:conjunction)}}. Vui lòng tạo các vai trò này trước khi tiếp tục."
        },
        "single_sign_on": {
            "forbidden_domains": "Không cho phép các tên miền email công cộng.",
            "duplicated_domains": "Có các tên miền trùng lặp.",
            "invalid_domain_format": "Định dạng tên miền không hợp lệ.",
            "duplicate_connector_name": "Tên trình kết nối đã tồn tại. Vui lòng chọn tên khác.",
            "idp_initiated_authentication_not_supported": "Xác thực do IdP khởi tạo chỉ được hỗ trợ riêng cho các trình kết nối SAML.",
            "idp_initiated_authentication_invalid_application_type": "Loại ứng dụng không hợp lệ. Chỉ cho phép các ứng dụng {{type}}.",
            "idp_initiated_authentication_redirect_uri_not_registered": "redirect_uri chưa được đăng ký. Vui lòng kiểm tra cài đặt ứng dụng.",
            "idp_initiated_authentication_client_callback_uri_not_found": "Không tìm thấy URI callback xác thực do IdP khởi tạo của client. Vui lòng kiểm tra cài đặt trình kết nối."
        },
        "verification_record": {
            "not_found": "Không tìm thấy bản ghi xác minh.",
            "permission_denied": "Quyền bị từ chối, vui lòng xác thực lại.",
            "not_supported_for_google_one_tap": "API này không hỗ trợ Google One Tap.",
            "social_verification": {
                "invalid_target": "Bản ghi xác minh không hợp lệ. Mong đợi {{expected}} nhưng nhận được {{actual}}.",
                "token_response_not_found": "Không tìm thấy phản hồi token. Vui lòng kiểm tra xem tính năng lưu trữ token có được hỗ trợ và bật cho trình kết nối mạng xã hội không."
            }
        },
        "account_center": {
            "not_enabled": "Trung tâm tài khoản chưa được bật.",
            "field_not_editable": "Trường không thể chỉnh sửa.",
            "field_not_enabled": "Trường chưa được bật."
        },
        "one_time_token": {
            "token_not_found": "Không tìm thấy token {{token}}.",
            "email_mismatch": "Email không khớp với token đã cho.",
            "token_expired": "Token đã hết hạn.",
            "token_consumed": "Token đã được sử dụng.",
            "token_revoked": "Token đã bị thu hồi.",
            "cannot_reactivate_token": "Không thể kích hoạt lại token."
        },
        "custom_profile_fields": {
            "entity_not_exists_with_names": "Không tìm thấy thực thể với các tên đã cho: {{names}}",
            "invalid_min_max_input": "Giá trị min và max nhập vào không hợp lệ.",
            "invalid_default_value": "Giá trị mặc định không hợp lệ.",
            "invalid_options": "Tuỳ chọn của trường không hợp lệ.",
            "invalid_regex_format": "Định dạng regex không hợp lệ.",
            "invalid_address_components": "Các thành phần địa chỉ không hợp lệ.",
            "invalid_fullname_components": "Các thành phần họ tên không hợp lệ.",
            "invalid_sub_component_type": "Loại thành phần con không hợp lệ.",
            "name_exists": "Đã tồn tại một trường với tên đã cho.",
            "conflicted_sie_order": "Giá trị thứ tự trường bị xung đột cho Trải nghiệm đăng nhập.",
            "invalid_name": "Tên trường không hợp lệ, chỉ cho phép chữ cái hoặc số, phân biệt chữ hoa/thường.",
            "name_conflict_sign_in_identifier": "Tên trường không hợp lệ. (Các) khoá định danh đăng nhập đã được đặt trước: {{name}}.",
            "name_conflict_built_in_prop": "Tên trường không hợp lệ. (Các) tên thuộc tính hồ sơ người dùng tích hợp sẵn đã được đặt trước: {{name}}.",
            "name_conflict_custom_data": "Tên trường không hợp lệ. (Các) khoá custom data đã được đặt trước: {{name}}.",
            "name_required": "Tên trường là bắt buộc."
        },
        "secrets": {
            "third_party_token_set": {
                "token_not_found": "Không tìm thấy bản ghi token.",
                "access_token_expired": "Access token đã hết hạn. Vui lòng kết nối lại tài khoản của bạn."
            }
        }
    }
};
export default viVN;
